/* ================= DASHBOARD ================= */
function renderDashboard() {
    /* §2: bara de sesiuni live face parte din dashboard. Fără linia asta, sesiunile
       existau în `state.liveSessions` după login, dar nimeni nu le DESENA — reapăreau
       abia când un eveniment realtime (o sesiune nouă) declanșa o redesenare, și
       atunci apăreau toate deodată. Datele erau acolo; lipsea randarea. */
    try { if (typeof renderLiveSessionsBar === 'function') renderLiveSessionsBar(); } catch (e) { logError('renderDashboard', e); }
    const totalGames = state.games.length;
    const _msrc = (typeof _membersSrc === 'function') ? _membersSrc() : ((state.membersById && Object.keys(state.membersById).length) ? state.membersById : (state.members || {}));
    const activePlayers = Object.values(_msrc).filter(m => !m.hidden).length;
    const totalPoints = Object.values(_msrc).reduce((sum, m) => sum + (m.score || 0), 0);
    
    // FIX: Calculate average score correctly
    const totalScoredGames = state.games.reduce((count, game) => {
        return count + (Object.keys(game.scores || {}).length > 0 ? 1 : 0);
    }, 0);
    const avgScore = totalScoredGames > 0 ? (totalPoints / totalScoredGames).toFixed(2) : 0;
    
    // Sesiuni în ultimele 30 de zile (stat mai utilă decât media pe joc)
    const _30ago = Date.now() - 30 * 24 * 60 * 60 * 1000;
    const sessions30 = state.games.filter(g => { const t = new Date(g.timestamp || g.date).getTime(); return t && t >= _30ago; }).length;
    
    // Update stats
    document.getElementById('stat-total-games').textContent = totalGames;
    document.getElementById('stat-active-players').textContent = activePlayers;
    document.getElementById('stat-avg-score').textContent = sessions30;
    /* RO: Eticheta sezonului e text liber (max 40 de caractere), nu un an de 4 cifre.
           La dimensiunea fixă din `.stat-value` (până la 2.8em) un text lung ieșea din
           chenar și era tăiat de `overflow:hidden` — utilizatorul vedea „Paranghe" în
           loc de „Paranghelie", fără niciun semn că lipsește ceva.
           Scalăm după lungime și lăsăm textul să se înfășoare; cifrele anului rămân
           exact la dimensiunea de până acum.
       EN: the season label is free text; scale it down by length so long labels wrap
           instead of being silently clipped. */
    const _seasonEl = document.getElementById('stat-season');
    const _seasonTxt = String(state.seasonLabel || state.currentSeason || '');
    _seasonEl.textContent = _seasonTxt;
    _seasonEl.classList.remove('stat-value-md', 'stat-value-sm');
    if (_seasonTxt.length > 12) _seasonEl.classList.add('stat-value-sm');
    else if (_seasonTxt.length > 6) _seasonEl.classList.add('stat-value-md');
    _seasonEl.title = _seasonTxt;   /* textul complet la hover, orice s-ar întâmpla */
    const _sl = document.getElementById('seasonLabelInput'); if (_sl && document.activeElement !== _sl) _sl.value = state.seasonLabel || '';
    const sp = document.getElementById('stat-season-progress');
    if (sp) sp.textContent = t('dash.month') + ' ' + (state.seasonMonth || (new Date().getMonth() + 1)) + '/12 · ' + (state.seasonYear || new Date().getFullYear());
    
    // Calculate changes
    const lastWeekGames = state.games.filter(g => {
        const gameDate = new Date(g.timestamp);
        const weekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
        return gameDate > weekAgo;
    }).length;
    
    const gamesChange = totalGames > 0 ? ((lastWeekGames / totalGames) * 100).toFixed(0) : 0;
    document.getElementById('stat-games-change').textContent = `+${gamesChange}%`;
    document.getElementById('stat-games-change').className = `stat-change ${gamesChange > 0 ? 'positive' : 'negative'}`;
    
    // Render leaderboard
    renderLeaderboard();
    
    // Render performance chart
    renderPerformanceChart();
    
    // Render recent activity
    renderRecentActivity();

    // Anunțuri (stil WhatsApp) — randează din state, apoi reîmprospătează din DB
    try { if (typeof renderAnnouncements === 'function') renderAnnouncements(); } catch (e) { logError('renderDashboard', e); }
    try {
        if (typeof loadAnnouncements === 'function') loadAnnouncements().then(function () {
            try { if (typeof renderAnnouncements === 'function' && currentTab === 'dashboard') renderAnnouncements(); } catch (e) { logError('renderDashboard', e); }
        });
    } catch (e) { logError('renderDashboard', e); }
    try { if (typeof renderDashboardEvent === 'function') renderDashboardEvent(); } catch (e) { logError('renderDashboard', e); }
}

/* Mod de VIZUALIZARE a coloanei de puncte din clasament (doar afișare, §18 —
   sursa de adevăr rămâne club_members.points): 'club' = puncte de club (implicit),
   'raw' = suma scorurilor brute din meciuri (fără amicale). */
window._lbPtsView = window._lbPtsView || 'club';
function setLbPtsView(mode) {
    window._lbPtsView = (mode === 'raw') ? 'raw' : 'club';
    renderLeaderboard();
}
window.setLbPtsView = setLbPtsView;

function renderLeaderboard() {
    const tbody = document.getElementById('leaderboardBody');
    tbody.innerHTML = '';

    const sortedPlayers = getSortedPlayers();
    const LB_TOP = 5;
    const avatarFn = (typeof avatarHtml === 'function') ? avatarHtml : null;

    /* RO: Fără uniformizare activă în club, forțăm vederea pe „Scoruri" și ascundem
           comutatorul (vezi `clubUniformScoringOn`). NU atingem `window._lbPtsView`:
           preferința utilizatorului se păstrează pentru cluburile unde comutatorul
           chiar are sens, altfel comutarea unui club ar rescrie alegerea din altul. */
    const _uniOn = (typeof clubUniformScoringOn === 'function') ? clubUniformScoringOn() : true;
    const lbMode = (!_uniOn || window._lbPtsView === 'raw') ? 'raw' : 'club';
    /* Totaluri de scor brut per jucător (fără amicale, §12.d) — DOAR pentru afișare. */
    const rawTotals = {};
    if (lbMode === 'raw') {
        (state.games || []).forEach(g => {
            if (g.friendly || (g.meta && g.meta.friendly)) return;
            Object.keys(g.scores || {}).forEach(pid => {
                rawTotals[pid] = (rawTotals[pid] || 0) + (Number(g.scores[pid]) || 0);
            });
        });
    }
    const displayVal = p => lbMode === 'raw' ? (rawTotals[p.dbId] || 0) : (Number(p.score) || 0);
    /* În modul „scoruri" reordonăm DOAR vizual după metrica afișată; clasamentul
       oficial (puncte de club) nu se atinge. */
    const playersView = lbMode === 'raw'
        ? sortedPlayers.slice().sort((a, b) => displayVal(b) - displayVal(a))
        : sortedPlayers;

    /* Header dinamic (Puncte/Scoruri) + comutator — pattern pf-scope (§11). */
    const th = document.getElementById('lbPointsTh');
    if (th) {
        const k = lbMode === 'raw' ? 'stats.scoresH' : 'stats.points';
        th.setAttribute('data-i18n', k);
        th.textContent = t(k);
    }
    const tg = document.getElementById('lbViewToggle');
    if (tg && !_uniOn) tg.innerHTML = '';
    else if (tg) tg.innerHTML = `<div class="pf-scope-toggle" role="group" style="margin-bottom:10px;">
            <button type="button" class="pf-scope-btn${lbMode === 'club' ? ' active' : ''}" aria-pressed="${lbMode === 'club'}" data-pl-act="lb-view" data-mode="club"><i class="fas fa-coins"></i> ${t('stats.points')}</button>
            <button type="button" class="pf-scope-btn${lbMode === 'raw' ? ' active' : ''}" aria-pressed="${lbMode === 'raw'}" data-pl-act="lb-view" data-mode="raw"><i class="fas fa-list-ol"></i> ${t('stats.scoresH')}</button>
        </div>`;

    playersView.forEach((player, index) => {
        const gamesPlayed = player.gamesPlayed || 0;
        const shown = displayVal(player);
        const avgScore = gamesPlayed > 0 ? (shown / gamesPlayed).toFixed(2) : '0.00';
        const wins = countWins(player.dbId);
        const winRate = gamesPlayed > 0 ? ((wins / gamesPlayed) * 100).toFixed(0) : '0';
        const trend = calculateTrend(player.dbId);
        const trendIcon = trend > 0 ? '📈' : trend < 0 ? '📉' : '➡️';
        const trendClass = trend > 0 ? 'positive' : trend < 0 ? 'negative' : '';

        const tr = document.createElement('tr');
        if (index === 0) tr.classList.add('rank-1');
        if (index === 1) tr.classList.add('rank-2');
        if (index === 2) tr.classList.add('rank-3');
        if (index >= LB_TOP && !lbExpanded) tr.classList.add('lb-extra-hidden');

        const medal = index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : '';
        const av = avatarFn ? avatarFn(player.avatar, 26) : '';

        tr.innerHTML = `
            <td>${medal} ${index + 1}</td>
            <td style="text-align: left;">
                <span class="lb-name"><span class="lb-avatar">${av}</span><strong class="lb-name-link" data-pl-act="lb-profile" data-id="${window.escHtml(player.dbId || player.name)}">${window.escHtml(player.name)}</strong></span>
            </td>
            <td><strong>${lbMode === 'raw' ? shown.toFixed(1) : shown.toFixed(2)}</strong></td>
            <td>${gamesPlayed}</td>
            <td>${avgScore}</td>
            <td>${winRate}%</td>
            <td class="${trendClass}">${trendIcon}</td>
        `;

        tbody.appendChild(tr);
    });

    // Buton „afișează mai mult" după top 5
    const moreBox = document.getElementById('leaderboardMore');
    if (moreBox) {
        const extra = sortedPlayers.length - LB_TOP;
        if (extra <= 0) {
            moreBox.innerHTML = '';
        } else if (lbExpanded) {
            moreBox.innerHTML = '<button type="button" class="btn btn-sm btn-secondary players-more-btn" data-pl-act="lb-more"><i class="fas fa-chevron-up"></i> ' + t('players.showLess') + '</button>';
        } else {
            moreBox.innerHTML = '<button type="button" class="btn btn-sm btn-secondary players-more-btn" data-pl-act="lb-more"><i class="fas fa-chevron-down"></i> ' + t('players.showMore') + ' (' + extra + ')</button>';
        }
    }
}
let lbExpanded = false;
function toggleLeaderboard() { lbExpanded = !lbExpanded; renderLeaderboard(); }
window.toggleLeaderboard = toggleLeaderboard;

function openLeaderboardProfile(idOrName) {
    const m = (state.membersById && state.membersById[idOrName])
           || (state.members && state.members[idOrName]) || {};
    const dispName = m.displayName || m.name || idOrName;
    if (m.dbId && typeof window.openPublicProfileById === 'function') { window.openPublicProfileById(m.dbId, dispName); return; }
    /* v9 8.14-b: un id de profil care nu e în clubul curent deschidea un profil GOL (fără id:
       fără date, fără status online). Acum se cere profilul real. */
    if (!m.dbId && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(idOrName || '')) && typeof window.openPublicProfileById === 'function') { window.openPublicProfileById(String(idOrName)); return; }
    if (typeof window.openPublicProfile === 'function') {
        window.openPublicProfile({
            id: m.dbId || null, name: dispName, avatar: m.avatar || null, email: m.email || null,
            bio: m.bio || '', user_tag: m.userTag || '', preferred_games: m.preferredGames || [],
            profileExtra: m.profileExtra || null
        });
    }
}
window.openLeaderboardProfile = openLeaderboardProfile;

function getSortedPlayers() {
    if (!state.members || typeof state.members !== 'object') return [];
    /* Sursa de adevăr e membersById (pe id) -> include și omonimii (același nume,
       id-uri diferite). Fallback pe state.members (nume) pentru demo/offline. */
    const src = (state.membersById && Object.keys(state.membersById).length) ? state.membersById : state.members;
    return Object.values(src)
        .filter(member => member && !member.hidden)
        .map(member => ({
            name: member.name || member.displayName || '',
            score: member.score || 0,
            gamesPlayed: member.gamesPlayed || 0,
            email: member.email || null,
            hidden: member.hidden || false,
            joinDate: member.joinDate || '',
            preferredGames: member.preferredGames || [],
            skillLevel: member.skillLevel || 3,
            dbId: member.dbId || null,
            role: member.role || 'member',
            userTag: member.userTag || '',
            avatar: member.avatar || null
        }))
        .sort((a, b) => (b.score || 0) - (a.score || 0));
}

function countWins(playerId) {
    return state.games.filter(game => {
        if (game.friendly || (game.meta && game.meta.friendly)) return false; /* amicale: nu contează la stats jucători */
        /* Câștigătorul = MEREU din game.winners (respectă tie-break-ul uniformizat,
           e gol la coop-loss și campanie) — NU recalculat din max(scores) (§18.f).
           Corectează: coop (scoruri 0 -> înainte „câștigau" toți), uniform-cu-tiebreak
           și campanie. */
        return Array.isArray(game.winners) && game.winners.includes(playerId);
    }).length;
}

function calculateTrend(playerId) {
    const recentGames = state.games.slice(-10);
    const playerGames = recentGames.filter(g => g.scores && g.scores[playerId] !== undefined);
    
    if (playerGames.length < 2) return 0;
    
    const recentAvg = playerGames.slice(-3).reduce((sum, g) => sum + g.scores[playerId], 0) / Math.min(3, playerGames.length);
    const olderAvg = playerGames.slice(0, -3).reduce((sum, g) => sum + g.scores[playerId], 0) / Math.max(1, playerGames.length - 3);
    
    return recentAvg - olderAvg;
}

function renderPerformanceChart() {
    const chartContainer = document.getElementById('performanceChart');
    if (!chartContainer) return;
    const locale = appDateLocale();
    const esc = window.escHtml || (x => x);

    /* RO: Ultimele 6 luni calendaristice, ancorate pe ÎNTÂI ale lunii.
           Înainte: `new Date(); date.setMonth(date.getMonth() - i)`. Pe 31 iulie,
           „iunie" devenea 31 iunie -> 1 IULIE, deci lista arăta „Jul Jul" și lipsea
           iunie. Iar filtrul de sub compara `getMonth()` pe data deja alunecată,
           așa că bara etichetată „iunie" NUMĂRA sesiunile din iulie. Bug vizibil
           doar în zilele de 29–31, de aceea „se repara singur" după câteva zile.
           Acum pornim din prima zi a lunii curente și comparăm cu granițele reale
           [1 ale lunii, 1 ale lunii următoare), nu cu numere de lună.
       EN: anchor the six-month window on the 1st of each month and compare against
           real month boundaries; setMonth overflow duplicated months and miscounted. */
    const months = [], counts = [];
    const lunaCurenta = startOfMonth(new Date());
    for (let i = 5; i >= 0; i--) {
        const inceput = addMonths(lunaCurenta, -i);
        const sfarsit = addMonths(lunaCurenta, -i + 1);
        const mName = inceput.toLocaleDateString(locale, { month: 'short' });
        months.push(mName.charAt(0).toUpperCase() + mName.slice(1));
        const c = (state.games || []).filter(g => {
            const d = new Date(g.timestamp);
            return d >= inceput && d < sfarsit;
        }).length;
        counts.push(c);
    }
    const maxC = Math.max(1, ...counts);
    const totalSessions = counts.reduce((a, b) => a + b, 0);

    // Jocuri jucate în ultimele 6 luni (miniaturi)
    /* Aceeași fereastră ca barele: exact 6 luni calendaristice, nu „acum minus 6
       luni" care aluneca cu 1–3 zile în funcție de ziua curentă. */
    const cutoff = addMonths(lunaCurenta, -5);
    const playCount = {};
    (state.games || []).forEach(g => {
        const d = new Date(g.timestamp);
        if (d >= cutoff && g.gameName) playCount[g.gameName] = (playCount[g.gameName] || 0) + 1;
    });
    const topGames = Object.keys(playCount).sort((a, b) => playCount[b] - playCount[a]).slice(0, 12);

    const bars = counts.map((c, i) => {
        const h = Math.round(c / maxC * 100);
        return `<div class="perf-bar-col">
            <div class="perf-bar-val">${c}</div>
            <div class="perf-bar" style="height:${c > 0 ? Math.max(8, h) : 2}%;"></div>
            <div class="perf-bar-label">${months[i]}</div>
        </div>`;
    }).join('');

    const thumbs = topGames.map(name => {
        const g = (state.catalog && state.catalog[name]) || {};
        /* Batch 0a-1: fundalul NU se mai pune la randare; pleacă în `data-bg` și
           se aplică la intrarea în viewport (vezi `toObserveLazyBg` mai jos). */
        const styleImg = toLazyBgAttr(g.imageUrl, 'thumb');
        const short = name.length > 15 ? name.slice(0, 14).trim() + '…' : name;
        return `<div class="perf-thumb${g.imageUrl ? '' : ' perf-thumb-noimg'}"${styleImg} onclick="showGameDetails('${window.attrJs(name)}')" title="${esc(name)}">
            <span class="perf-thumb-count">${playCount[name]}×</span>
            <span class="perf-thumb-name">${esc(short)}</span>
        </div>`;
    }).join('');

    chartContainer.innerHTML = `
        <div class="perf-bars">${bars}</div>
        ${topGames.length ? `
            <div class="perf-thumbs-label">${t('dash.gamesPlayed')} · ${totalSessions} ${t('dash.sessions6mo')}</div>
            <div class="perf-thumbs">${thumbs}</div>
        ` : ''}`;

    /* Batch 0a-1: după ce HTML-ul e în DOM, punem miniaturile sub observare.
       Banda e la ~3.500 px de sus și derulează orizontal => practic niciuna nu
       se descarcă până când utilizatorul chiar ajunge la ea. */
    toObserveLazyBg(chartContainer);
}

function recentActivityChanged(val) {
    state.recentActivityQuery = val || '';
    renderRecentActivity();
}
function renderRecentActivity() {
    const container = document.getElementById('recentActivity');
    if (!container) return;
    const q = (state.recentActivityQuery || '').trim().toLowerCase();
    const nm = id => (typeof displayNameById === 'function' && displayNameById(id)) || id;
    let games = (state.games || []).slice();
    if (q) {
        games = games.filter(g => {
            const hay = [
                g.gameName, g.location, g.notes, nm(g.recordedBy), g.tournamentName, g.format,
                ...(g.participants || []).map(nm),
                ...Object.keys(g.scores || {}).map(nm)
            ].filter(Boolean).join(' ').toLowerCase();
            return hay.includes(q);
        });
    }
    games.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    const recentGames = q ? games.slice(0, 50) : games.slice(0, 10);

    if (recentGames.length === 0) {
        container.innerHTML = q
            ? `<p class="text-center text-muted">${t('ra.searchEmptyPre')} „${q}".</p>`
            : '<p class="text-center text-muted">' + t('dash.noActivity') + '</p>';
        return;
    }
    
    container.innerHTML = recentGames.map(game => {
        const date = new Date(game.timestamp);
        const timeStr = date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString(appTimeLocale(), { hour: '2-digit', minute: '2-digit' });
        /* La sesiunile cooperative UNIFORMIZATE scorurile brute sunt 0 (rezultat de
           echipă) — afișăm Punctele de Club câștigate. Competitivul rămâne pe brut. */
        const _uniNonComp = (game.scoreMode === 'uniform' && game.clubPoints && (game.type === 'coop' || game.coop || game.scoreKind === 'campaign'));
        const dispScores = _uniNonComp ? game.clubPoints : (game.scores || {});
        /* Câștigătorul afișat = cel salvat în winners (respectă tie-break-ul);
           fallback pe scorul maxim doar dacă lipsește. Campania nu are câștigător. */
        const _wIds = (game.scoreKind === 'campaign') ? [] : (Array.isArray(game.winners) ? game.winners.filter(Boolean) : []);
        let winner = null;
        if (_wIds.length) {
            const _wid = _wIds[0];
            winner = [_wid, (dispScores[_wid] != null ? dispScores[_wid] : 0)];
        } else if (game.scoreKind !== 'campaign' && Object.keys(dispScores).length) {
            winner = Object.entries(dispScores).sort((a, b) => b[1] - a[1])[0];
        }
        /* Co-op: rezultat de echipă, fără „câștigător" individual (suprimăm coroana). */
        const isCoopRA = (game.type === 'coop' || !!game.coop);
        if (isCoopRA) winner = null;
        const hasScores = Object.keys(dispScores).length > 0;
        /* Flag-uri (identice cu History, §18): badge Uniformizat, khanda la
           câștigătorul tie-break-ului, Punctele de Club mic în paranteză. */
        const _raUniform = game.scoreMode === 'uniform';
        const _raTb = pid => !!(game.tieBreaks && game.tieBreaks[pid]);
        const raTieIcon = pid => _raTb(pid)
            ? ` <i class="fas fa-khanda" style="color:var(--accent-gold,#f9a826);" title="${t('hist.tieBreakWon')}"></i>` : '';
        const raCpNote = pid => (_raUniform && !_uniNonComp && game.clubPoints && game.clubPoints[pid] != null)
            ? ` <small style="opacity:.65; font-weight:400;">(${(Number(game.clubPoints[pid]) || 0)} ${t('hist.clubPts')})</small>` : '';
        
        // FIX: Include all participants, even those without scores
        const allParticipants = game.participants || [];
        const participantsWithScores = game.scores ? Object.keys(game.scores) : [];
        
        return `
            <div class="game-entry" style="
                background: var(--bg-secondary);
                padding: 15px;
                margin-bottom: 15px;
                border-radius: 10px;
                border-left: 4px solid ${hasScores ? 'var(--accent-primary)' : 'var(--text-secondary)'};
            ">
                <div class="game-time">
                    <i class="fas fa-clock"></i> ${timeStr}
                    ${game.location ? `<span class="badge badge-primary" style="margin-left: 10px;"><i class="fas fa-map-marker-alt"></i> ${window.escHtml(game.location)}</span>` : ''}
                    ${game.isTournament ? `<span class="badge badge-warning" style="margin-left: 10px;"><i class="fas fa-trophy"></i> ${t('session.tournament')}</span>` : ''}
                    ${game.friendly ? `<span class="badge" style="margin-left: 10px; background:var(--accent-primary,#ff6b35); color:#fff;"><i class="fas fa-handshake"></i> ${t('hist.friendly')}</span>` : ''}
                    ${_raUniform ? uniformBadgeHtml() : ''}
                    ${isCoopRA ? `<span class="badge" style="margin-left: 10px; background:${(game.coop && game.coop.outcome === 'loss') ? '#b3402f' : '#0e8a7b'}; color:#fff;"><i class="fas fa-handshake"></i> ${t('hist.coop')} — ${(game.coop && game.coop.outcome === 'win') ? t('camp.win') : (game.coop && game.coop.outcome === 'loss') ? t('camp.loss') : ''}</span>` : ''}
                </div>
                <div class="ra-head" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                    <h4 style="color: var(--accent-gold); margin: 0; min-width:0;">${window.escHtml(game.gameName || t('ra.fallbackName'))}</h4>
                    ${winner ? `<span class="ra-winner" style="color: var(--success); font-weight: bold;"><i class="fas fa-crown"></i> ${window.escHtml(nm(winner[0]))}${raTieIcon(winner[0])}: ${(Number(winner[1]) || 0).toFixed(1)} ${t('hist.points')}</span>` : ''}
                </div>
                ${game.isTournament ? (() => {
                    const podium = game.scores ? Object.entries(game.scores).sort((a, b) => b[1] - a[1]).slice(0, 3) : [];
                    const medals = ['🥇', '🥈', '🥉'];
                    const meta = [];
                    if (game.tournamentName) meta.push('🏆 ' + game.tournamentName);
                    if (game.format) meta.push(t('ra.format') + ': ' + game.format);
                    if (game.rounds) meta.push(game.rounds + ' ' + t('ra.rounds'));
                    if (game.prize) meta.push(t('ra.prize') + ': ' + game.prize);
                    if (game.fee) meta.push(t('ra.fee') + ': ' + game.fee);
                    return `<div style="background:rgba(255,215,0,0.08); border:1px solid var(--accent-gold); border-radius:8px; padding:10px 12px; margin-bottom:10px;">
                        ${meta.length ? `<div style="font-size:0.85em; color:var(--text-secondary); margin-bottom:${podium.length ? '8px' : '0'};">${meta.join(' · ')}</div>` : ''}
                        ${podium.length ? `<div style="display:flex; gap:14px; flex-wrap:wrap;">${podium.map((p, i) => `<span style="font-weight:700;">${medals[i]} ${window.escHtml(nm(p[0]))} <span style="color:var(--text-secondary); font-weight:400;">(${p[1].toFixed(1)})</span></span>`).join('')}</div>` : ''}
                    </div>`;
                })() : ''}
                ${isCoopRA ? (() => {
                    const _c = game.coop || {};
                    const _dtxt = (typeof coopDifficultyText === 'function') ? coopDifficultyText(_c) : (_c.difficulty || '');
                    const bits = [];
                    if (_dtxt) bits.push('🏔 ' + t('coop.difficultyShort') + ': ' + window.escHtml(_dtxt));
                    if (_c.teamScore != null) bits.push('⭐ ' + t('hist.teamScore') + ': ' + (Number(_c.teamScore) || 0));
                    if (game.scoreMode === 'uniform' && game.clubPoints) {
                        const _pe = (game.participants || []).map(p => game.clubPoints[p]).find(x => x != null);
                        if (_pe != null) bits.push('⚖️ ' + (Number(_pe) || 0) + ' ' + t('hist.clubPts') + ' ' + t('coop.ptsEachSuffix'));
                    }
                    if (_c.scenario) bits.push('📖 ' + window.escHtml(String(_c.scenario)));
                    if (_c.detail) bits.push('🎯 ' + window.escHtml(String(_c.detail)));
                    if (_c.mvp || _c.mvpCustom) bits.push('🏅 ' + t('coop.mvpShort') + ': ' + window.escHtml(String(_c.mvpCustom || nm(_c.mvp))));
                    if (!bits.length) return '';
                    return `<div style="background:rgba(14,138,123,0.08); border:1px solid #0e8a7b; border-radius:8px; padding:10px 12px; margin-bottom:10px; font-size:0.88em; color:var(--text-secondary); display:flex; flex-wrap:wrap; gap:6px 16px;">${bits.map(b => `<span>${b}</span>`).join('')}</div>`;
                })() : ''}
                <div class="game-participants">
                    ${allParticipants.map(name => {
                        if (isCoopRA) {
                            const _role = (game.roles && game.roles[name]) ? String(game.roles[name]) : '';
                            return `
                            <div class="participant" style="display: flex; justify-content: space-between; padding: 8px; margin: 4px 0; background: var(--bg-primary); border-radius: 8px;">
                                <span class="participant-name">${window.escHtml(nm(name))}</span>
                                ${_role ? `<span class="participant-score" style="color: var(--text-secondary); font-weight:400;">🎭 ${window.escHtml(_role)}</span>` : ''}
                            </div>`;
                        }
                        const score = dispScores[name];
                        return `
                            <div class="participant" style="
                                display: flex;
                                justify-content: space-between;
                                padding: 8px;
                                margin: 4px 0;
                                background: var(--bg-primary);
                                border-radius: 8px;
                            ">
                                <span class="participant-name">${window.escHtml(nm(name))}${raTieIcon(name)}</span>
                                <span class="participant-score" style="color: ${score !== undefined ? 'var(--success)' : 'var(--text-secondary)'};">
                                    ${score !== undefined ? (Number(score) || 0).toFixed(1) : t('ra.noScore')}${score !== undefined ? raCpNote(name) : ''}
                                </span>
                            </div>
                        `;
                    }).join('')}
                </div>
                ${game.notes ? `<p style="color: var(--text-secondary); margin-top: 10px; font-style: italic;">"${window.escHtml(game.notes)}"</p>` : ''}
            </div>
        `;
    }).join('');
}

/* ================= SESSION MANAGEMENT ================= */
let currentSessionType = 'standard';
let sessionPlayers = []; /* jucătorii selectați pentru sesiunea curentă (combobox) */
let sessionPhotoFiles = []; /* fotografii selectate pentru sesiunea curentă (File[]) */
/* 9.3: căile pozelor DEJA urcate în Storage (string[]). Într-o sesiune live pozele se urcă
   la alegere, nu la salvare — altfel un refresh le pierdea (un `File` nu supraviețuiește
   reîncărcării paginii) și nu le vedea nimeni altcineva.
   EN: paths of photos already uploaded; in a live session we upload at pick time. */
let sessionPhotoPaths = [];
let sessionTieBreaks = {}; /* departajări manuale la egalitate: { pid: true } (Batch C2) */

function setSessionType(type) {
    if (type === 'tournament' && !requireFeature('tournaments')) { type = 'standard'; }
    if (type === 'coop' && !requireFeature('coop')) { type = 'standard'; }
    currentSessionType = type;

    // Update buttons (păstrăm mereu clasa de bază .btn; comutăm doar varianta)
    const map = { standard: 'btnStandard', tournament: 'btnTournament', coop: 'btnCoop' };
    Object.keys(map).forEach(t => {
        const btn = document.getElementById(map[t]);
        if (btn) {
            const isActive = t === type;
            btn.classList.add('btn');
            btn.classList.toggle('btn-secondary', !isActive);
        }
    });

    const tournamentFields = document.getElementById('tournamentFields');
    if (tournamentFields) tournamentFields.classList.toggle('hidden', type !== 'tournament');
    const coopFields = document.getElementById('coopFields');
    if (coopFields) coopFields.classList.toggle('hidden', type !== 'coop');
    /* Notă de transparență: pe cluburile fără uniformizare activă, coop-ul se
       înregistrează dar NU adaugă Puncte de Club (§5.3 — varianta unitară). */
    const _coopNoPts = document.getElementById('coopNoPointsNote');
    if (_coopNoPts) {
        const _tpl = (typeof getScoringTemplates === 'function') ? getScoringTemplates() : null;
        const _uniformAvailable = !!(_tpl && _tpl.enabled);
        _coopNoPts.classList.toggle('hidden', !(type === 'coop' && !_uniformAvailable));
    }
    if (type === 'coop') {
        if (typeof onCoopDifficultyChange === 'function') onCoopDifficultyChange();
        if (typeof renderCoopScenarioSuggest === 'function') renderCoopScenarioSuggest();
        if (typeof renderCoopMvpOptions === 'function') renderCoopMvpOptions();
    }

    // În co-op ascundem scorurile individuale
    if (typeof renderSessionScoreMode === 'function') renderSessionScoreMode();
    if (typeof renderSessionScoreDir === 'function') renderSessionScoreDir();
    if (typeof renderSessionPlayers === 'function') renderSessionPlayers();
}

/* ---- Selector joc sesiune: search live cu carduri (titlu peste poză) ---- */
function sessionGameSearchLive() {
    const box = document.getElementById('sessionGameResults');
    const inp = document.getElementById('sessionGameSearch');
    if (!box || !inp) return;
    const addBtn = document.getElementById('sessionAddGameBtn');
    if (addBtn) addBtn.style.display = ''; /* butonul „+" apare după interacțiunea cu search-ul */
    const q = inp.value.trim().toLowerCase();
    const parts = q ? q.split(/\s+/) : [];
    let list = Object.keys(state.catalog || {}).map(function (name) { return { name: name, g: state.catalog[name] }; });
    if (parts.length) {
        list = list.filter(function (o) {
            const g = o.g || {};
            const hay = (o.name + ' ' + ((g.categories || []).join(' ')) + ' ' + (g.designer || '') + ' ' + (g.publisher || '') + ' ' + (g.edition || '')).toLowerCase();
            return parts.every(function (p) { return hay.indexOf(p) !== -1; });
        });
    }
    list.sort(function (a, b) { return a.name.localeCompare(b.name); });
    list = list.slice(0, 40);
    if (!list.length) {
        box.innerHTML = '<div class="sess-game-empty">' + t('session.noGames') + '</div>';
        box.classList.add('show');
        return;
    }
    box.innerHTML = list.map(function (o) {
        const g = o.g || {};
        /* ⚡ PERF §54.1: încărcare LENEȘĂ, ca la banda de miniaturi din Dashboard.
           RO: lista asta afișează până la 40 de carduri de joc, fiecare cu imaginea lui
               de catalog (BGG), într-o casetă care arată 3-4 rânduri o dată. Fără
               amânare, deschiderea selectorului descărca TOATE cele 40 de imagini
               deodată — zeci sau sute de kilobytes pentru câteva pe care le și vezi.
               `loading="lazy"` NU ajută aici: e un fundal CSS, nu un `<img>`; de asta
               există perechea `toLazyBgAttr` + `toObserveLazyBg`.
           EN: up to 40 catalogue images in a box that shows 3-4 rows at a time. `loading="lazy"`
               does not apply to CSS backgrounds, hence the attribute + observer pair. */
        const styleImg = (typeof toLazyBgAttr === 'function')
            ? toLazyBgAttr(g.imageUrl, 'thumb')
            : (g.imageUrl ? ' style="background-image:url(\'' + gameImgCss(g.imageUrl, 'thumb') + '\');"' : '');
        return '<div class="sess-game-card' + (g.imageUrl ? '' : ' noimg') + '"' + styleImg + ' onclick="pickSessionGame(\'' + window.attrJs(o.name) + '\')">' +
            '<div class="sess-game-card-ov"><span class="sess-game-card-title">' + window.escHtml(o.name) + '</span></div></div>';
    }).join('');
    box.classList.add('show');
    /* ⚠ DUPĂ `.show`: cât timp caseta e ascunsă, nimic nu e „vizibil", deci observatorul
       n-ar porni nimic. Ordinea contează.
       EN: must run AFTER the box is shown, otherwise nothing intersects. */
    try { if (typeof toObserveLazyBg === 'function') toObserveLazyBg(box); } catch (e) { logError('sessionGameSearchLive', e); }
}
function pickSessionGame(name) {
    /* `_liveHydrating` = încărcăm noi foaia în pagină -> permis. Un click al userului
       în mod doar-vizualizare -> blocat. */
    if (!window._liveHydrating && liveWriteBlocked()) return;
    /* Jocul s-a schimbat -> propagă foaia (dacă suntem într-o sesiune live).
       ⚠ 9.1 (sept. 2026) — PIERDERE REALĂ DE DATE, dovedită prin rularea fluxului:
       RO: push-ul pleacă AMÂNAT (setTimeout 0), deci DUPĂ ce `openLiveCard` își coboară
           steagul `_liveHydrating`. Garda din `pushLiveSheet` nu-l mai vedea, iar foaia
           plecată conținea cardurile PROASPĂT desenate: scor 0, rol gol. Test: pe server
           42 / 37 + roluri -> după simpla deschidere a cardului, fără nicio atingere,
           aplicația trimitea 0 / 0 și zero roluri. Reținem starea din momentul APELULUI:
           o selecție făcută de hidratare nu se trimite niciodată înapoi.
       EN: the deferred push escaped the hydration flag and overwrote the server's
           scores/roles with freshly-rendered zeros. Capture the flag at call time. */
    var _fromHydration = !!window._liveHydrating;
    setTimeout(function () {
        if (_fromHydration) return;
        try { if (typeof pushLiveSheet === 'function') pushLiveSheet(); } catch (e) { logError('pickSessionGame', e); }
    }, 0);
    const hidden = document.getElementById('sessionGame');
    if (hidden) hidden.value = name;
    const g = (state.catalog || {})[name] || {};
    const sel = document.getElementById('sessionGameSelected');
    const picker = document.getElementById('sessionGamePicker');
    const box = document.getElementById('sessionGameResults');
    if (box) { box.innerHTML = ''; box.classList.remove('show'); }
    if (sel) {
        const styleImg = g.imageUrl ? ' style="background-image:url(\'' + gameImgCss(g.imageUrl, 'wide') + '\');"' : '';
        sel.innerHTML = '<div class="sess-game-selected-card' + (g.imageUrl ? '' : ' noimg') + '"' + styleImg + '>' +
            '<span class="sess-game-selected-title">' + window.escHtml(name) + '</span>' +
            '<button type="button" class="sess-game-clear" onclick="clearSessionGame()" aria-label="' + t('common.cancel') + '"><i class="fas fa-times"></i></button></div>';
        sel.style.display = 'block';
    }
    if (picker) picker.style.display = 'none';
    /* Jocul s-a schimbat -> reevaluează direcția moștenită (Faza 3). Resetăm
       override-ul anterior ca să reflecte jocul nou selectat. */
    try { const _sd = document.getElementById('sessionScoreDir'); if (_sd) _sd.value = ''; } catch (e) {}
    if (typeof renderSessionScoreDir === 'function') renderSessionScoreDir();
    if (typeof renderSessionPlayers === 'function') renderSessionPlayers();
}
function clearSessionGame() {
    const hidden = document.getElementById('sessionGame');
    if (hidden) hidden.value = '';
    const sel = document.getElementById('sessionGameSelected');
    const picker = document.getElementById('sessionGamePicker');
    const search = document.getElementById('sessionGameSearch');
    const box = document.getElementById('sessionGameResults');
    const addBtn = document.getElementById('sessionAddGameBtn');
    if (addBtn) addBtn.style.display = 'none';
    if (sel) { sel.innerHTML = ''; sel.style.display = 'none'; }
    if (picker) picker.style.display = '';
    if (search) search.value = '';
    if (box) { box.innerHTML = ''; box.classList.remove('show'); }
    try { const _sd = document.getElementById('sessionScoreDir'); if (_sd) _sd.value = ''; } catch (e) {}
    if (typeof renderSessionScoreDir === 'function') renderSessionScoreDir();
    if (typeof renderSessionPlayers === 'function') renderSessionPlayers();

    /* Propagă foaia: ștergerea jocului e o modificare ca oricare alta.
       ⚠ Lipsea — adăugasem push-ul în `pickSessionGame`, dar NU și aici. Rezultat: host-ul
       ștergea jocul, iar spectatorii îl vedeau în continuare pe cel vechi.
       `renderSessionPlayers` NU mai propagă (ar fi ciclu de feedback), deci o facem explicit.
       Hidratarea programatică e exclusă de garda din `pushLiveSheet` (`_liveHydrating`). */
    try { if (typeof pushLiveSheet === 'function') pushLiveSheet(); } catch (e) { logError('clearSessionGame', e); }
}
window.sessionGameSearchLive = sessionGameSearchLive;
window.pickSessionGame = pickSessionGame;
window.clearSessionGame = clearSessionGame;

/* ---- Locații anterioare ale clubului (din sesiunile salvate) ---- */
function renderPastLocations() {
    const wrap = document.getElementById('pastLocations');
    if (!wrap) return;
    const seen = [];
    (state.games || []).slice().sort(function (a, b) {
        return new Date(b.timestamp || 0) - new Date(a.timestamp || 0);
    }).forEach(function (s) {
        const loc = ((s && s.location) || '').trim();
        if (loc && seen.indexOf(loc) === -1) seen.push(loc);
    });
    const locs = seen.slice(0, 10);
    if (!locs.length) { wrap.innerHTML = ''; wrap.style.display = 'none'; return; }
    wrap.style.display = '';
    wrap.innerHTML = '<div class="past-loc-label">' + t('session.pastLocations') + '</div>' +
        '<div class="past-loc-chips">' + locs.map(function (l) {
            return '<button type="button" class="past-loc-chip" onclick="setSessionLocation(\'' + window.attrJs(l) + '\')">' +
                '<i class="fas fa-map-marker-alt" style="opacity:.6; margin-right:5px;"></i>' + clubEsc(l) + '</button>';
        }).join('') + '</div>';
}
function setSessionLocation(loc) {
    const inp = document.getElementById('sessionLocation');
    if (inp) { inp.value = loc; }
}
window.renderPastLocations = renderPastLocations;
window.setSessionLocation = setSessionLocation;

/* ---- Co-op (Faza 1): dificultate custom + sugestii de scenariu ---- */
/* Arată câmpul „Nume dificultate" doar când e selectat Personalizat. */
function onCoopDifficultyChange() {
    const sel = document.getElementById('coopDifficulty');
    const wrap = document.getElementById('coopDifficultyCustomWrap');
    if (!sel || !wrap) return;
    const isCustom = sel.value === 'custom';
    wrap.classList.toggle('hidden', !isCustom);
    if (!isCustom) { const inp = document.getElementById('coopDifficultyLabel'); if (inp) inp.value = ''; }
}
/* Chips cu scenariile coop anterioare ale clubului (ca renderPastLocations). */
function renderCoopScenarioSuggest() {
    const wrap = document.getElementById('coopScenarioSuggest');
    if (!wrap) return;
    const seen = [];
    (state.games || []).slice().sort(function (a, b) {
        return new Date(b.timestamp || 0) - new Date(a.timestamp || 0);
    }).forEach(function (s) {
        const co = s && (s.coop || (s.meta && s.meta.coop));
        const sc = (co && co.scenario ? String(co.scenario) : '').trim();
        if (sc && seen.indexOf(sc) === -1) seen.push(sc);
    });
    const items = seen.slice(0, 8);
    if (!items.length) { wrap.innerHTML = ''; wrap.style.display = 'none'; return; }
    wrap.style.display = '';
    wrap.innerHTML = '<div class="past-loc-label">' + t('coop.scenarioSuggest') + '</div>' +
        '<div class="past-loc-chips">' + items.map(function (sc) {
            return '<button type="button" class="past-loc-chip" onclick="setCoopScenario(\'' + window.attrJs(sc) + '\')">' +
                '<i class="fas fa-book" style="opacity:.6; margin-right:5px;"></i>' + clubEsc(sc) + '</button>';
        }).join('') + '</div>';
}
function setCoopScenario(sc) {
    const inp = document.getElementById('coopScenario');
    if (inp) { inp.value = sc; }
}
/* Eticheta de dificultate pentru afișare (preset -> i18n; custom -> label liber). */
function coopDifficultyText(coop) {
    if (!coop || !coop.difficulty) return '';
    if (coop.difficulty === 'custom') return String(coop.difficultyLabel || t('coop.diff.custom')).trim();
    const key = 'coop.diff.' + coop.difficulty;
    const lbl = t(key);
    return (lbl && lbl !== key) ? lbl : String(coop.difficulty);
}
/* Populează selectorul de MVP cu jucătorii înregistrați selectați (păstrează alegerea). */
function renderCoopMvpOptions() {
    const sel = document.getElementById('coopMvp');
    if (!sel) return;
    const prev = sel.value;
    const opts = ['<option value="">' + t('coop.mvpNone') + '</option>'];
    (typeof sessionPlayers !== 'undefined' ? sessionPlayers : []).forEach(id => {
        const m = (typeof memberById === 'function') ? memberById(id) : null;
        const pid = (m && m.dbId) || id;
        const nm = (m && (m.name || m.displayName)) || ((typeof displayNameById === 'function') ? displayNameById(pid) : pid);
        opts.push('<option value="' + window.attrJs(pid) + '">' + clubEsc(nm) + '</option>');
    });
    opts.push('<option value="__custom__">' + t('coop.mvpCustom') + '</option>'); /* nume liber (ex. invitat) */
    sel.innerHTML = opts.join('');
    if (prev) sel.value = prev; /* rămâne '' dacă jucătorul evidențiat nu mai e în listă */
    if (typeof onCoopMvpChange === 'function') onCoopMvpChange(); /* sincronizează câmpul custom */
}
/* Arată câmpul de nume liber doar când MVP = „Personalizat". */
function onCoopMvpChange() {
    const sel = document.getElementById('coopMvp');
    const wrap = document.getElementById('coopMvpCustomWrap');
    if (!sel || !wrap) return;
    const isCustom = sel.value === '__custom__';
    wrap.classList.toggle('hidden', !isCustom);
    if (!isCustom) { const inp = document.getElementById('coopMvpCustom'); if (inp) inp.value = ''; }
}
window.onCoopDifficultyChange = onCoopDifficultyChange;
window.renderCoopScenarioSuggest = renderCoopScenarioSuggest;
window.setCoopScenario = setCoopScenario;
window.coopDifficultyText = coopDifficultyText;
window.renderCoopMvpOptions = renderCoopMvpOptions;
window.onCoopMvpChange = onCoopMvpChange;

/* Formularul de sesiune are LUCRU ÎN CURS?
   Tab-urile sunt doar div-uri ascunse — DOM-ul supraviețuiește comutării. Singurul care
   ștergea scorurile era `renderSessionForm()`, chemat la FIECARE intrare în tab.
   Deci: dacă ai lucru în curs, nu-l mai resetăm. Vrei un formular gol? -> butonul
   „Sesiune nouă" (`clearSessionForm`), sau „Pornește sesiune live" din dashboard. */
function sessionFormHasWork() {
    if (window._liveSessionId) return true;                       /* legat de o sesiune live */
    if (typeof sessionPlayers !== 'undefined' && Array.isArray(sessionPlayers) && sessionPlayers.length) return true;
    if (typeof sessionGuests !== 'undefined' && Array.isArray(sessionGuests) && sessionGuests.length) return true;
    const g = document.getElementById('sessionGame');
    if (g && g.value) return true;                                /* joc ales */
    return false;
}
window.sessionFormHasWork = sessionFormHasWork;

/* ============================================================
   Butonul „Fă sesiunea live" (#btnGoLive) din tabul Sesiune.
   ------------------------------------------------------------
   RO: Are sens O SINGURĂ dată — când construiești o sesiune NOUĂ și vrei s-o
       publici. Dacă formularul editează deja o sesiune live (ai intrat pe ea din
       bara de pe Acasă), butonul e derutant: apăsat din nou ar deschide ÎNCĂ o
       sesiune live, în loc s-o editeze pe cea curentă.
       Sursa de adevăr există deja: `window._liveSessionId` e setat exact când
       formularul e legat de o sesiune live (`openLiveCard`, `openLiveSessionFromSheet`)
       și golit când e o sesiune nouă (chiar la începutul lui `renderSessionForm`).
       Deci regula e o singură condiție, fără stare nouă.
   EN: `#btnGoLive` only makes sense for a brand-new session. `window._liveSessionId`
       already tells us whether the form is bound to a live session.
   ============================================================ */
function syncGoLiveBtn() {
    try {
        var b = document.getElementById('btnGoLive');
        if (!b) return;
        var bound = !!window._liveSessionId;
        /* ⚠ Butonul avea DOAR gardă de rol (`data-cap="session.create"`), nu și de
           PLAN. Pe Starter apărea aici, deși bara de pe Acasă era ascunsă — iar
           apăsarea lui deschidea modalul de upgrade. Îl ascundem la sursă, ca să
           nu oferim o acțiune care oricum va fi refuzată.
           `requireFeature('liveSessions')` rămâne în `openLiveSessionFromSheet`
           ca gardă reală: ascunderea din interfață NU e apărare. */
        var allowed = (typeof planAllows !== 'function') || planAllows('liveSessions');
        b.classList.toggle('hidden', bound || !allowed);
    } catch (e) { if (typeof logError === 'function') logError('syncGoLiveBtn', e); }
}
window.syncGoLiveBtn = syncGoLiveBtn;

function renderSessionForm() {
    /* §2: formularul ăsta se RESETEAZĂ complet (joc, jucători, oaspeți, poze) la
       FIECARE intrare în tab. Deci trebuie să se dezlege și de sesiunea live —
       altfel rămânea legat de cea veche: formular gol, dar cronometrul și butoanele
       Turn încă acționau sesiunea PRECEDENTĂ. Ăsta e „mă duce la ultima sesiune".

       Excepție: `openLiveCard` ridică `_liveHydrating`, fiindcă el CHIAR vrea să
       încarce o sesiune existentă în formular. */
    if (!window._liveHydrating) {
        window._liveSessionId = null;
        window._liveReadOnly = false;
        if (typeof applyLiveReadOnly === 'function') applyLiveReadOnly();   /* deblochează câmpurile */
        if (typeof resetLiveTimer === 'function') resetLiveTimer();          /* cronometrul general pleacă de la 0 */
    }
    syncGoLiveBtn();

    // Selectorul de joc e acum search live cu carduri — resetăm picker-ul
    if (typeof clearSessionGame === 'function') clearSessionGame();
    if (typeof renderPastLocations === 'function') renderPastLocations();

    // Set default date and time
    const now = new Date();
    document.getElementById('sessionDate').value = now.toISOString().split('T')[0];
    document.getElementById('sessionStartTime').value = now.toTimeString().slice(0, 5);
    
    // Render players
    renderSessionPlayers();
    
    // Clear guests
    sessionGuests = [];
    // Reset jucători selectați (combobox)
    sessionPlayers = [];
    // Reset fotografii sesiune
    sessionPhotoFiles = [];
    sessionPhotoPaths = [];   /* 9.3: și pozele deja urcate ale mesei anterioare */
    try { const pv = document.getElementById('sessionPhotoPreview'); if (pv) pv.innerHTML = ''; const fi = document.getElementById('sessionPhotos'); if (fi) fi.value = ''; } catch (e) { logError('renderSessionForm', e); }

    // Reset toggle „Sesiune Amicală"
    var _fr = document.getElementById('sessionFriendly'); if (_fr) _fr.checked = false;

    // Mod de scorare (Brut/Uniformizat) — apare doar dacă uniformizarea e activă în club
    try { sessionTieBreaks = {}; } catch (e) { logError('renderSessionForm', e); }
    if (typeof renderSessionScoreMode === 'function') renderSessionScoreMode();
    if (typeof renderSessionScoreDir === 'function') renderSessionScoreDir();

    // Cronometru live: încarcă starea partajată (dacă există pe alt device)
    if (typeof loadTimerState === 'function') loadTimerState();
}

/* ---------- Scoresheets custom per joc (plan Pro+) ----------
   Șabloane = listă de categorii numerice per joc; totalul = suma lor.
   Stocate în club_settings cheia 'scoresheets' = { numeJoc: [categorii] }. */
function scoresheetFor(gameName) {
    if (!gameName || !planAllows('scoresheets')) return null;
    const arr = (state.scoresheets || {})[gameName];
    return (Array.isArray(arr) && arr.length) ? arr : null;
}

function recalcScoresheet(safeId) {
    const gameName = (document.getElementById('sessionGame') || {}).value || '';
    const fields = scoresheetFor(gameName) || [];
    let sum = 0;
    fields.forEach((_, i) => { const el = document.getElementById('ss-' + safeId + '-' + i); sum += parseFloat(el && el.value) || 0; });
    const tot = document.getElementById('score-' + safeId);
    if (tot) tot.value = sum;
    if (typeof onSessionScoreInput === 'function') onSessionScoreInput();
}

function openScoresheetEditor() {
    if (!requireFeature('scoresheets')) return;
    if (!isAdmin) { showNotification(t('m1.onlyAdminScoresheet'), 'error'); return; }
    const gameName = (document.getElementById('sessionGame') || {}).value || '';
    if (!gameName) { showNotification(t('m1.selectGameFirst'), 'info'); return; }
    const fields = (state.scoresheets && state.scoresheets[gameName]) ? state.scoresheets[gameName].slice() : [];
    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.dataset.game = gameName;
    modal.innerHTML = `<div class="modal-content"><div class="modal-header">
        <h2><i class="fas fa-table-list"></i> Scoresheet — ${clubEsc(gameName)}</h2>
        <button class="modal-close" onclick="this.parentElement.parentElement.parentElement.remove()">×</button>
        </div>
        <p style="color:var(--text-secondary); font-size:0.85em;">${t('ss.help')}</p>
        <div id="ssFields"></div>
        <button class="btn btn-sm btn-secondary" type="button" onclick="ssAddField()"><i class="fas fa-plus"></i> ${t('ss.addField')}</button>
        <div class="btn-group" style="margin-top:14px;">
            <button class="btn btn-primary" onclick="saveScoresheet()"><i class="fas fa-save"></i> ${t('common.save')}</button>
            <button class="btn btn-secondary" onclick="this.closest('.modal').remove()">${t('common.cancel')}</button>
        </div></div>`;
    document.body.appendChild(modal);
    const box = modal.querySelector('#ssFields');
    box.innerHTML = '';
    if (fields.length) fields.forEach(f => ssAddField(f)); else ssAddField();
}

function ssAddField(value) {
    const box = document.getElementById('ssFields'); if (!box) return;
    const row = document.createElement('div');
    row.style.cssText = 'display:flex; align-items:center; gap:8px; margin-bottom:6px;';
    row.innerHTML = `<input type="text" class="form-control ss-field-input" placeholder="${t('ss.fieldPh')}" value="${value ? clubEsc(value) : ''}">
        <button class="field-x" type="button" title="${t('common.delete')}" onclick="this.parentElement.remove()"><i class="fas fa-times"></i></button>`;
    box.appendChild(row);
}

async function saveScoresheet() {
    const modal = document.querySelector('.modal.active[data-game]');
    if (!modal) return;
    const gameName = modal.dataset.game;
    const fields = Array.from(modal.querySelectorAll('.ss-field-input'))
        .map(i => i.value.trim()).filter(Boolean);
    state.scoresheets = state.scoresheets || {};
    if (!isDemoMode()) {
        /* ⚠ DB-FIRST (aceeași clasă de bug care a șters date în iul. 2026):
           `scoresheets` e o HARTĂ pe joc. Scrierea hărții ÎNTREGI din memorie ar
           ȘTERGE foile celorlalte jocuri dacă memoria e goală/învechită.
           Citim harta REALĂ din DB, atingem DOAR jocul curent, scriem înapoi.
           Dacă citirea eșuează, NU scriem (mai bine nesalvat decât șters). */
        let baseMap = null;
        try {
            const cur = await sb.from('club_settings').select('value')
                .eq('club_id', currentClubId).eq('key', 'scoresheets').maybeSingle();
            if (cur && cur.error) throw cur.error;
            baseMap = (cur && cur.data && cur.data.value && typeof cur.data.value === 'object' && !Array.isArray(cur.data.value))
                ? cur.data.value : {};
        } catch (e) {
            showNotification(t('m1.saveErrorColon') + ((e && e.message) || ''), 'error');
            return;
        }
        const merged = Object.assign({}, baseMap);
        if (fields.length) merged[gameName] = fields; else delete merged[gameName];

        const up = await sb.from('club_settings')
            .upsert({ club_id: currentClubId, key: 'scoresheets', value: merged, updated_at: new Date().toISOString() }, { onConflict: 'club_id,key' });
        if (up.error) { showNotification(t('m1.saveErrorColon') + up.error.message, 'error'); return; }
        state.scoresheets = merged;   /* DB-first: memoria se aliniază DUPĂ scriere */
    } else {
        if (fields.length) state.scoresheets[gameName] = fields;
        else delete state.scoresheets[gameName];
    }
    modal.remove();
    renderSessionPlayers();
    showNotification(t('m1.scoresheetSaved').replace('{game}', gameName), 'success');
}

/* ---------- Roluri/facțiuni per joc + win rate per rol (plan Pro+) ---------- */
function rolesFor(gameName) {
    if (!gameName || !planAllows('advancedStats')) return null;
    const arr = (state.gameRoles || {})[gameName];
    return (Array.isArray(arr) && arr.length) ? arr : null;
}

function openRolesEditor() {
    if (!requireFeature('advancedStats')) return;
    if (!isAdmin) { showNotification(t('m1.onlyAdminRoles'), 'error'); return; }
    const gameName = (document.getElementById('sessionGame') || {}).value || '';
    if (!gameName) { showNotification(t('m1.selectGameFirst'), 'info'); return; }
    const roles = (state.gameRoles && state.gameRoles[gameName]) ? state.gameRoles[gameName].slice() : [];
    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.dataset.rolesGame = gameName;
    modal.innerHTML = `<div class="modal-content"><div class="modal-header">
        <h2><i class="fas fa-masks-theater"></i> ${t('roles.heading')} — ${clubEsc(gameName)}</h2>
        <button class="modal-close" onclick="this.parentElement.parentElement.parentElement.remove()">×</button>
        </div>
        <p style="color:var(--text-secondary); font-size:0.85em;">${t('roles.help')}</p>
        <div id="rolesFields"></div>
        <button class="btn btn-sm btn-secondary" type="button" onclick="roleAddField()"><i class="fas fa-plus"></i> ${t('roles.addField')}</button>
        <div class="btn-group" style="margin-top:14px;">
            <button class="btn btn-primary" onclick="saveRoles()"><i class="fas fa-save"></i> ${t('common.save')}</button>
            <button class="btn btn-secondary" onclick="this.closest('.modal').remove()">${t('common.cancel')}</button>
        </div></div>`;
    document.body.appendChild(modal);
    const box = modal.querySelector('#rolesFields');
    box.innerHTML = '';
    if (roles.length) roles.forEach(r => roleAddField(r)); else roleAddField();
}

function roleAddField(value) {
    const box = document.getElementById('rolesFields'); if (!box) return;
    const row = document.createElement('div');
    row.style.cssText = 'display:flex; align-items:center; gap:8px; margin-bottom:6px;';
    row.innerHTML = `<input type="text" class="form-control role-field-input" placeholder="${t('roles.fieldPh')}" value="${value ? clubEsc(value) : ''}">
        <button class="field-x" type="button" title="${t('common.delete')}" onclick="this.parentElement.remove()"><i class="fas fa-times"></i></button>`;
    box.appendChild(row);
}

async function saveRoles() {
    const modal = document.querySelector('.modal.active[data-roles-game]');
    if (!modal) return;
    const gameName = modal.dataset.rolesGame;
    const roles = Array.from(modal.querySelectorAll('.role-field-input')).map(i => i.value.trim()).filter(Boolean);
    state.gameRoles = state.gameRoles || {};
    if (!isDemoMode()) {
        /* ⚠ DB-FIRST: `gameroles` e o HARTĂ pe joc — scrierea ei întreagă din memorie
           ar șterge rolurile celorlalte jocuri dacă memoria e goală/învechită.
           Citim harta reală din DB, atingem DOAR jocul curent. Citire eșuată -> NU scriem. */
        let baseMap = null;
        try {
            const cur = await sb.from('club_settings').select('value')
                .eq('club_id', currentClubId).eq('key', 'gameroles').maybeSingle();
            if (cur && cur.error) throw cur.error;
            baseMap = (cur && cur.data && cur.data.value && typeof cur.data.value === 'object' && !Array.isArray(cur.data.value))
                ? cur.data.value : {};
        } catch (e) {
            showNotification(t('m1.saveErrorColon') + ((e && e.message) || ''), 'error');
            return;
        }
        const merged = Object.assign({}, baseMap);
        if (roles.length) merged[gameName] = roles; else delete merged[gameName];

        const up = await sb.from('club_settings')
            .upsert({ club_id: currentClubId, key: 'gameroles', value: merged, updated_at: new Date().toISOString() }, { onConflict: 'club_id,key' });
        if (up.error) { showNotification(t('m1.saveErrorColon') + up.error.message, 'error'); return; }
        state.gameRoles = merged;
    } else {
        if (roles.length) state.gameRoles[gameName] = roles;
        else delete state.gameRoles[gameName];
    }
    modal.remove();
    renderSessionPlayers();
    showNotification(t('m1.rolesSaved').replace('{game}', gameName), 'success');
}

/* ---------- Cronometru sesiune (live) + ceas per jucător (plan Basic+) ---------- */
let liveTimer = { sessionRunning: false, sessionAccumMs: 0, sessionStartTs: 0, activePlayer: null, playerAccumMs: {}, playerStartTs: 0, interval: null };

function fmtClock(ms) {
    const s = Math.max(0, Math.floor(ms / 1000)), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), ss = s % 60;
    const p = n => String(n).padStart(2, '0');
    return (h > 0 ? p(h) + ':' : '') + p(m) + ':' + p(ss);
}
/* ============================================================
   §2 — CEASURILE SE CITESC DIRECT DIN SESIUNEA LEGATĂ (fără oglindă globală).

   GREȘEALA ANTERIOARĂ: `liveTimer` e UN singur obiect, dar sesiunile live sunt N.
   Oglindeam sesiunea legată în el -> orice oglindă partajată între N surse se
   murdărește: timpii unei sesiuni se scurgeau în alta („continuă de unde a rămas
   la celelalte"). Nu era o scăpare, era un model greșit.

   ACUM: dacă formularul e legat de o sesiune live, ceasurile se citesc DIRECT din
   rândul ei (`state.liveSessions[i].timers`), care e per-sesiune prin construcție.
   N sesiuni pot avea ceasuri care curg în ritmuri diferite, fără să se atingă.
   `liveTimer` rămâne folosit DOAR pentru sesiunile locale (non-live) și pentru
   oaspeți (care n-au profile_id).
   ============================================================ */

/* ============================================================
   §2 batch C (final) — SINCRONIZAREA FOII.
   Ce editează host-ul (joc, jucători, scoruri, roluri) ajunge la spectatori.

   `sheet` are UN SINGUR scriitor logic (host + Moderator+), deci înlocuirea
   întreagă e corectă aici — spre deosebire de `timers`, care are N scriitori și
   cere delta. Debounce 700ms: tastarea unui scor nu trebuie să genereze o scriere
   pe fiecare tastă.
   ============================================================ */
let _liveSheetPushTimer = null;

function collectLiveSheet() {
    const gameSel = document.getElementById('sessionGame');
    const game = (gameSel && gameSel.value) || '';
    const players = (typeof sessionPlayers !== 'undefined' && Array.isArray(sessionPlayers))
        ? sessionPlayers.slice() : [];

    const scores = {};
    const roles = {};
    const ss = {};
    players.forEach(function (pid) {
        /* ⚠ Id-ul DOM e derivat din PROFILE_ID, nu din nume:
               <input id="score-${safeId}">   unde safeId = dbId cu cratime
           Căutam după nume => nu găseam NICIUN input, deci nu trimiteam niciun scor.
           De asta scorurile nu se sincronizau deloc. */
        const safe = String(pid).replace(/[^a-zA-Z0-9]/g, '-');
        const si = document.getElementById('score-' + safe);
        if (si && si.value !== '') scores[pid] = Number(si.value) || 0;
        const ri = document.getElementById('role-' + safe);
        if (ri && ri.value) roles[pid] = ri.value;

        /* Modul cu FOAIE DE SCOR: câmpurile individuale (`ss-{id}-{i}`), din care se
           calculează Total-ul (`score-{id}`, readonly). Dacă am trimite doar Total-ul,
           la celălalt client `recalcScoresheet` l-ar rescrie din câmpurile lui goale
           => scorul ar sări înapoi la 0. Deci trimitem câmpurile, nu doar suma. */
        const cells = document.querySelectorAll('[id^="ss-' + safe + '-"]');
        if (cells.length) {
            const arr = [];
            cells.forEach(function (c) {
                const idx = parseInt(String(c.id).split('-').pop(), 10);
                if (!isNaN(idx)) arr[idx] = Number(c.value) || 0;
            });
            ss[pid] = arr;
        }
    });

    /* TIPUL sesiunii merge în foaie. Fără el, redeschiderea unei sesiuni live de TURNEU
       sau COOPERATIVE o transforma tăcut în „standard" la salvare: legătura cu turneul
       se pierdea, iar ELO se aplica greșit unui joc cooperativ. */
    const type = (typeof currentSessionType !== 'undefined' && currentSessionType) ? currentSessionType : 'standard';

    /* Oaspeții: nume + cheie de ceas. Ei nu au cont, deci nu apasă nimic — dar au timp,
       acționat de host/admin. */
    const guests = (typeof sessionGuests !== 'undefined' && Array.isArray(sessionGuests))
        ? sessionGuests.map(g => ({ key: g.key, name: g.name })) : [];
    const guestKeys = guests.filter(g => g.key).map(g => 'guest:' + g.key);

    /* ⚠ 9.1 (sept. 2026): scorul, rolul și foaia de scor ale OASPEȚILOR nu intrau deloc în
       foaie — bucla de mai sus parcurge doar jucătorii cu cont, iar câmpurile oaspeților au
       alt id (`score-guest-<nume>`, `role-guest-<nume>`, `ssg-<cheie>-<i>`). Verificat: un
       55 tastat la oaspete nu apărea în foaia trimisă, deci se pierdea la refresh.
       Chei SEPARATE (`guestScores`/`guestRoles`/`guestSs`, pe cheia oaspetelui), NU în
       `scores`: acolo cheile sunt id-uri de profil, pe care le citesc și fereastra rapidă, și
       fuziunea guest→cont din baza de date. O foaie veche, fără aceste chei, nu e atinsă.
       EN: guest score/role/scoresheet were never sent. Separate keys keep `scores` uuid-only. */
    const guestScores = {};
    const guestRoles = {};
    const guestSs = {};
    guests.forEach(function (g) {
        if (!g || !g.key) return;
        const safeName = String(g.name || '').replace(/\s+/g, '-');       /* id DOM, ca în renderSessionPlayers */
        const tid = String(g.key).replace(/[^a-zA-Z0-9]/g, '-');
        const si = document.getElementById('score-guest-' + safeName);
        if (si && si.value !== '') guestScores[g.key] = Number(si.value) || 0;
        const ri = document.getElementById('role-guest-' + safeName);
        if (ri && ri.value) guestRoles[g.key] = ri.value;
        const cells = document.querySelectorAll('[id^="ssg-' + tid + '-"]');
        if (cells.length) {
            const arr = [];
            cells.forEach(function (c) {
                const idx = parseInt(String(c.id).split('-').pop(), 10);
                if (!isNaN(idx)) arr[idx] = Number(c.value) || 0;
            });
            guestSs[g.key] = arr;
        }
    });

    return { game: game, players: players, scores: scores, roles: roles, ss: ss,
             type: type, guests: guests, guestKeys: guestKeys,
             guestScores: guestScores, guestRoles: guestRoles, guestSs: guestSs,
             form: _collectSessionFormFields(type) };
}

/* ============================================================
   9.2 — RESTUL FORMULARULUI intră în foaie.
   RO: până acum foaia purta doar jocul, jucătorii, scorurile, rolurile și ceasurile.
       Data, ora, durata, locul, notițele, „amical", modul de scorare, departajările,
       câmpurile de turneu și legătura cu campania trăiau DOAR în memoria paginii —
       deci un refresh le ștergea, iar ceilalți nu le vedeau niciodată.
       Stau grupate sub cheia `form`, ca foile vechi (fără ea) să rămână valide.
   ⚠ Ce NU punem aici: emailul invitatului (§48 — foaia o citesc toți membrii) și
       pozele (fișiere, nu text; vin la pasul c).
   EN: the rest of the form now travels in the sheet, grouped under `form` so older
       sheets stay valid. Guest emails and photos stay out on purpose.
   ============================================================ */
function _collectSessionFormFields(type) {
    const v = function (id) { const e = document.getElementById(id); return e ? e.value : undefined; };
    const f = {};
    const date = v('sessionDate'); if (date !== undefined) f.date = date;
    const st = v('sessionStartTime'); if (st !== undefined) f.startTime = st;
    const du = v('sessionDuration'); if (du !== undefined) f.duration = du;
    const lo = v('sessionLocation'); if (lo !== undefined) f.location = lo;
    const no = v('sessionNotes'); if (no !== undefined) f.notes = no;
    const fr = document.getElementById('sessionFriendly'); if (fr) f.friendly = !!fr.checked;
    const sm = v('sessionScoreMode'); if (sm !== undefined) f.scoreMode = sm;
    const sd = v('sessionScoreDir'); if (sd !== undefined) f.scoreDir = sd;
    try {
        if (typeof sessionTieBreaks !== 'undefined' && sessionTieBreaks
            && Object.keys(sessionTieBreaks).length) f.tieBreaks = Object.assign({}, sessionTieBreaks);
    } catch (e) { logError('_collectSessionFormFields', e); }
    /* Câmpurile de turneu: în DOM există mereu, dar le trimitem doar dacă sesiunea E
       turneu sau dacă măcar unul e completat — altfel am umple fiecare foaie cu cinci
       câmpuri goale, fără niciun câștig. */
    const tour = { name: v('tournamentName'), prize: v('tournamentPrize'), format: v('tournamentFormat'),
                   rounds: v('tournamentRounds'), fee: v('tournamentFee') };
    const tourHasValue = Object.keys(tour).some(function (k) { return tour[k]; });
    if (type === 'tournament' || tourHasValue) f.tournament = tour;
    /* 9.3: doar CĂILE pozelor deja urcate. Fișierele încă nesalvate nu au ce căuta în
       foaie (nu sunt text) — ele rămân locale până la urcare sau până la salvare. */
    try {
        if (typeof sessionPhotoPaths !== 'undefined' && Array.isArray(sessionPhotoPaths)
            && sessionPhotoPaths.length) f.photos = sessionPhotoPaths.slice();
    } catch (e) { logError('_collectSessionFormFields.photos', e); }
    try {
        if (window._sessCampaignId) f.campaignId = String(window._sessCampaignId);
        const scn = v('sessionScenarioName'); if (scn !== undefined) f.scenario = scn;
    } catch (e) { logError('_collectSessionFormFields', e); }
    return f;
}

/* Scrie în formular câmpurile venite din foaie. Aceleași gărzi ca la scoruri: nu atingem
   câmpul de sub cursor și nici pe cel modificat local și neconfirmat încă. O cheie
   ABSENTĂ nu se atinge — `undefined` nu înseamnă „golește" (§65.5), și exact asta face
   foile vechi să funcționeze nemodificate. */
/* Golește câmpurile de formular la valorile implicite. Folosită DOAR la trecerea de la o
   masă live la alta, în timpul hidratării (deci fără să trimită nimic înapoi). */
function _resetSessionFormFields() {
    const set = function (id, val) { const e = document.getElementById(id); if (e) e.value = val; };
    const now = new Date();
    set('sessionDate', now.toISOString().split('T')[0]);
    set('sessionStartTime', now.toTimeString().slice(0, 5));
    set('sessionDuration', '');
    set('sessionLocation', '');
    set('sessionNotes', '');
    set('tournamentName', ''); set('tournamentPrize', ''); set('tournamentFormat', '');
    set('tournamentRounds', ''); set('tournamentFee', '');
    const fr = document.getElementById('sessionFriendly'); if (fr) fr.checked = false;
    /* 9.3: pozele altei mese nu au ce căuta aici. Nu le ștergem din Storage — masa
       cealaltă e vie și le mai folosește. */
    try { sessionPhotoPaths = []; sessionPhotoFiles = []; if (typeof renderSessionPhotoPreview === 'function') renderSessionPhotoPreview(); } catch (e) { logError('_resetSessionFormFields', e); }
    try { sessionTieBreaks = {}; } catch (e) { logError('_resetSessionFormFields', e); }
}

function _paintSessionFormFields(sheet, opts) {
    if (!sheet) return;
    const f = (sheet.form && typeof sheet.form === 'object') ? sheet.form : null;
    if (!f) return;
    opts = opts || {};
    const ae = document.activeElement;
    const put = function (id, val) {
        if (val === undefined || val === null) return;
        const el = document.getElementById(id);
        if (!el || el === ae || _isLiveDirty(el)) return;
        if (String(el.value) !== String(val)) el.value = val;
    };
    put('sessionDate', f.date);
    put('sessionStartTime', f.startTime);
    put('sessionDuration', f.duration);
    put('sessionLocation', f.location);
    put('sessionNotes', f.notes);
    const fr = document.getElementById('sessionFriendly');
    if (fr && fr !== ae && f.friendly !== undefined && fr.checked !== !!f.friendly) fr.checked = !!f.friendly;
    put('sessionScoreMode', f.scoreMode);
    put('sessionScoreDir', f.scoreDir);
    if (f.tieBreaks && typeof f.tieBreaks === 'object') {
        try { sessionTieBreaks = Object.assign({}, f.tieBreaks); } catch (e) { logError('_paintSessionFormFields', e); }
    }
    if (f.tournament && typeof f.tournament === 'object') {
        put('tournamentName', f.tournament.name);
        put('tournamentPrize', f.tournament.prize);
        put('tournamentFormat', f.tournament.format);
        put('tournamentRounds', f.tournament.rounds);
        put('tournamentFee', f.tournament.fee);
    }
    /* Campania: are propriul modul, cu scorare forțată și selector re-randat. Trecem prin
       intrarea lui publică în loc să-i atingem starea pe furiș. Doar la deschidere:
       o re-randare la fiecare eveniment realtime ar fura focusul din selector. */
    if (opts.initial) {
        try {
            if (f.campaignId && window.TO_CAMP && typeof TO_CAMP._onAttach === 'function'
                && String(window._sessCampaignId || '') !== String(f.campaignId)) {
                TO_CAMP._onAttach(String(f.campaignId));
            }
            if (f.scenario !== undefined) put('sessionScenarioName', f.scenario);
        } catch (e) { logError('_paintSessionFormFields.camp', e); }
    }
    /* Pozele: lista din foaie e sursa de adevăr pentru cele URCATE. Nu atingem fișierele
       încă nesalvate ale acestui dispozitiv — ele nu există la ceilalți. */
    if (Array.isArray(f.photos)) {
        const cur = (typeof sessionPhotoPaths !== 'undefined' && Array.isArray(sessionPhotoPaths)) ? sessionPhotoPaths : [];
        if (cur.join('|') !== f.photos.join('|')) {
            sessionPhotoPaths = f.photos.slice();
            if (typeof renderSessionPhotoPreview === 'function') {
                try { renderSessionPhotoPreview(); } catch (e) { logError('_paintSessionFormFields.photos', e); }
            }
        }
    }
    if (typeof renderTieBreakBar === 'function') { try { renderTieBreakBar(); } catch (e) { logError('_paintSessionFormFields.tb', e); } }
}
window._paintSessionFormFields = _paintSessionFormFields;
window.collectLiveSheet = collectLiveSheet;

/* Trimite foaia curentă în sesiunea live (dacă formularul e legat de una). */
/* ============================================================================
   ANTI-CURSĂ PE LISTA DE JUCĂTORI (roster)
   ----------------------------------------------------------------------------
   RO: `pushLiveSheet()` e amânat 700 ms. În fereastra aceea poate sosi prin
       realtime o foaie ÎNCĂ VECHE (ecoul unui push anterior, al meu sau al
       altcuiva). `syncSessionTabFromLive` o aplica necondiționat și îmi
       SUPRASCRIA lista locală — adică exact jucătorii pe care tocmai îi
       adăugasem dispăreau. A doua oară „rămâneau", pentru că între timp
       plecase și push-ul meu.
       Codul are DEJA fix această protecție pentru scoruri (`data-live-dirty`:
       „nu suprascriem un câmp a cărui valoare nu e cea confirmată de server").
       Lista de jucători pur și simplu nu o avea. I-o dăm, după același tipar.
       Supapă de siguranță: dacă serverul nu confirmă în 8 secunde, blocajul
       expiră singur, ca să nu rămânem niciodată surzi la modificările altora.
   EN: the 700ms debounce let a stale realtime echo overwrite the local roster.
       Same protection the score fields already have, applied to the roster,
       with an 8s safety expiry.
   ============================================================================ */
function _rosterKey() {
    try {
        var p = (typeof sessionPlayers !== 'undefined' && Array.isArray(sessionPlayers)) ? sessionPlayers.map(String) : [];
        var g = (typeof sessionGuests !== 'undefined' && Array.isArray(sessionGuests)) ? sessionGuests : [];
        return p.join('|') + '#' + g.map(function (x) { return (x && x.key) + ':' + (x && x.name); }).join('|');
    } catch (e) { return ''; }
}
window._rosterKey = _rosterKey;

/* Lista locală e mai nouă decât orice poate trimite serverul acum? */
function rosterLocked() {
    return !!window._liveRosterPending &&
        (Date.now() - (window._liveRosterPendingTs || 0) < 8000);
}
window.rosterLocked = rosterLocked;

function pushLiveSheet() {
    const ls = (typeof activeLiveSession === 'function') ? activeLiveSession() : null;
    if (!ls) return;
    /* În mod DOAR-VIZUALIZARE nu scriem NIMIC. Altfel, la simpla hidratare a paginii,
       `pickSessionGame` declanșa un push, serverul îl respingea corect (`insufficient_role`)
       și membrul primea „Nu ai permisiunea" fără să fi făcut nimic.
       Serverul se purta corect; clientul n-ar fi trebuit să încerce. */
    if (window._liveReadOnly) return;
    /* Anti PING-PONG: dacă tocmai hidratăm pagina cu o foaie PRIMITĂ de la altcineva,
       nu o trimitem înapoi. Doi editori și-ar fi retrimis reciproc aceeași foaie la
       nesfârșit, generând trafic și randări inutile. */
    if (window._liveHydrating) return;
    const canWrite = lsIAmHost(ls) || (typeof can === 'function' && can('live.manage'));
    if (!canWrite) return;
    /* Din acest moment lista locală e mai nouă decât ce poate ști serverul. */
    window._liveRosterPending = true;
    window._liveRosterPendingTs = Date.now();

    clearTimeout(_liveSheetPushTimer);
    _liveSheetPushTimer = setTimeout(function () {
        /* ⚠ 9.1 (sept. 2026): sesiunea `ls` e reținută la APEL, dar formularul se citește la
           DECLANȘARE, 700 ms mai târziu. Dacă între timp formularul s-a legat de ALTĂ sesiune
           (ai deschis altă masă) sau s-a dezlegat („Sesiune nouă", salvare), foaia citită nu
           mai e a lui `ls` — am fi scris masa B peste masa A, sau un formular gol peste A.
           Renunțăm: pierdem cel mult ultimele 0,7 s de tastare, nu o sesiune întreagă.
           EN: the form is read 700ms after the call; if it was rebound or unbound meanwhile,
           writing it would corrupt `ls`. Drop the push instead. */
        if (String(window._liveSessionId) !== String(ls.id)) { window._liveRosterPending = false; return; }
        const sheet = collectLiveSheet();
        const sentRoster = _rosterKey();   /* ce listă am trimis efectiv */

        /* Fotografiem câmpurile MURDARE și valoarea lor exactă, ca să știm ce anume
           confirmăm. Dacă utilizatorul mai tastează cât timp cererea e pe drum, câmpul
           rămâne murdar (valoarea s-a schimbat față de ce am trimis) — deci nu-l vom
           suprascrie cu răspunsul, care e deja învechit. */
        const snapshot = [];
        document.querySelectorAll('[data-live-dirty="1"]').forEach(function (el) {
            snapshot.push({ el: el, val: el.value });
        });

        lsSetSheet(ls.id, sheet).then(function (out) {
            if (!out) return;                       /* eroare -> câmpurile RĂMÂN murdare */
            ls.sheet = out;
            /* Deblocăm lista DOAR dacă între timp nu s-a mai schimbat local.
               Dacă utilizatorul a mai adăugat pe cineva cât timp cererea era pe
               drum, rămâne blocată — răspunsul e deja învechit. */
            if (_rosterKey() === sentRoster) window._liveRosterPending = false;
            snapshot.forEach(function (snap) {
                /* Curățăm doar câmpurile a căror valoare e chiar cea confirmată de server. */
                if (snap.el && snap.el.value === snap.val) delete snap.el.dataset.liveDirty;
            });
            renderLiveSessionsBar();
        });
    }, 700);
}
window.pushLiveSheet = pushLiveSheet;

/* Ascultător delegat: orice modificare în zona jucătorilor (scor, rol) se propagă.
   Delegat pe container, nu pe fiecare input — cardurile se re-randează des, iar
   listener-ele individuale s-ar pierde la fiecare redesenare.

   ★ MARCAJ „MURDAR" (bug real, pierdea scoruri tăcut):
   Între tastare și push trec 700ms (debounce). Dacă în fereastra aia soseau date de la
   server (oricine apasă Turn — se întâmplă constant), `refreshLiveTimersInDom` rescria
   câmpul cu valoarea VECHE — pentru că protejam doar câmpul FOCUSAT, iar tu tocmai
   trecuseși în alt câmp. Apoi debounce-ul citea DOM-ul și trimitea înapoi valoarea veche.
   Cifrele tale dispăreau, fără nicio eroare.
   Acum un câmp modificat local e „murdar" până când push-ul lui e CONFIRMAT de server.
   Câmpurile murdare nu sunt atinse de datele venite de la alții. */
function _markLiveDirty(el) {
    if (el && el.dataset) el.dataset.liveDirty = '1';
}
function _isLiveDirty(el) {
    return !!(el && el.dataset && el.dataset.liveDirty === '1');
}
window._isLiveDirty = _isLiveDirty;

/* ⚠ 9.1: `ssg-` = celulele foii de scor ale OASPEȚILOR; nu declanșau deloc trimiterea.
   EN: `ssg-` = guest scoresheet cells, which never triggered a push. */
document.addEventListener('input', function (e) {
    if (!e.target || !e.target.id) return;
    if (_isLiveSheetField(e.target.id)) { _markLiveDirty(e.target); pushLiveSheet(); }
}, true);
document.addEventListener('change', function (e) {
    if (!e.target || !e.target.id) return;
    if (_isLiveSheetField(e.target.id)) { _markLiveDirty(e.target); pushLiveSheet(); }
}, true);

/* 9.2: câmpurile de formular fac acum parte din foaie, deci tastarea în ele trebuie să
   declanșeze aceeași propagare ca un scor. Fără asta, ce scrii la „Locație" ar ajunge pe
   server doar din întâmplare, la următoarea atingere a unui scor.
   EN: form fields are part of the sheet now, so they must trigger the same push. */
const _LIVE_FORM_FIELDS = {
    sessionDate: 1, sessionStartTime: 1, sessionDuration: 1, sessionLocation: 1,
    sessionNotes: 1, sessionFriendly: 1, sessionScoreMode: 1, sessionScoreDir: 1,
    tournamentName: 1, tournamentPrize: 1, tournamentFormat: 1, tournamentRounds: 1,
    tournamentFee: 1, sessionScenarioName: 1
};
function _isLiveSheetField(id) {
    return /^(score|role|ss|ssg)-/.test(id) || _LIVE_FORM_FIELDS[id] === 1;
}

/* GARDĂ CENTRALĂ pentru modul „doar vizualizare".

   DE CE NU E DE AJUNS `disabled` PE ELEMENTE:
   `applyLiveReadOnly()` dezactivează elementele EXISTENTE, dar `renderSessionTimerPanel()`
   și lista de jucători RECREEAZĂ butoane după aceea — cele noi apar active. Mai rău:
   jucătorii se adaugă dintr-un `<div onclick>`, NU dintr-un `<button>`, deci scanarea
   nici nu-l atingea. Așa a putut un membru să adauge jucători și să apese „Stop & set duration".

   Sursa de adevăr devine FUNCȚIA, nu atributul din DOM. UI-ul rămâne gri pentru claritate,
   dar blocarea reală e aici (și, definitiv, în server). */
function liveWriteBlocked() {
    if (!window._liveReadOnly) return false;
    if (typeof showNotification === 'function') showNotification(t('live.readOnly'), 'info');
    return true;
}
window.liveWriteBlocked = liveWriteBlocked;

/* Sincronizează PAGINA de sesiune cu foaia live venită de la altcineva.
   `refreshLiveTimersInDom` acoperea doar ceasurile și scorurile — schimbarea JOCULUI
   sau a LISTEI DE JUCĂTORI nu ajungea niciodată în tab, de unde „le văd doar la refresh".

   Randăm din nou DOAR dacă s-a schimbat ceva STRUCTURAL (joc / jucători), fiindcă o
   re-randare recreează cardurile și ar putea fura focusul. Scorurile și ceasurile se
   actualizează in-place, fără reconstrucție. Focusul se restaurează după. */
function syncSessionTabFromLive(ls) {
    if (!ls || !document.getElementById('sessionPlayers')) return;
    const sheet = (ls.sheet && typeof ls.sheet === 'object') ? ls.sheet : {};

    const ae = document.activeElement;
    const focusId = (ae && ae.id) ? ae.id : null;
    const selStart = (ae && typeof ae.selectionStart === 'number') ? ae.selectionStart : null;

    let structural = false;

    /* Tipul sesiunii (standard / coop / turneu) — schimbă randarea grilei. */
    if (sheet.type && typeof setSessionType === 'function'
        && sheet.type !== currentSessionType) {
        window._liveHydrating = true;
        try { setSessionType(sheet.type); } catch (e) { logError('syncSessionTabFromLive', e); }
        finally { window._liveHydrating = false; }
        structural = true;
    }

    /* Jocul */
    const gameSel = document.getElementById('sessionGame');
    const curGame = (gameSel && gameSel.value) || '';
    const newGame = sheet.game || '';
    if (newGame !== curGame) {
        window._liveHydrating = true;   /* hidratare programatică -> nu declanșa push înapoi */
        try {
            if (newGame && typeof pickSessionGame === 'function') pickSessionGame(newGame);
            else if (!newGame && typeof clearSessionGame === 'function') clearSessionGame();
        } catch (e) { logError('syncSessionTabFromLive', e); }
        finally { window._liveHydrating = false; }
        structural = true;
    }

    /* Jucătorii */
    const incoming = Array.isArray(sheet.players) ? sheet.players.map(String) : [];
    const current = (typeof sessionPlayers !== 'undefined' && Array.isArray(sessionPlayers))
        ? sessionPlayers.map(String) : [];
    const gIn = (Array.isArray(sheet.guests) ? sheet.guests : []).map(g => g.key + ':' + g.name).join('|');
    const gCur = ((typeof sessionGuests !== 'undefined' && sessionGuests) ? sessionGuests : []).map(g => g.key + ':' + g.name).join('|');

    /* Nu suprascriem lista dacă a mea e mai nouă și încă neconfirmată. */
    if (!rosterLocked() && (incoming.join('|') !== current.join('|') || gIn !== gCur)) {
        sessionPlayers = incoming.slice();
        if (Array.isArray(sheet.guests)) {
            sessionGuests = sheet.guests.map(g => ({ key: g.key, name: g.name }));
            /* 9.2: lista tocmai a fost refăcută din foaie, care NU poartă emailuri (§48);
               le punem la loc din magazia locală, altfel salvarea le-ar cere degeaba. */
            try { if (ls.id) _gemRestore(ls.id); } catch (e) { logError('syncSessionTabFromLive.gem', e); }
        }
        if (typeof renderSessionPlayers === 'function') renderSessionPlayers();
        structural = true;
    }

    /* Scoruri, roluri, ceasuri — in-place, fără să atingem câmpul de sub cursor. */
    refreshLiveTimersInDom();
    _paintSessionFormFields(sheet);   /* 9.2: și restul formularului vine de la ceilalți */
    if (window._liveReadOnly && typeof applyLiveReadOnly === 'function') applyLiveReadOnly();

    /* Restaurăm focusul dacă re-randarea l-a pierdut. */
    if (structural && focusId) {
        const el = document.getElementById(focusId);
        if (el && typeof el.focus === 'function') {
            el.focus();
            if (selStart !== null && typeof el.setSelectionRange === 'function') {
                try { el.setSelectionRange(selStart, selStart); } catch (e) { /* input fără selecție */ }
            }
        }
    }
}
window.syncSessionTabFromLive = syncSessionTabFromLive;

/* Actualizează ceasurile, butoanele Turn și scorurile ALTORA — DIRECT ÎN DOM,
   fără să reconstruiască cardurile.

   DE CE E ESENȚIAL: `renderSessionPlayers()` recreează tot HTML-ul, deci ștergea
   inputul în care tocmai scriai scorul (pierdeai focusul și cifrele). Update-urile
   de timer vin des (la fiecare Turn al oricui), deci o reconstrucție ar fi făcut
   scrierea scorului practic imposibilă.
   Regula: NU atingem niciodată un câmp aflat sub cursorul utilizatorului. */
function refreshLiveTimersInDom() {
    const act = activeTurnKey();
    const ls = (typeof activeLiveSession === 'function') ? activeLiveSession() : null;
    const sheet = (ls && ls.sheet && typeof ls.sheet === 'object') ? ls.sheet : null;

    document.querySelectorAll('button[data-player]').forEach(function (btn) {
        const key = btn.dataset.player;
        if (!key) return;
        const tid = String(key).replace(/[^a-zA-Z0-9]/g, '-');

        const el = document.getElementById('ptimer-' + tid);
        if (el) el.textContent = fmtClock(playerElapsedMs(key));

        const isActive = (String(act) === String(key));
        btn.classList.toggle('btn-primary', isActive);
        btn.classList.toggle('btn-secondary', !isActive);
        btn.innerHTML = '<i class="fas fa-' + (isActive ? 'pause' : 'play') + '"></i> '
                      + (isActive ? t('session.turnActive') : t('session.turn'));
    });

    /* Scorurile și rolurile scrise de ALTCINEVA: le reflectăm, dar NICIODATĂ în câmpul
       aflat sub cursor (altfel i-am rescrie cifrele sub degete). */
    if (sheet) {
        const scores = sheet.scores || {};
        const roles = sheet.roles || {};
        const ssMap = sheet.ss || {};
        const keys = new Set(Object.keys(scores).concat(Object.keys(roles)).concat(Object.keys(ssMap)));
        keys.forEach(function (pid) {
            const safe = String(pid).replace(/[^a-zA-Z0-9]/g, '-');   /* id DOM = profile_id */

            /* ⚠ NU atingem un câmp MURDAR (modificat local, încă neconfirmat de server).
               Protejam doar câmpul FOCUSAT — insuficient: tastai un scor, treceai la alt
               câmp (deci pierdea focusul), iar un eveniment realtime sosit înainte de
               debounce-ul de 700ms îi rescria valoarea VECHE. Apoi push-ul citea DOM-ul
               și trimitea valoarea veche => cifrele tale dispăreau TĂCUT.
               `dirty` se ridică la tastare și cade doar când serverul confirmă exact
               acea valoare. */
            const si = document.getElementById('score-' + safe);
            if (si && si !== document.activeElement && !_isLiveDirty(si) && scores[pid] !== undefined) {
                const v = String(scores[pid]);
                if (si.value !== v) si.value = v;
            }
            const ri = document.getElementById('role-' + safe);
            if (ri && ri !== document.activeElement && !_isLiveDirty(ri) && roles[pid] !== undefined) {
                const rv = String(roles[pid]);
                if (ri.value !== rv) ri.value = rv;
            }

            /* Foaia de scor: completăm celulele, apoi lăsăm `recalcScoresheet` să
               refacă Total-ul — ca la clientul care a scris. */
            const cells = ssMap[pid];
            if (Array.isArray(cells)) {
                let touched = false;
                cells.forEach(function (v, i) {
                    const c = document.getElementById('ss-' + safe + '-' + i);
                    if (c && c !== document.activeElement && !_isLiveDirty(c) && String(c.value) !== String(v)) {
                        c.value = v; touched = true;
                    }
                });
                if (touched && typeof recalcScoresheet === 'function') {
                    try { recalcScoresheet(safe); } catch (e) { logError('refreshLiveTimersInDom', e); }
                }
            }
        });
        _paintLiveGuestValues(sheet);
    }
}
window.refreshLiveTimersInDom = refreshLiveTimersInDom;

/* ⚠ 9.1 (sept. 2026): valorile OASPEȚILOR din foaie -> câmpuri, cu ACELEAȘI gărzi ca la
   jucătorii cu cont: nu atingem câmpul focusat și nici pe cel MURDAR (modificat local,
   neconfirmat). O cheie absentă (foaie veche, dinainte de deploy) = nu atingem nimic —
   `undefined` nu înseamnă „șterge" (§65.5).
   EN: paints guest values with the same focus/dirty guards; missing keys are left alone. */
function _paintLiveGuestValues(sheet) {
    if (!sheet) return;
    const gs = (sheet.guestScores && typeof sheet.guestScores === 'object') ? sheet.guestScores : null;
    const gr = (sheet.guestRoles && typeof sheet.guestRoles === 'object') ? sheet.guestRoles : null;
    const gss = (sheet.guestSs && typeof sheet.guestSs === 'object') ? sheet.guestSs : null;
    if (!gs && !gr && !gss) return;
    const list = (typeof sessionGuests !== 'undefined' && Array.isArray(sessionGuests)) ? sessionGuests : [];
    const ae = document.activeElement;
    list.forEach(function (g) {
        if (!g || !g.key) return;
        const safeName = String(g.name || '').replace(/\s+/g, '-');
        const tid = String(g.key).replace(/[^a-zA-Z0-9]/g, '-');
        const si = document.getElementById('score-guest-' + safeName);
        if (gs && gs[g.key] !== undefined && si && si !== ae && !_isLiveDirty(si)) {
            const v = String(gs[g.key]);
            if (si.value !== v) si.value = v;
        }
        const ri = document.getElementById('role-guest-' + safeName);
        if (gr && gr[g.key] !== undefined && ri && ri !== ae && !_isLiveDirty(ri)) {
            const rv = String(gr[g.key]);
            if (ri.value !== rv) ri.value = rv;
        }
        const cells = gss ? gss[g.key] : null;
        if (Array.isArray(cells)) {
            let touched = false;
            cells.forEach(function (v, i) {
                const c = document.getElementById('ssg-' + tid + '-' + i);
                if (c && c !== ae && !_isLiveDirty(c) && String(c.value) !== String(v)) { c.value = v; touched = true; }
            });
            if (touched && typeof recalcGuestScoresheet === 'function') {
                try { recalcGuestScoresheet(tid, safeName); } catch (e) { logError('_paintLiveGuestValues', e); }
            }
        }
    });
}

/* Cheia de ceas într-o sesiune live.
   Jucător cu cont -> `<uuid>`.  Oaspete -> `guest:<cheie>`.
   Oaspeții n-au profile_id, dar au dreptul la timp: host-ul/adminul le apasă ceasul
   (au oricum dreptul de a acționa ceasul oricui). Prefixul face coliziunea imposibilă. */
const _UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function liveClockKey(tkey) {
    const k = String(tkey || '');
    return _UUID_RE.test(k) ? k : ('guest:' + k);
}
function liveClockKeyToDom(k) {
    const s0 = String(k || '');
    return s0.indexOf('guest:') === 0 ? s0.slice(6) : s0;
}
window.liveClockKey = liveClockKey;
window.liveClockKeyToDom = liveClockKeyToDom;

/* Cine are Turn-ul ACUM, în sesiunea legată (sau local, dacă nu suntem în live). */
function activeTurnKey() {
    const ls = (typeof activeLiveSession === 'function') ? activeLiveSession() : null;
    if (ls) {
        const tm = (ls.timers && typeof ls.timers === 'object') ? ls.timers : {};
        const k = Object.keys(tm).find(x => x !== '__session' && tm[x] && tm[x].running);
        return k ? liveClockKeyToDom(k) : null;   /* cheia DOM, fără prefixul `guest:` */
    }
    return liveTimer.activePlayer;
}
window.activeTurnKey = activeTurnKey;

/* Cronometrul GENERAL rulează? */
function sessionClockRunning() {
    const ls = (typeof activeLiveSession === 'function') ? activeLiveSession() : null;
    if (ls) {
        const t0 = (ls.timers || {})['__session'];
        return !!(t0 && t0.running);
    }
    return !!liveTimer.sessionRunning;
}
window.sessionClockRunning = sessionClockRunning;

function sessionElapsedMs() {
    const ls = (typeof activeLiveSession === 'function') ? activeLiveSession() : null;
    if (ls) return liveTimerMs((ls.timers || {})['__session']);   /* per-sesiune */
    return liveTimer.sessionAccumMs + (liveTimer.sessionRunning ? (Date.now() - liveTimer.sessionStartTs) : 0);
}

function playerElapsedMs(name) {
    const ls = (typeof activeLiveSession === 'function') ? activeLiveSession() : null;
    if (ls) {
        const tm = (ls.timers && typeof ls.timers === 'object') ? ls.timers : {};
        const lk = liveClockKey(name);   /* oaspete -> `guest:<key>` */
        if (Object.prototype.hasOwnProperty.call(tm, lk)) return liveTimerMs(tm[lk]);
        /* Jucător fără ceas în ACEASTĂ sesiune -> 0. NU cădem pe `liveTimer`,
           altfel am afișa timpul lui din ALTĂ sesiune. Ăsta era bug-ul. */
        return 0;
    }
    return (liveTimer.playerAccumMs[name] || 0) + (liveTimer.activePlayer === name ? (Date.now() - liveTimer.playerStartTs) : 0);
}
function ensureTimerInterval() { if (!liveTimer.interval) liveTimer.interval = setInterval(timerTick, 1000); }
function maybeStopInterval() {
    if (sessionClockRunning() || activeTurnKey()) return;   /* mai curge ceva -> tick-ul rămâne */
    if (liveTimer.interval) { clearInterval(liveTimer.interval); liveTimer.interval = null; }
}
function timerTick() {
    const sd = document.getElementById('sessionTimerDisplay'); if (sd) sd.textContent = fmtClock(sessionElapsedMs());
    const act = activeTurnKey();   /* din sesiunea LEGATĂ, nu din oglinda globală */
    if (act) {
        const el = document.getElementById('ptimer-' + String(act).replace(/[^a-zA-Z0-9]/g, '-'));
        if (el) el.textContent = fmtClock(playerElapsedMs(act));
    }
}
function bankActivePlayer() {
    if (liveTimer.activePlayer) {
        const n = liveTimer.activePlayer;
        liveTimer.playerAccumMs[n] = (liveTimer.playerAccumMs[n] || 0) + (Date.now() - liveTimer.playerStartTs);
    }
}
/* Start/Pause pe CRONOMETRUL GLOBAL, în modul live -> server (nu stare locală).
   Altfel s-ar desincroniza: următorul update prin realtime le-ar suprascrie. */
async function lsSessionClock(sessionId, running) {
    if (isDemoMode() || !sb || !sessionId) return null;
    const r = await sb.rpc('ls_session_clock', { p_id: sessionId, p_running: !!running });
    if (r.error) { showNotification(t('live.errTimer') + r.error.message, 'error'); return null; }
    const out = r.data || {};
    _lsNoteServerNow(out.now);
    const s = (state.liveSessions || []).find(x => String(x.id) === String(sessionId));
    if (s && out.timers) {
        s.timers = out.timers;
        if (String(window._liveSessionId) === String(sessionId)) {   /* vezi nota din lsPressClock */
            applyLiveTimersToLocal(s);
            if (typeof refreshLiveTimersInDom === 'function' && document.getElementById('sessionPlayers')) refreshLiveTimersInDom();
        }
        renderLiveSessionsBar();
    }
    return out.timers || null;
}
window.lsSessionClock = lsSessionClock;

function startSessionTimer() {
    if (liveWriteBlocked()) return;
    if (!requireFeature('timer')) return;
    /* §2: în sesiune live, cronometrul global e ținut de SERVER (toți îl văd la fel). */
    const _ls = (typeof activeLiveSession === 'function') ? activeLiveSession() : null;
    if (_ls) { lsSessionClock(_ls.id, true); return; }
    if (liveTimer.sessionRunning) return;
    liveTimer.sessionRunning = true; liveTimer.sessionStartTs = Date.now();
    ensureTimerInterval(); renderSessionTimerPanel(); pushTimerState();
}
function pauseSessionTimer() {
    if (liveWriteBlocked()) return;
    const _ls = (typeof activeLiveSession === 'function') ? activeLiveSession() : null;
    if (_ls) { lsSessionClock(_ls.id, false); return; }
    if (!liveTimer.sessionRunning) return;
    liveTimer.sessionAccumMs = sessionElapsedMs(); liveTimer.sessionRunning = false;
    bankActivePlayer(); liveTimer.activePlayer = null;
    maybeStopInterval(); renderSessionTimerPanel(); renderSessionPlayers(); pushTimerState();
}
function stopSessionTimer() {
    if (liveWriteBlocked()) return;
    liveTimer.sessionAccumMs = sessionElapsedMs(); liveTimer.sessionRunning = false;
    bankActivePlayer(); liveTimer.activePlayer = null; maybeStopInterval();
    const mins = Math.round(liveTimer.sessionAccumMs / 60000);
    const dur = document.getElementById('sessionDuration'); if (dur && mins > 0) dur.value = mins;
    renderSessionTimerPanel(); renderSessionPlayers(); pushTimerState();
    showNotification(t('m1.timerStopped').replace('{mins}', mins), 'success');
}
function setActivePlayer(name) {
    /* Singura acțiune permisă în modul doar-vizualizare: PROPRIUL cronometru. */
    if (window._liveReadOnly) {
        const _me = String((state.currentUser && state.currentUser.id) || '');
        if (String(name) !== _me) { showNotification(t('live.readOnly'), 'info'); return; }
    }
    if (!requireFeature('timer')) return;

    /* §2: dacă lucrăm într-o SESIUNE LIVE, „Turn" nu mai e o stare locală — e o
       operație pe server (`ls_press_clock`), vizibilă instant tuturor jucătorilor.
       Astfel butonul din formular și cel din foaia live fac EXACT același lucru,
       pe aceeași sursă de adevăr. Fără asta, am fi avut două cronometre paralele
       care se contrazic.
       Oaspeții (fără cont) nu au profile_id => rămân pe cronometrul local. */
    const ls = (typeof activeLiveSession === 'function') ? activeLiveSession() : null;
    if (ls) {
        const lk = liveClockKey(name);
        const players = (ls.sheet && Array.isArray(ls.sheet.players)) ? ls.sheet.players.map(String) : [];
        const guests = (ls.sheet && Array.isArray(ls.sheet.guestKeys)) ? ls.sheet.guestKeys.map(String) : [];
        if (players.indexOf(lk) !== -1 || guests.indexOf(lk) !== -1) { lsPressClock(ls.id, lk); return; }
    }

    if (liveTimer.activePlayer === name) { bankActivePlayer(); liveTimer.activePlayer = null; maybeStopInterval(); renderSessionPlayers(); pushTimerState(); return; }
    bankActivePlayer();
    liveTimer.activePlayer = name; liveTimer.playerStartTs = Date.now();
    if (!liveTimer.sessionRunning) { liveTimer.sessionRunning = true; liveTimer.sessionStartTs = Date.now(); }
    ensureTimerInterval(); renderSessionTimerPanel(); renderSessionPlayers(); pushTimerState();
}
function setActivePlayerFromBtn(btn) { if (btn && btn.dataset) setActivePlayer(btn.dataset.player); }
function resetLiveTimer() {
    if (liveTimer.interval) clearInterval(liveTimer.interval);
    liveTimer = { sessionRunning: false, sessionAccumMs: 0, sessionStartTs: 0, activePlayer: null, playerAccumMs: {}, playerStartTs: 0, interval: null };
    renderSessionTimerPanel();
}
/* ============================================================
   §2 batch C — TURN-ul, sincronizat între formular și sesiunea live.

   O SINGURĂ SURSĂ DE ADEVĂR: `live_sessions.timers` (server).
   Nu duplicăm logica de cronometru: rehidratăm obiectul LOCAL `liveTimer` din ea,
   astfel încât `playerElapsedMs()`, `timerTick()` și randarea existentă să meargă
   NEMODIFICATE. Butonul „Turn" din formular și cel din foaia live apasă același
   RPC și produc exact același efect.

   DECALAJ DE CEAS: `startedAt` vine cu ora SERVERULUI. Telefoanele au ceasuri
   diferite; dacă am compara cu `Date.now()` direct, timpul afișat ar fi greșit pe
   dispozitivele decalate. Ținem un offset și corectăm.
   ============================================================ */
let _lsClockOffset = 0;   /* Date.now() - ora serverului (ms) */

function _lsNoteServerNow(serverNowMs) {
    if (typeof serverNowMs === 'number' && serverNowMs > 0) {
        _lsClockOffset = Date.now() - serverNowMs;
    }
}

/* Apasă „Turn" (ceas de șah): oprește ceasul activ, îl pornește pe al meu.
   Excludere mutuală impusă SERVER-SIDE — un jucător nu poate seta timpul altuia,
   poate doar să oprească ceasul activ apăsându-l pe al lui. */
async function lsPressClock(sessionId, playerId) {
    if (isDemoMode() || !sb || !sessionId) return null;
    /* `p_player` = pe cine apăsăm. NULL => pe mine.
       Serverul verifică: ceasul ALTCUIVA doar dacă sunt host sau admin. */
    const r = await sb.rpc('ls_press_clock', { p_id: sessionId, p_player: playerId || null });
    if (r.error) { showNotification(t('live.errTimer') + r.error.message, 'error'); return null; }
    const out = r.data || {};
    _lsNoteServerNow(out.now);

    const s = (state.liveSessions || []).find(x => String(x.id) === String(sessionId));
    if (s && out.timers) {
        s.timers = out.timers;
        /* ⚠ `liveTimer` (obiectul LOCAL) e UNUL SINGUR, dar sesiunile live sunt N.
           Proiectăm în el DOAR sesiunea legată de formular. Altfel, apăsând Turn în
           foaia sesiunii B, timerele lui B ajungeau în formularul deschis pe A —
           datele din DB rămâneau corecte, dar UI-ul mințea. */
        if (String(window._liveSessionId) === String(sessionId)) {
            applyLiveTimersToLocal(s);
            if (typeof refreshLiveTimersInDom === 'function' && document.getElementById('sessionPlayers')) refreshLiveTimersInDom();
        }
        renderLiveSheetIfOpen();
        renderLiveSessionsBar();
    }
    return out.timers || null;
}
window.lsPressClock = lsPressClock;

/* Proiectează timerele sesiunii live în obiectul LOCAL `liveTimer`.
   De aici încolo, tot codul existent de randare/tick funcționează ca înainte —
   doar că datele vin din server, nu din memoria locală. */
/* NU mai OGLINDIM timpii în `liveTimer` — afișarea îi citește direct din sesiune
   (vezi playerElapsedMs / sessionElapsedMs). Oglinda era exact sursa amestecului
   între sesiuni. Aici rămâne doar: pornirea/oprirea tick-ului de 1s și redesenarea. */
function applyLiveTimersToLocal(s) {
    if (!s) return;
    if (sessionClockRunning() || activeTurnKey()) ensureTimerInterval(); else maybeStopInterval();
    if (typeof renderSessionTimerPanel === 'function' && document.getElementById('sessionTimerPanel')) renderSessionTimerPanel();
}
window.applyLiveTimersToLocal = applyLiveTimersToLocal;

/* Sesiunea live „în lucru" în formular (dacă există). */
function activeLiveSession() {
    if (!window._liveSessionId) return null;
    return (state.liveSessions || []).find(x => String(x.id) === String(window._liveSessionId)) || null;
}
window.activeLiveSession = activeLiveSession;

/* Timpul afișat = timpul BANCAT + secundele scurse de la pornire.
   Serverul stochează doar `elapsed` + `startedAt`; secundele care curg le calculează
   fiecare client local. Altfel ar însemna o scriere în DB pe SECUNDĂ. */
function liveTimerMs(tmr) {
    if (!tmr) return 0;
    const base = (Number(tmr.elapsed) || 0) * 1000;
    if (tmr.running && tmr.startedAt) {
        const startedLocal = Number(tmr.startedAt) + _lsClockOffset;
        return base + Math.max(0, Date.now() - startedLocal);
    }
    return base;
}
window.liveTimerMs = liveTimerMs;

/* Tick local la 1s: actualizează DOAR textul ceasurilor care rulează.
   Nu re-randăm tot modalul (ar fura focusul din inputuri și ar face UI-ul să pâlpâie). */
let _liveTickInterval = null;
function ensureLiveTick() {
    const anyRunning = (state.liveSessions || []).some(function (s) {
        const tm = (s.timers && typeof s.timers === 'object') ? s.timers : {};
        return Object.keys(tm).some(k => tm[k] && tm[k].running);
    });
    if (anyRunning && !_liveTickInterval) {
        _liveTickInterval = setInterval(liveTick, 1000);
    } else if (!anyRunning && _liveTickInterval) {
        clearInterval(_liveTickInterval); _liveTickInterval = null;
    }
}
window.ensureLiveTick = ensureLiveTick;

function liveTick() {
    document.querySelectorAll('.live-clock[data-lsid][data-pid]').forEach(function (el) {
        const s = (state.liveSessions || []).find(x => String(x.id) === el.dataset.lsid);
        if (!s) return;
        const tm = (s.timers && typeof s.timers === 'object') ? s.timers : {};
        const t0 = tm[el.dataset.pid];
        if (!t0 || !t0.running) return;
        const txt = el.querySelector('.live-clock-txt');
        if (txt) txt.textContent = fmtClock(liveTimerMs(t0));
    });
}

/* ============================================================
   §2 — Bara „Sesiuni live acum" (batch B).
   Pe DASHBOARD (nu în tab-ul Sesiune, care e gardat pe `session.create` și deci
   invizibil pentru membrii simpli). Oricine vede sesiunile; doar Moderator+ deschide.
   ============================================================ */
function renderLiveSessionsBar() {
    const box = document.getElementById('liveSessionsBar');
    if (!box) return;
    if (typeof isDemoMode === 'function' && isDemoMode()) { box.innerHTML = ''; return; }
    /* Gating pe plan. ⚠ Folosea feature-ul `timer`, ceea ce era greșit: pe Starter
       modalul de upgrade vorbea despre CRONOMETRU când tu voiai o SESIUNE LIVE.
       Acum are cheia lui, `liveSessions` (tot de la Basic în sus).
       Ascundem bara complet dacă planul nu o include — altfel butonul ar apărea,
       dar apăsarea lui ar eșua în `requireFeature`. */
    if (typeof planAllows === 'function' && !planAllows('liveSessions')) { box.innerHTML = ''; return; }

    const list = (state.liveSessions || []);
    const canOpen = (typeof can === 'function' && can('session.create'));

    if (!list.length) {
        box.innerHTML = canOpen
            ? `<div class="live-bar empty">
                   <span><i class="fas fa-satellite-dish"></i> ${t('live.noneNow')}</span>
                   <button class="btn btn-sm btn-primary" onclick="openLiveSessionFromSheet(true)">
                       <i class="fas fa-dice"></i> ${t('live.startBtn')}
                   </button>
               </div>`
            : '';
        return;
    }

    const cards = list.map(function (s) {
        const sheet = (s.sheet && typeof s.sheet === 'object') ? s.sheet : {};
        const game = sheet.game || t('live.untitled');
        const host = (typeof memberById === 'function' && memberById(s.host_id)) || null;
        const hostName = (host && (host.displayName || host.name)) || t('live.someone');
        /* ⚠ 9.1: contorul număra DOAR jucătorii cu cont — o masă cu 2 membri și 1 invitat
           arăta „2 jucători". Invitații stau la aceeași masă, deci intră în contor.
           `guestKeys` e sursa de adevăr (o intrare per invitat cu cheie); dacă lipsește
           (foaie veche), cădem pe `guests`.
           EN: the counter ignored guests; they sit at the same table, so count them. */
        const nGuests = Array.isArray(sheet.guestKeys) ? sheet.guestKeys.length
                      : (Array.isArray(sheet.guests) ? sheet.guests.length : 0);
        const nPlayers = (Array.isArray(sheet.players) ? sheet.players.length : 0) + nGuests;
        const nTimers = (s.timers && typeof s.timers === 'object') ? Object.keys(s.timers).length : 0;
        const mine = lsIAmHost(s);
        /* Poate ÎNCHIDE sesiunea: host-ul sau Moderator+ (identic cu regula din `ls_close`). */
        /* Modifică/închide: DOAR host-ul sau un admin. Identic cu regula server-side
           (`ls_close`), ca UI-ul să nu promită ce DB-ul refuză. */
        const canEnd = mine || (typeof can === 'function' && can('live.manage'));
        const me = (state.currentUser && state.currentUser.id) || '';
        const iPlay = Array.isArray(sheet.players) && sheet.players.map(String).indexOf(String(me)) !== -1;

        return `<div class="live-card${mine ? ' mine' : ''}">
            <div class="live-card-main" role="button" tabindex="0"
                 onclick="openLiveCard('${attrJs(s.id)}')"
                 onkeydown="if(event.key==='Enter'){openLiveCard('${attrJs(s.id)}');}">
                <div class="live-card-top">
                    <span class="live-dot"></span>
                    <strong>${escHtml(game)}</strong>
                    ${mine ? `<span class="live-tag">${t('live.youHost')}</span>` : ''}
                    ${(!mine && iPlay) ? `<span class="live-tag playing">${t('live.youPlay')}</span>` : ''}
                </div>
                <small class="live-card-meta">
                    <i class="fas fa-user"></i> ${escHtml(hostName)}
                    &middot; <i class="fas fa-users"></i> ${nPlayers}
                    ${nTimers ? ` &middot; <i class="fas fa-stopwatch"></i> ${nTimers}` : ''}
                </small>
            </div>
            <div class="live-actions">
                <button class="live-act" title="${t('live.viewBtn')}" aria-label="${t('live.viewBtn')}"
                        onclick="openLiveCard('${attrJs(s.id)}', true); event.stopPropagation();">
                    <i class="fas fa-eye"></i>
                </button>
                ${canEnd ? `<button class="live-act danger" title="${t('live.endBtn')}" aria-label="${t('live.endBtn')}"
                        onclick="endLiveSession('${attrJs(s.id)}'); event.stopPropagation();">
                    <i class="fas fa-stop"></i>
                </button>` : ''}
            </div>
        </div>`;
    }).join('');

    ensureLiveTick();
    box.innerHTML = `<div class="live-bar">
        <div class="live-bar-head">
            <span><i class="fas fa-satellite-dish"></i> ${t('live.nowTitle')} (${list.length})</span>
            ${canOpen ? `<button class="btn btn-sm btn-primary" onclick="openLiveSessionFromSheet(true)">
                <i class="fas fa-dice"></i> ${t('live.startBtn')}
            </button>` : ''}
        </div>
        <div class="live-cards">${cards}</div>
    </div>`;
}
window.renderLiveSessionsBar = renderLiveSessionsBar;

/* Publică foaia curentă ca sesiune live (batch B: doar publicarea; foaia completă
   și timerele personale vin în batch-ul C). */
/* `blank = true` -> sesiune NOUĂ și GOALĂ (butonul din bara de pe DASHBOARD).
   `blank` fals    -> folosește formularul completat (butonul din TAB-ul Sesiune).

   ⚠ BUG-UL REPARAT: butonul din dashboard citea `collectLiveSheet()`, adică FORMULARUL —
   care, tab-ul fiind doar ASCUNS (nu golit), mai conținea jocul și jucătorii sesiunii
   precedente. Rezultat: a doua sesiune „live" pornea ca o COPIE a primei. Și a treia. */
async function openLiveSessionFromSheet(blank) {
    if (typeof requireWritableClub === 'function' && !requireWritableClub()) return;
    /* ⚠ `liveSessions`, nu `timer` — vezi nota din `FEATURE_MIN_PLAN`. */
    if (typeof requireFeature === 'function' && !requireFeature('liveSessions')) return;

    /* Din dashboard: golim formularul ÎNAINTE de a citi foaia, ca sesiunea nouă să
       pornească de la zero — nu cu resturile celei anterioare. */
    if (blank && typeof clearSessionForm === 'function') clearSessionForm();

    /* ⚠ Construiam foaia DE MÂNĂ aici, în paralel cu `collectLiveSheet()`. Cele două
       copii au divergat: asta nu includea `guests`/`guestKeys`, deci serverul nu găsea
       oaspetele la masă (`not_a_player`) și ceasul lui nu pornea.
       O SINGURĂ sursă a foii, folosită peste tot. */
    const sheet = collectLiveSheet();
    const id = await lsOpen(sheet);
    if (!id) return;

    /* ⚠ RESET COMPLET al stării locale de cronometru.
       Fără asta, `liveTimer.playerAccumMs` păstra timpii din sesiunea ANTERIOARĂ și
       formularul îi afișa în sesiunea NOUĂ (dispăreau abia la primul Turn, care
       rescria cheia). O sesiune nouă trebuie să fie nouă în TOATE câmpurile ei. */
    resetLiveTimer();

    window._liveSessionId = id;
    _liveLastRemember(id);  /* 9.2: un refresh ne aduce înapoi la masa asta */
    syncGoLiveBtn();        /* sesiunea a devenit live -> butonul nu mai are ce oferi */
    startLiveHeartbeat();   /* puls global: acoperă toate sesiunile pe care le găzduiesc */

    /* Proiectăm starea REALĂ a sesiunii proaspete (timers = {}) -> ceasuri la zero. */
    const fresh = (state.liveSessions || []).find(x => String(x.id) === String(id));
    if (fresh) applyLiveTimersToLocal(fresh);

    if (typeof renderSessionPlayers === 'function' && document.getElementById('sessionPlayers')) renderSessionPlayers();
    if (typeof renderSessionTimerPanel === 'function') renderSessionTimerPanel();
    renderLiveSessionsBar();

    /* Pornită din dashboard -> ducem utilizatorul în tab-ul Sesiune, ca s-o completeze.
       `_liveHydrating` împiedică `renderSessionForm` să dezlege sesiunea proaspăt creată. */
    if (blank && typeof switchTab === 'function') {
        window._liveHydrating = true;
        switchTab('session');
        setTimeout(function () { window._liveHydrating = false; }, 0);
    }

    showNotification(t('live.started'), 'success');
}
window.openLiveSessionFromSheet = openLiveSessionFromSheet;

/* Click pe card:
     • Host / Moderator+  -> tab-ul SESIUNE, cu jocul și jucătorii ÎNCĂRCAȚI, ca să
                             poată modifica informațiile sesiunii de acolo.
     • Membru simplu      -> foaia read-only + butonul lui de Turn (tab-ul Sesiune
                             e gardat pe `session.create`, deci nici nu-l vede).
   Aceeași apăsare, două destinații — după ce poți face, nu după cine ești. */
/* Deschide sesiunea în PAGINA de sesiune (tab-ul Sesiune), cu toate informațiile.
   `forceRead` = venim de pe butonul-ochi: pagina completă, dar READ-ONLY.
   Fără el: host/admin -> editabil; ceilalți -> pop-up-ul rapid. */
function openLiveCard(sessionId, forceRead) {
    const s = (state.liveSessions || []).find(x => String(x.id) === String(sessionId));
    if (!s) { showNotification(t('live.notFound'), 'error'); return; }

    const canEdit = !forceRead && (lsIAmHost(s) || (typeof can === 'function' && can('live.manage')));
    if (!canEdit && !forceRead) { openLiveSheet(sessionId); return; }   /* pop-up rapid */

    /* 9.1: redeschidem CHIAR sesiunea deja legată? Atunci câmpurile pot avea tastare
       încă netrimisă (murdară) și nu le ștergem. Altfel pornim de la carduri curate.
       EN: re-opening the already-bound session keeps unsent typing. */
    const _sameSession = String(window._liveSessionId) === String(s.id);
    /* 9.1: intrăm într-o sesiune live VIE -> garda anti-dublare se stinge. */
    window._liveSavedElsewhereId = null;
    window._liveSavedElsewhereMatch = null;
    /* 9.2: reținem ce masă avem deschisă, ca un refresh să ne aducă înapoi la ea. */
    if (!forceRead) _liveLastRemember(s.id);

    window._liveReadOnly = !canEdit;   /* setat ÎNAINTE de switchTab — acesta îl citește */
    const sheet = (s.sheet && typeof s.sheet === 'object') ? s.sheet : {};

    /* Marcăm sesiunea live ca fiind cea „în lucru" -> formularul o editează pe ea. */
    window._liveSessionId = s.id;
    if (lsIAmHost(s)) startLiveHeartbeat();

    /* ⚠ ORDINEA CONTEAZĂ: `switchTab('session')` cheamă `renderSessionForm()`, care
       GOLEȘTE `sessionPlayers` și resetează formularul. Dacă populăm înainte, ne
       șterge datele imediat. Deci: mai întâi comutăm tab-ul, abia apoi hidratăm —
       și o facem după ce randarea s-a terminat (setTimeout 0), ca să prindem DOM-ul
       proaspăt, nu pe cel vechi. */
    /* Steag: îi spune lui `renderSessionForm` (care rulează sincron în `switchTab`)
       că NU trebuie să dezlege sesiunea live — aici chiar vrem s-o încărcăm. */
    window._liveHydrating = true;
    if (typeof switchTab === 'function') switchTab('session');

    setTimeout(function () {
        try {
            /* ⚠ 9.1 (sept. 2026): `renderSessionPlayers` păstrează valorile vechi din câmpuri
               (snapshot/restore după id-ul jucătorului). Trecând de la masa A la masa B,
               scorul unui jucător prezent la ambele mese se muta din A în B. Golim zona
               ÎNAINTE de a desena, ca B să pornească doar de la foaia ei.
               EN: the snapshot/restore carried A's values into B for shared players. */
            if (!_sameSession) {
                const _sp = document.getElementById('sessionPlayers');
                if (_sp) _sp.innerHTML = '';
                /* ⚠ 9.2: și câmpurile de text trebuie golite la schimbarea mesei. Altfel masa
                   B moștenea locul și notițele mesei A — `_paintSessionFormFields` scrie doar
                   cheile PREZENTE în foaia lui B, iar ce lipsește de acolo rămânea de la A.
                   Se vede cel mai clar la mesele pornite înainte de această versiune, care
                   n-au deloc `form`. Golim întâi, apoi pictăm ce are B.
                   EN: text fields kept A's values when B's sheet lacked those keys. */
                _resetSessionFormFields();
            }
            /* Tipul ÎNTÂI: `setSessionType` re-randează grila (coop/turneu arată altfel). */
            if (sheet.type && typeof setSessionType === 'function' && sheet.type !== currentSessionType) {
                setSessionType(sheet.type);
            }
            if (sheet.game && typeof pickSessionGame === 'function') pickSessionGame(sheet.game);
            if (Array.isArray(sheet.guests)) {
                sessionGuests = sheet.guests.map(g => ({ key: g.key, name: g.name }));
                /* 9.1: emailurile NU circulă prin foaie (§48); le luăm din magazia locală. */
                _gemRestore(s.id);
            }
            if (Array.isArray(sheet.players)) {
                sessionPlayers = sheet.players.slice();
            }
            if (typeof renderSessionPlayers === 'function') renderSessionPlayers();
            /* Proiectăm timerele (jucători + cronometrul global) din server în UI. */
            applyLiveTimersToLocal(s);
            if (typeof renderSessionPlayers === 'function') renderSessionPlayers();
            if (typeof renderSessionTimerPanel === 'function') renderSessionTimerPanel();
            /* ⚠ 9.1 (sept. 2026) — CAUZA pierderii scorurilor și rolurilor la redeschidere:
               cardurile se desenau cu scor 0 și rol gol, iar valorile din foaie NU erau scrise
               în câmpuri (doar un eveniment realtime ulterior le aducea, dacă mai venea).
               Le scriem acum, cât steagul de hidratare e încă ridicat (nu pleacă nimic înapoi),
               cu gărzile obișnuite pentru câmpurile focusate/murdare.
               EN: sheet values were never painted on open; paint them while still hydrating. */
            if (typeof refreshLiveTimersInDom === 'function') refreshLiveTimersInDom();
            /* 9.2: data, ora, locul, notițele și restul. Pentru sesiunile pornite ÎNAINTE de
               această versiune foaia n-are `form`; atunci data și ora vin din momentul în
               care serverul a creat sesiunea — adică exact ora de început a partidei. */
            _paintSessionFormFields(sheet, { initial: true });
            if (!(sheet.form && sheet.form.date) && s.created_at) {
                try {
                    const _c = new Date(s.created_at);
                    const _d = document.getElementById('sessionDate');
                    const _t = document.getElementById('sessionStartTime');
                    if (_d && !_isLiveDirty(_d)) _d.value = _c.toISOString().split('T')[0];
                    if (_t && !_isLiveDirty(_t)) _t.value = String(_c.getHours()).padStart(2, '0') + ':' + String(_c.getMinutes()).padStart(2, '0');
                } catch (e) { logError('openLiveCard.created', e); }
            }
            if (typeof applyLiveReadOnly === 'function') applyLiveReadOnly();
        } catch (e) { logError('openLiveCard', e); }
        finally { window._liveHydrating = false; }
    }, 0);

    renderLiveSessionsBar();
    showNotification(window._liveReadOnly ? t('live.readOnly') : t('live.editing'), 'info');
}
window.openLiveCard = openLiveCard;

/* Blochează toate câmpurile din pagina de sesiune, cu O SINGURĂ excepție:
   butonul „Turn" al utilizatorului curent. Asta e promisiunea din spec —
   „read-only, cu excepția propriului cronometru" — aplicată literal.
   Autoritatea REALĂ e oricum în server (`ls_set_sheet` respinge non-host-ul);
   asta e doar ca UI-ul să nu promită ce DB-ul va refuza. */
function applyLiveReadOnly() {
    const tab = document.getElementById('tab-session');
    if (!tab) return;
    const on = !!window._liveReadOnly;
    const me = String((state.currentUser && state.currentUser.id) || '');

    tab.querySelectorAll('input, select, textarea, button').forEach(function (el) {
        const isMyTurn = el.tagName === 'BUTTON' && el.dataset && String(el.dataset.player) === me;
        if (on && !isMyTurn) {
            el.setAttribute('disabled', 'disabled');
            el.classList.add('is-readonly');
        } else {
            el.removeAttribute('disabled');
            el.classList.remove('is-readonly');
        }
    });

    /* Elementele CLICABILE care NU sunt butoane (ex. opțiunile de jucător din combobox
       sunt `<div onclick="addSessionPlayer(...)">`). `disabled` nu are efect pe ele —
       de acolo a scăpat adăugarea de jucători. Le tăiem interacțiunea vizual;
       blocarea REALĂ e oricum în funcții (`liveWriteBlocked`) și în server. */
    tab.querySelectorAll('[onclick]:not(button)').forEach(function (el) {
        if (on) { el.classList.add('is-readonly-click'); }
        else    { el.classList.remove('is-readonly-click'); }
    });

    let banner = document.getElementById('liveReadOnlyNote');
    if (on) {
        if (!banner) {
            banner = document.createElement('div');
            banner.id = 'liveReadOnlyNote';
            banner.className = 'live-ro-note';
            tab.insertBefore(banner, tab.firstChild);
        }
        banner.innerHTML = '<i class="fas fa-lock"></i> ' + t('live.readOnly');
    } else if (banner) {
        banner.remove();
    }
}
window.applyLiveReadOnly = applyLiveReadOnly;

/* Încheie o sesiune live. Host + Moderator+ (aceeași regulă ca în `ls_close`).
   Batch B: „abandoned" (fără salvare în matches). Salvarea → `matches` vine în batch-ul D. */
async function endLiveSession(sessionId) {
    const s = (state.liveSessions || []).find(x => String(x.id) === String(sessionId));
    if (!s) return;
    if (typeof confirmModal === 'function' && !await confirmModal(t('live.confirmEnd'))) return;

    const r = await lsClose(sessionId, 'abandoned', null);
    if (!r) return;

    if (String(window._liveSessionId) === String(sessionId)) {
        window._liveSessionId = null;   /* doar dezlegăm formularul de sesiunea închisă */
        syncGoLiveBtn();                /* redevine o sesiune nouă -> butonul reapare */
    }
    /* NU oprim pulsul aici: e GLOBAL. Dacă mai găzduim alte sesiuni, le-am fi omorât
       și pe ele (cronul le-ar fi marcat `abandoned` după 60 min). `loadLiveSessions()`,
       chemat de `lsClose`, decide corect: pornește pulsul dacă mai am sesiuni, îl
       oprește dacă nu mai am niciuna. */
    const modal = document.getElementById('liveSheetModal');
    if (modal && modal.dataset.sessionId === String(sessionId)) modal.remove();

    renderLiveSessionsBar();
    showNotification(t('live.ended'), 'info');
}
window.endLiveSession = endLiveSession;

/* Vizualizator de sesiune live (batch B: READ-ONLY + timer personal). */
function openLiveSheet(sessionId) {
    const s = (state.liveSessions || []).find(x => String(x.id) === String(sessionId));
    if (!s) { showNotification(t('live.notFound'), 'error'); return; }

    const existing = document.getElementById('liveSheetModal'); if (existing) existing.remove();
    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.id = 'liveSheetModal';
    modal.dataset.sessionId = String(sessionId);
    modal.onclick = (e) => { if (e.target === modal) modal.remove(); };
    modal.innerHTML = `
        <div class="modal-content" style="max-width:680px;">
            <div class="modal-header">
                <h2><span class="live-dot"></span> ${t('live.sheetTitle')}</h2>
                <button class="modal-close" onclick="closeModal('liveSheetModal')">×</button>
            </div>
            <div id="liveSheetBody"></div>
        </div>`;
    document.body.appendChild(modal);
    renderLiveSheetIfOpen();
}
window.openLiveSheet = openLiveSheet;

/* Re-randează foaia live deschisă. Apelată de realtime la fiecare schimbare. */
function renderLiveSheetIfOpen() {
    const modal = document.getElementById('liveSheetModal');
    if (!modal) return;
    const body = modal.querySelector('#liveSheetBody');
    if (!body) return;

    const sid = modal.dataset.sessionId;
    const s = (state.liveSessions || []).find(x => String(x.id) === String(sid));
    if (!s) { body.innerHTML = `<p>${t('live.ended')}</p>`; return; }

    const sheet = (s.sheet && typeof s.sheet === 'object') ? s.sheet : {};
    const timers = (s.timers && typeof s.timers === 'object') ? s.timers : {};
    const me = (state.currentUser && state.currentUser.id) || '';
    const myTimer = timers[me] || null;
    const iAmIn = Array.isArray(sheet.players) && sheet.players.map(String).indexOf(String(me)) !== -1;

    const rows = (Array.isArray(sheet.players) ? sheet.players : []).map(function (pid) {
        const m = (typeof memberById === 'function' && memberById(pid)) || null;
        const nm = (m && (m.displayName || m.name)) || t('live.someone');
        const tmr = timers[pid] || null;
        const running = !!(tmr && tmr.running);
        const sc = (sheet.scores && typeof sheet.scores === 'object') ? sheet.scores[pid] : undefined;
        const role = (sheet.roles && typeof sheet.roles === 'object') ? sheet.roles[pid] : '';
        return `<div class="live-row${String(pid) === String(me) ? ' me' : ''}">
            <span class="live-name">
                ${escHtml(nm)}
                ${role ? `<small class="live-role">${escHtml(role)}</small>` : ''}
            </span>
            <span class="live-right">
                ${(sc !== undefined && sc !== null) ? `<span class="live-score">${escHtml(String(sc))}</span>` : ''}
                <span class="live-clock${running ? ' running' : ''}"
                      data-lsid="${attrJs(s.id)}" data-pid="${attrJs(String(pid))}">
                    ${running ? '<i class="fas fa-circle"></i> ' : ''}<span class="live-clock-txt">${fmtClock(liveTimerMs(tmr))}</span>
                </span>
            </span>
        </div>`;
    }).join('') || `<small style="color:var(--text-secondary);">${t('live.noPlayers')}</small>`;

    ensureLiveTick();
    body.innerHTML = `
        <p><strong>${escHtml(sheet.game || t('live.untitled'))}</strong></p>
        <div class="live-rows">${rows}</div>
        ${iAmIn ? `<div class="btn-group" style="margin-top:14px;">
            <button class="btn ${myTimer && myTimer.running ? 'btn-primary' : 'btn-secondary'}"
                    onclick="lsPressClock('${attrJs(s.id)}', '${attrJs(String(me))}')">
                <i class="fas fa-${myTimer && myTimer.running ? 'pause' : 'play'}"></i>
                ${myTimer && myTimer.running ? t('session.turnActive') : t('session.turn')}
            </button>
        </div>
        <small style="color:var(--text-secondary); display:block; margin-top:8px;">${t('live.turnHint')}</small>`
        : `<small style="color:var(--text-secondary); display:block; margin-top:12px;">${t('live.watchingOnly')}</small>`}
        <small style="color:var(--text-secondary); display:block; margin-top:10px;">
            <i class="fas fa-lock"></i> ${t('live.readOnly')}
        </small>
    `;
}
window.renderLiveSheetIfOpen = renderLiveSheetIfOpen;



function renderSessionTimerPanel() {
    /* Butoanele panoului se recreează la fiecare randare -> reaplicăm blocarea,
       altfel ies active în modul doar-vizualizare (așa a scăpat „Stop & set duration"). */
    setTimeout(function () { try { if (window._liveReadOnly && typeof applyLiveReadOnly === 'function') applyLiveReadOnly(); } catch (e) { logError('renderSessionTimerPanel', e); } }, 0);
    const panel = document.getElementById('sessionTimerPanel'); if (!panel) return;
    if (!planAllows('timer')) { panel.innerHTML = ''; return; }
    const running = sessionClockRunning();   /* sursa: sesiunea legată, nu oglinda globală */
    panel.innerHTML = `<div class="card" style="display:flex; align-items:center; justify-content:space-between; gap:10px; flex-wrap:wrap; margin-bottom:12px;">
        <div style="display:flex; align-items:center; gap:10px;">
            <i class="fas fa-stopwatch" style="color:var(--accent-primary,#ff6b35);"></i>
            <strong>${typeof t === 'function' ? t('session.timerTitle') : 'Cronometru sesiune'}</strong>${typeof planBadgeHtml === 'function' ? planBadgeHtml('timer') : ''}
            <span id="sessionTimerDisplay" style="font-variant-numeric:tabular-nums; font-size:1.1em; font-weight:700;">${fmtClock(sessionElapsedMs())}</span>
        </div>
        <div class="btn-group">
            ${running
                ? `<button class="btn btn-sm btn-secondary" type="button" onclick="pauseSessionTimer()"><i class="fas fa-pause"></i> ${t('session.timerPause')}</button>`
                : `<button class="btn btn-sm btn-primary" type="button" onclick="startSessionTimer()"><i class="fas fa-play"></i> Start</button>`}
            <button class="btn btn-sm" type="button" onclick="stopSessionTimer()"><i class="fas fa-stop"></i> ${t('session.timerStop')}</button>
            <button class="btn btn-sm btn-secondary" type="button" onclick="resetTimerShared()" title="${t('session.timerResetTitle')}"><i class="fas fa-rotate-left"></i> ${t('session.timerReset')}</button>
        </div>
    </div>`;
}
function resetTimerShared() {
    resetLiveTimer();
    try { clearTimerState(); } catch (e) { logError('resetTimerShared', e); }
    renderSessionPlayers();
}

/* ---- Sincronizare cronometru pe mai multe device-uri (Supabase realtime) ----
   Oricine din club poate porni/comuta de pe telefonul lui; toți văd la fel.
   O persoană le poate ține pe toate, sau fiecare jucător își apasă „La rând". */
const TIMER_CLIENT_ID = 'tc-' + Math.random().toString(36).slice(2);
let timerChannel = null;

function serializeTimer() {
    return {
        sessionRunning: liveTimer.sessionRunning, sessionAccumMs: liveTimer.sessionAccumMs,
        sessionStartTs: liveTimer.sessionStartTs, activePlayer: liveTimer.activePlayer,
        playerAccumMs: liveTimer.playerAccumMs, playerStartTs: liveTimer.playerStartTs
    };
}
function applyTimerState(st) {
    if (!st || typeof st !== 'object') return;
    liveTimer.sessionRunning = !!st.sessionRunning;
    liveTimer.sessionAccumMs = st.sessionAccumMs || 0;
    liveTimer.sessionStartTs = st.sessionStartTs || 0;
    liveTimer.activePlayer = st.activePlayer || null;
    liveTimer.playerAccumMs = st.playerAccumMs || {};
    liveTimer.playerStartTs = st.playerStartTs || 0;
    if (liveTimer.sessionRunning || liveTimer.activePlayer) ensureTimerInterval(); else maybeStopInterval();
    renderSessionTimerPanel();
    if (document.getElementById('sessionPlayers')) renderSessionPlayers();
}
/* ============================================================
   `live_timers` — RETRASĂ (§2).

   CE FĂCEA: sincroniza cronometrul unei sesiuni OBIȘNUITE între dispozitivele
   aceluiași club. Dar avea UN RÂND PER CLUB (`onConflict: 'club_id'`) — deci două
   sesiuni pornite pe două dispozitive SE SUPRASCRIAU deja reciproc. Era exact
   limitarea pe care sesiunile live o rezolvă corect (N sesiuni, fiecare cu rândul ei).

   ACUM: cronometrul unei sesiuni obișnuite e LOCAL (pe dispozitivul tău).
   Vrei cronometru partajat între oameni? -> pornești o SESIUNE LIVE. Aia e unealta.

   Funcțiile rămân, ca no-op, fiindcă sunt chemate din ~15 locuri. Le golim aici,
   într-un singur punct, în loc să vânăm apelurile prin tot codul.
   ============================================================ */
async function pushTimerState() { /* retras: vezi live_sessions */ }
async function loadTimerState() { /* retras: vezi live_sessions */ }
async function clearTimerState() { /* retras: vezi live_sessions */ }
function subscribeRealtimeTimer() { /* retras: canalul live-sessions îl înlocuiește */ }

/* Snapshot/restore al valorilor din inputuri/select-uri (păstrează scorurile,
   categoriile de scoresheet, rolurile etc. la re-randarea grilei de jucători —
   ex. comutare limbă, adăugare/scoatere jucător, orice render()). */
function _snapshotInputs(container) {
    const snap = {};
    if (!container) return snap;
    container.querySelectorAll('input, select').forEach(el => {
        if (!el.id) return;
        snap[el.id] = (el.type === 'checkbox') ? el.checked : el.value;
    });
    return snap;
}
function _restoreInputs(snap) {
    Object.keys(snap || {}).forEach(id => {
        const el = document.getElementById(id);
        if (!el) return;
        if (el.type === 'checkbox') el.checked = snap[id];
        else el.value = snap[id];
    });
}

/* Eticheta câmpului de scor: „Bonus" la sesiunile de campanie uniformizate, „Scor" altfel. */
function _scoreInputLabel() {
    return (typeof currentScoreKind === 'function' && currentScoreKind() === 'campaign') ? t('session.bonusLabel') : t('session.scoreLabel');
}

/* Re-randare NON-distructivă a foii de sesiune (apelată din render()/setLang):
   păstrează jocul ales, jucătorii, invitații, data și scorurile introduse.
   NU resetează nimic — spre deosebire de renderSessionForm (deschidere proaspătă). */
function renderSessionRefresh() {
    if (typeof currentTab !== 'undefined' && currentTab !== 'session') return;
    if (!document.getElementById('sessionPlayers')) return;
    if (typeof renderSessionScoreMode === 'function') renderSessionScoreMode();
    if (typeof renderSessionScoreDir === 'function') renderSessionScoreDir();
    renderSessionPlayers(); // are snapshot/restore intern al scorurilor
}

function renderSessionPlayers() {
    /* Cardurile se recreează -> reaplicăm blocarea read-only pe elementele noi. */
    setTimeout(function () { try { if (window._liveReadOnly && typeof applyLiveReadOnly === 'function') applyLiveReadOnly(); } catch (e) { logError('renderSessionPlayers', e); } }, 0);
    /* ⚠ NU chema `pushLiveSheet()` de aici. Era un CICLU DE FEEDBACK:
       randare -> push -> realtime -> randare -> push...  Iar fiecare randare
       RECONSTRUIA cardurile, distrugând inputul în care tocmai scriai scorul.
       Push-ul se face acum DOAR la modificări reale (adaugă/scoate jucător, schimbă joc,
       tastează scor) — vezi addSessionPlayer / removeSessionPlayer / listener-ul delegat. */
    const container = document.getElementById('sessionPlayers');
    const _snap = _snapshotInputs(container);
    container.innerHTML = '';
    try { if (typeof renderSessionTimerPanel === 'function') renderSessionTimerPanel(); } catch (e) { logError('renderSessionPlayers', e); }
    const gameName = (document.getElementById('sessionGame') || {}).value || '';
    const fields = scoresheetFor(gameName);
    const roles = rolesFor(gameName);
    const showTimer = planAllows('timer');
    const coop = (typeof currentSessionType !== 'undefined' && currentSessionType === 'coop');

    if (typeof sessionPlayers === 'undefined' || !Array.isArray(sessionPlayers)) { try { sessionPlayers = []; } catch (e) { logError('renderSessionPlayers', e); } }

    /* COMBOBOX cu search (filtrează după Nume de Afișare + @user_tag, în timp real). */
    const combo = document.createElement('div');
    combo.style.cssText = 'margin-bottom:14px;';
    combo.innerHTML = `
        <label for="playerComboSearch" style="font-size:0.85em; opacity:0.85; display:block; margin-bottom:6px;"><i class="fas fa-user-plus"></i> ${t('session.addPlayers')}</label>
        <input type="text" id="playerComboSearch" class="form-control" placeholder="${t('session.searchPlayersPh')}" oninput="renderPlayerCombo()" autocomplete="off">
        <div id="playerComboList" style="max-height:230px; overflow:auto; border:1px solid var(--border,#333); border-radius:10px; margin-top:6px; display:none;"></div>`;
    container.appendChild(combo);

    /* Container pentru cardurile jucătorilor SELECTAȚI. */
    const sel = document.createElement('div');
    sel.id = 'selectedPlayers';
    container.appendChild(sel);

    renderSelectedSessionPlayers();
    renderPlayerCombo();

    /* Invitați (cu cronometru, ca jucătorii înregistrați) */
    (typeof sessionGuests !== 'undefined' ? sessionGuests : []).forEach(guest => {
        const gname = guest.name;
        const safeName = gname.replace(/\s+/g, '-');
        if (!guest.key) guest.key = 'g_' + Math.random().toString(36).slice(2, 10); // cheie cronometru stabilă
        const tkey = guest.key;
        const tid = String(tkey).replace(/[^a-zA-Z0-9]/g, '-');
        const div = document.createElement('div');
        div.className = 'session-player-card';
        div.style.borderLeft = '4px solid var(--warning)';
        div.id = `guest-${safeName}`;
        const isActive = activeTurnKey() === tkey;   /* sursa: sesiunea legată */
        if (showTimer && isActive) div.style.boxShadow = '0 0 0 2px var(--accent-primary,#ff6b35) inset';
        const gTimer = showTimer
            ? `<div style="display:flex; align-items:center; justify-content:space-between; gap:10px; margin-top:8px;">
                    <span style="display:inline-flex; align-items:center; gap:6px; background:var(--bg-secondary); border-radius:999px; padding:5px 12px; font-size:0.85em; font-variant-numeric:tabular-nums;">
                        <i class="fas fa-clock" style="opacity:0.7;"></i> <span id="ptimer-${tid}">${fmtClock(playerElapsedMs(tkey))}</span>
                    </span>
                    <button class="btn btn-sm ${isActive ? 'btn-primary' : 'btn-secondary'}" type="button" data-player="${clubEsc(tkey)}" onclick="setActivePlayerFromBtn(this)" style="width:auto; min-width:auto; padding:8px 16px; flex:none;">
                        <i class="fas fa-${isActive ? 'pause' : 'play'}"></i> ${isActive ? t('session.turnActive') : t('session.turn')}
                    </button>
               </div>`
            : '';
        const gRole = (roles && roles.length)
            ? `<select class="form-control" id="role-guest-${safeName}" style="margin-top:6px; font-size:0.85em;">
                    <option value="">${t('session.role')}</option>
                    ${roles.map(r => `<option value="${clubEsc(r)}">${clubEsc(r)}</option>`).join('')}
               </select>`
            : '';
        let gScore;
        if (coop && !(fields && fields.length)) {
            gScore = '';
        } else if (fields && fields.length) {
            const inputs = fields.map((label, i) =>
                `<div style="display:flex; align-items:center; gap:8px; margin-top:4px;">
                    <label for="ssg-${tid}-${i}" style="flex:1; font-size:0.82em; opacity:0.85;">${clubEsc(label)}</label>
                    <input type="number" step="${POINTS_STEP}" value="0" class="form-control ss-cat-g-${tid}" style="width:88px;" id="ssg-${tid}-${i}" oninput="recalcGuestScoresheet('${tid}','${safeName}')">
                </div>`).join('');
            gScore = `${inputs}
                <div style="display:flex; justify-content:space-between; align-items:center; margin-top:8px; font-weight:700;">
                    <span>${t('common.total')}</span>
                    <input type="number" readonly value="0" class="session-player-score" id="score-guest-${safeName}" style="width:88px; background:rgba(255,255,255,0.06);">
                </div>`;
        } else {
            gScore = `<div style="display:flex; align-items:center; gap:10px; margin-top:8px;">
                    <span style="font-size:0.85em; opacity:0.7; min-width:38px;">${_scoreInputLabel()}</span>
                    <input type="number" step="${POINTS_STEP}" min="0" value="0" class="session-player-score" id="score-guest-${safeName}" placeholder="0" style="flex:1; text-align:left; padding-left:14px;" oninput="onSessionScoreInput()">
                </div>`;
        }
        div.innerHTML = `
            <div class="session-player-header">
                <div class="session-player-name session-player-guest">
                    <i class="fas fa-user-plus"></i> ${clubEsc(gname)} (${t('session.guestTag')})
                </div>
                <button class="btn-x-small" title="${t('session.removeGuest')}" onclick="removeGuest('${window.attrJs(gname)}')">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            ${gRole}
            ${gTimer}
            ${gScore}
        `;
        container.appendChild(div);
    });
    _restoreInputs(_snap);
    applyFriendlyState();
    if (typeof renderTieBreakBar === 'function') renderTieBreakBar();
}

/* Randează cardurile jucătorilor SELECTAȚI (cu scor/rol/timer + buton de scoatere). */
function renderSelectedSessionPlayers() {
    const wrap = document.getElementById('selectedPlayers'); if (!wrap) return;
    if (typeof sessionPlayers === 'undefined' || !Array.isArray(sessionPlayers)) return;
    const _snapSel = _snapshotInputs(wrap);
    const gameName = (document.getElementById('sessionGame') || {}).value || '';
    const fields = scoresheetFor(gameName);
    const roles = rolesFor(gameName);
    const showTimer = planAllows('timer');
    const coop = (typeof currentSessionType !== 'undefined' && currentSessionType === 'coop');
    wrap.innerHTML = '';
    if (!sessionPlayers.length) {
        wrap.innerHTML = '<p style="color:var(--text-secondary); font-size:0.85em; padding:6px 2px;">' + t('session.noPlayersSelected') + '</p>';
        return;
    }
    sessionPlayers.forEach(function (id) {
        const member = (typeof memberById === 'function') ? memberById(id) : (state.membersById && state.membersById[id]);
        if (!member) return;
        const name = member.name || member.displayName || '';
        const safeId = String(member.dbId || id).replace(/[^a-zA-Z0-9]/g, '-');
        const tkey = member.dbId || name;                       // cheie cronometru = id (stabilă, ne-coliziune)
        const tid = String(tkey).replace(/[^a-zA-Z0-9]/g, '-'); // id DOM pentru ptimer
        const tagHtml = member.userTag ? ' <span style="color:var(--accent-primary); font-weight:600; font-size:0.8em;">@' + clubEsc(member.userTag) + '</span>' : '';
        let scoreBlock;
        if (coop && !(fields && fields.length)) {
            scoreBlock = '';
        } else if (fields && fields.length) {
            const inputs = fields.map((label, i) =>
                `<div style="display:flex; align-items:center; gap:8px; margin-top:4px;">
                    <label for="ss-${safeId}-${i}" style="flex:1; font-size:0.82em; opacity:0.85;">${clubEsc(label)}</label>
                    <input type="number" step="${POINTS_STEP}" value="0" class="form-control ss-cat-${safeId}" style="width:88px;" id="ss-${safeId}-${i}" oninput="recalcScoresheet('${safeId}')">
                </div>`).join('');
            scoreBlock = `${inputs}
                <div style="display:flex; justify-content:space-between; align-items:center; margin-top:8px; font-weight:700;">
                    <span>${t('common.total')}</span>
                    <input type="number" readonly value="0" class="session-player-score" id="score-${safeId}" style="width:88px; background:rgba(255,255,255,0.06);">
                </div>`;
        } else {
            scoreBlock = `<div style="display:flex; align-items:center; gap:10px; margin-top:8px;">
                    <span style="font-size:0.85em; opacity:0.7; min-width:38px;">${_scoreInputLabel()}</span>
                    <input type="number" step="${POINTS_STEP}" min="0" value="0" class="session-player-score" id="score-${safeId}" placeholder="0" style="flex:1; text-align:left; padding-left:14px;" oninput="onSessionScoreInput()">
                </div>`;
        }
        const roleBlock = (roles && roles.length)
            ? `<select class="form-control" id="role-${safeId}" style="margin-top:6px; font-size:0.85em;">
                    <option value="">${t('session.role')}</option>
                    ${roles.map(r => `<option value="${clubEsc(r)}">${clubEsc(r)}</option>`).join('')}
               </select>`
            : '';
        const isActive = activeTurnKey() === tkey;   /* sursa: sesiunea legată */
        const timerBlock = showTimer
            ? `<div style="display:flex; align-items:center; justify-content:space-between; gap:10px; margin-top:8px;">
                    <span style="display:inline-flex; align-items:center; gap:6px; background:var(--bg-secondary); border-radius:999px; padding:5px 12px; font-size:0.85em; font-variant-numeric:tabular-nums;">
                        <i class="fas fa-clock" style="opacity:0.7;"></i> <span id="ptimer-${tid}">${fmtClock(playerElapsedMs(tkey))}</span>
                    </span>
                    <button class="btn btn-sm ${isActive ? 'btn-primary' : 'btn-secondary'}" type="button" data-player="${clubEsc(tkey)}" onclick="setActivePlayerFromBtn(this)" style="width:auto; min-width:auto; padding:8px 16px; flex:none;">
                        <i class="fas fa-${isActive ? 'pause' : 'play'}"></i> ${isActive ? t('session.turnActive') : t('session.turn')}
                    </button>
               </div>`
            : '';
        const div = document.createElement('div');
        div.className = 'session-player-card';
        div.id = `player-${safeId}`;
        div.dataset.player = (member.dbId || id);
        if (showTimer && isActive) div.style.boxShadow = '0 0 0 2px var(--accent-primary,#ff6b35) inset';
        div.innerHTML = `
            <div class="session-player-header">
                <div class="session-player-name">${(typeof avatarHtml === 'function') ? avatarHtml(member.avatar, 28) : ''}<span>${clubEsc(name)}${tagHtml}</span></div>
                <button class="btn-x-small" title="${t('session.removePlayer')}" onclick="removeSessionPlayer('${window.attrJs(member.dbId || id)}')"><i class="fas fa-times"></i></button>
            </div>
            ${roleBlock}${timerBlock}${scoreBlock}`;
        wrap.appendChild(div);
    });
    _restoreInputs(_snapSel);
    applyFriendlyState();
    if (typeof renderTieBreakBar === 'function') renderTieBreakBar();
    if (coop && typeof renderCoopMvpOptions === 'function') renderCoopMvpOptions();
}

/* Lista dropdown a comboboxului: membrii ne-adăugați, filtrați după nume + @tag. */
function renderPlayerCombo() {
    const list = document.getElementById('playerComboList'); if (!list) return;
    if (typeof sessionPlayers === 'undefined' || !Array.isArray(sessionPlayers)) sessionPlayers = [];
    const q = ((document.getElementById('playerComboSearch') || {}).value || '').trim().toLowerCase().replace(/^@/, '');
    const all = getSortedPlayers().filter(p => sessionPlayers.indexOf(p.dbId) === -1);
    let matches = all;
    if (q) matches = all.filter(p => ((p.name || '').toLowerCase().indexOf(q) !== -1) || ((p.userTag || '').toLowerCase().indexOf(q) !== -1));
    list.style.display = 'block';
    if (!matches.length) {
        list.innerHTML = '<div style="padding:10px; color:var(--text-secondary); font-size:0.85em;">' + t('session.noPlayerMatch') + '</div>';
        return;
    }
    list.innerHTML = matches.slice(0, 50).map(p => {
        const safe = String(p.dbId || '').replace(/'/g, "\\'");
        const tag = p.userTag ? ' <span style="color:var(--accent-primary); font-size:0.8em;">@' + clubEsc(p.userTag) + '</span>' : '';
        const av = (typeof avatarHtml === 'function') ? avatarHtml(p.avatar, 26) : '';
        return '<div onclick="addSessionPlayer(\'' + safe + '\')" style="display:flex; align-items:center; gap:9px; padding:9px 12px; cursor:pointer; border-bottom:1px solid var(--border,#2a2a3a);">'
            + '<span class="sess-combo-av">' + av + '</span>'
            + '<span style="flex:1 1 auto; min-width:0;">' + clubEsc(p.name) + tag + '</span>'
            + '<i class="fas fa-plus" style="opacity:0.6;"></i></div>';
    }).join('');
}
function addSessionPlayer(name) {
    if (liveWriteBlocked()) return;
    if (!name) return;
    if (typeof sessionPlayers === 'undefined' || !Array.isArray(sessionPlayers)) sessionPlayers = [];
    if (sessionPlayers.indexOf(name) === -1) sessionPlayers.push(name);
    try { if (typeof pushLiveSheet === 'function') pushLiveSheet(); } catch (e) { logError('addSessionPlayer', e); }
    const s = document.getElementById('playerComboSearch'); if (s) s.value = '';
    renderSelectedSessionPlayers();
    renderPlayerCombo();
    /* NU focalizăm search-ul: tastatura se deschide doar dacă userul apasă pe el intenționat */
}
function removeSessionPlayer(name) {
    if (liveWriteBlocked()) return;
    if (typeof sessionPlayers === 'undefined' || !Array.isArray(sessionPlayers)) return;
    const i = sessionPlayers.indexOf(name);
    if (i !== -1) sessionPlayers.splice(i, 1);
    try { if (typeof pushLiveSheet === 'function') pushLiveSheet(); } catch (e) { logError('removeSessionPlayer', e); }
    renderSelectedSessionPlayers();
    renderPlayerCombo();
}

/* ===== Fotografii sesiune (Session Photos) ===== */
/* ⚠ Comprimarea se face la ALEGERE, nu la încărcare: previzualizarea arată atunci
   EXACT ce se va trimite, iar la salvare fișierele sunt deja pregătite.
   ⚠ UNA CÂTE UNA, nu în paralel: 12 poze de telefon decodate simultan pot epuiza
     memoria pe telefoane slabe. Previzualizarea se re-randează după fiecare, deci
     miniaturile apar pe rând — ăsta e și indicatorul de progres.
   ⚠ `window._photoPrepBusy` blochează salvarea cât timp mai sunt poze în lucru:
     fără el, cine apasă „Salvează" imediat după alegere ar trimite o sesiune cu
     mai puține poze decât a ales, fără niciun avertisment.
   EN: sequential compression at pick time; the preview doubles as progress, and
       a busy flag prevents saving with a half-processed photo set. */
async function onSessionPhotosPicked(input) {
    if (!requireFeature('photos')) { try { input.value = ''; } catch (e) { logError('onSessionPhotosPicked', e); } return; }
    const files = input && input.files ? Array.from(input.files) : [];
    try { input.value = ''; } catch (e) { logError('onSessionPhotosPicked', e); }
    const picked = files.filter(function (f) { return /^image\//.test(f.type); });
    if (!picked.length) return;

    window._photoPrepBusy = true;
    if (picked.length > 1) showNotification(t('photo.preparing').replace('{n}', picked.length), 'info');
    try {
        for (const f of picked) {
            if (sessionPhotoFiles.length >= 12) break;
            let out = f;
            try {
                out = (typeof window.compressImage === 'function') ? await window.compressImage(f) : f;
            } catch (e) { logError('onSessionPhotosPicked', e); out = f; }
            sessionPhotoFiles.push(out);
            renderSessionPhotoPreview();
        }
        /* ⚠ 9.3: într-o sesiune live urcăm ACUM, nu la salvare. Un `File` trăiește doar în
           memoria paginii: la refresh pozele dispăreau fără urmă, iar ceilalți jucători nu
           le vedeau deloc. După urcare ținem doar calea, care încape în foaie.
           În afara unei sesiuni live păstrăm comportamentul de dinainte (urcare la salvare):
           acolo formularul oricum nu supraviețuiește, iar urcarea devreme ar lăsa fișiere
           orfane la fiecare formular abandonat.
           EN: inside a live session upload immediately and keep only the path. */
        if (window._liveSessionId) await _uploadPickedToLive();
    } finally {
        window._photoPrepBusy = false;
    }
    renderSessionPhotoPreview();
}

/* Urcă pozele încă nesalvate în Storage și le mută din `sessionPhotoFiles` în
   `sessionPhotoPaths`. Eșecul NU e distructiv: fișierul rămâne local și se va urca la
   salvare, ca înainte. */
async function _uploadPickedToLive() {
    const lsId = window._liveSessionId;
    if (!lsId || !sessionPhotoFiles.length) return;
    if (typeof planAllows === 'function' && !planAllows('photos')) return;
    if (typeof uploadSessionPhotos !== 'function') return;
    const batch = sessionPhotoFiles.slice();
    let paths = [];
    try {
        paths = await uploadSessionPhotos('live-' + lsId, batch) || [];
    } catch (e) { logError('_uploadPickedToLive', e); return; }
    if (!paths.length) return;
    /* Scoatem din coada locală exact câte au reușit, în ordine. */
    batch.slice(0, paths.length).forEach(function (f) {
        const i = sessionPhotoFiles.indexOf(f);
        if (i > -1) sessionPhotoFiles.splice(i, 1);
    });
    sessionPhotoPaths = sessionPhotoPaths.concat(paths);
    renderSessionPhotoPreview();
    try { if (typeof pushLiveSheet === 'function') pushLiveSheet(); } catch (e) { logError('_uploadPickedToLive.push', e); }
}

function renderSessionPhotoPreview() {
    const box = document.getElementById('sessionPhotoPreview'); if (!box) return;
    const btn = function (handler) {
        return '<button type="button" onclick="' + handler + '" title="' + t('common.remove') + '" style="position:absolute; top:-6px; right:-6px; width:22px; height:22px; border-radius:50%; border:none; background:#b23b3b; color:#fff; cursor:pointer; font-size:11px; display:flex; align-items:center; justify-content:center;"><i class="fas fa-times"></i></button>';
    };
    /* ÎNTÂI cele urcate (au și ceilalți jucători aceeași ordine), apoi cele încă locale.
       Bucket PRIVAT ⇒ adresă semnată: v9 8.5-C — prin observatorul comun (`data-sp`, o cerere
       pentru toate) cu miniatura de 320 px (`data-spt`) și originalul ca rezervă pentru pozele
       vechi; înainte, câte o semnare pe poză (`_paintUploadedThumb`) și mereu originalul. */
    const up = sessionPhotoPaths.map(function (p, i) {
        return '<div style="position:relative; width:72px; height:72px;">'
            + '<img data-sp="' + window.escHtml(p) + '" data-spt="1" src="' + (window._SP_PH || '') + '" alt="" style="width:72px; height:72px; object-fit:cover; border-radius:8px; background:var(--bg-secondary,#222);">'
            + btn('removeSessionPhotoUploaded(' + i + ')')
            + '</div>';
    }).join('');
    const loc = sessionPhotoFiles.map(function (f, i) {
        const url = URL.createObjectURL(f);
        return '<div style="position:relative; width:72px; height:72px;">'
            + '<img src="' + url + '" style="width:72px; height:72px; object-fit:cover; border-radius:8px;">'
            + btn('removeSessionPhoto(' + i + ')')
            + '</div>';
    }).join('');
    box.innerHTML = up + loc;
}
function removeSessionPhoto(i) {
    if (i >= 0 && i < sessionPhotoFiles.length) sessionPhotoFiles.splice(i, 1);
    renderSessionPhotoPreview();
}
/* Scoate o poză DEJA urcată. O ștergem și din Storage (politica permite proprietarului
   și moderatorilor), ca să nu rămână fișiere pe care nu le mai vede nimeni. Ștergerea e
   best-effort: dacă eșuează, lista tot se actualizează — altfel poza ar reapărea la
   următoarea randare și utilizatorul n-ar înțelege de ce. */
function removeSessionPhotoUploaded(i) {
    if (liveWriteBlocked()) return;
    if (i < 0 || i >= sessionPhotoPaths.length) return;
    const path = sessionPhotoPaths.splice(i, 1)[0];
    renderSessionPhotoPreview();
    try { if (typeof pushLiveSheet === 'function') pushLiveSheet(); } catch (e) { logError('removeSessionPhotoUploaded', e); }
    try {
        if (typeof sb !== 'undefined' && sb && path) {
            /* v9 8.5-C: și miniatura ei (aceeași regulă de ștergere: proprietarul sau moderatorii);
               una care nu există (poze vechi) e ignorată de Storage */
            const thumb = String(path).replace(/[.][A-Za-z0-9]+$/, '.thumb.jpg');
            Promise.resolve(sb.storage.from('session-photos').remove(thumb !== path ? [path, thumb] : [path]))
                .catch(function (e) { logError('removeSessionPhotoUploaded.storage', e); });
        }
    } catch (e) { logError('removeSessionPhotoUploaded.storage', e); }
}
window.removeSessionPhotoUploaded = removeSessionPhotoUploaded;

/* Sesiune Amicală: când e bifat, BLOCHEAZĂ introducerea de scoruri (inputuri dezactivate
   și golite). Se re-aplică după fiecare randare a participanților. */
function applyFriendlyState() {
    const on = !!(document.getElementById('sessionFriendly') && document.getElementById('sessionFriendly').checked);
    /* La friendly scorurile RĂMÂN editabile: se salvează în istoric, dar nu contează la stats jucători. */
    const note = document.getElementById('friendlyScoreNote');
    if (note) note.style.display = on ? 'block' : 'none';
    /* Friendly => scorarea uniformizată nu are sens (nu afectează clasamentul); ascunde comutatorul. */
    if (typeof renderSessionScoreMode === 'function') renderSessionScoreMode();
    if (typeof renderSessionScoreDir === 'function') renderSessionScoreDir();
}

/* Comutatorul Brut/Uniformizat al sesiunii. Apare DOAR dacă uniformizarea e
   activată în club (Admin Panel) și sesiunea nu e amicală. */
/* Tipul de punctaj curent pentru sesiune: 'coop' (tip co-op) / 'campaign' / 'competitive'. */
function currentScoreKind() {
    if (typeof currentSessionType !== 'undefined' && currentSessionType === 'coop') return 'coop';
    const k = (document.getElementById('sessionScoreKind') || {}).value;
    return (k === 'campaign') ? 'campaign' : 'competitive';
}

function renderSessionScoreMode() {
    const wrap = document.getElementById('sessionScoreModeWrap');
    if (!wrap) return;
    const tpl = (typeof getScoringTemplates === 'function') ? getScoringTemplates() : null;
    const friendly = !!(document.getElementById('sessionFriendly') && document.getElementById('sessionFriendly').checked);
    if (!tpl || !tpl.enabled || friendly) { wrap.innerHTML = ''; return; }
    /* Păstrează alegerea curentă dacă există; altfel modul implicit al clubului. */
    const prev = (document.getElementById('sessionScoreMode') || {}).value;
    const def = prev || ((typeof clubDefaultScoreMode === 'function') ? clubDefaultScoreMode() : 'raw');
    const coop = (typeof currentSessionType !== 'undefined' && currentSessionType === 'coop');
    const prevKind = (document.getElementById('sessionScoreKind') || {}).value || 'competitive';
    const showKind = (def === 'uniform' && !coop);
    wrap.innerHTML = `
        <div class="form-group" style="border:1px solid var(--accent-primary,#ff6b35); background:rgba(255,107,53,0.06); padding:12px; border-radius:10px;">
            <label for="sessionScoreMode" style="margin-bottom:4px;"><i class="fas fa-scale-balanced"></i> ${t('session.scoreModeLabel')}</label>
            <select id="sessionScoreMode" class="form-control" onchange="onSessionScoreModeChange()">
                <option value="raw" ${def !== 'uniform' ? 'selected' : ''}>${t('scoreTpl.modeRaw')}</option>
                <option value="uniform" ${def === 'uniform' ? 'selected' : ''}>${t('scoreTpl.modeUniform')}</option>
            </select>
            <small id="sessionScoreModeNote" style="color:var(--text-secondary); display:block; margin-top:6px;">${def === 'uniform' ? t('session.scoreModeUniformNote') : t('session.scoreModeRawNote')}</small>
            ${showKind ? `
            <div style="margin-top:10px;">
                <label for="sessionScoreKind" style="margin-bottom:4px; font-size:0.9em;"><i class="fas fa-layer-group"></i> ${t('session.scoreKindLabel')}</label>
                <select id="sessionScoreKind" class="form-control" onchange="onSessionScoreKindChange()">
                    <option value="competitive" ${prevKind !== 'campaign' ? 'selected' : ''}>${t('session.kindCompetitive')}</option>
                    <option value="campaign" ${prevKind === 'campaign' ? 'selected' : ''}>${t('session.kindCampaign')}</option>
                </select>
                ${prevKind === 'campaign' ? `<small style="color:var(--text-secondary); display:block; margin-top:6px;">${t('session.campaignNote')}</small>` : ''}
            </div>` : ''}
        </div>`;
}

function onSessionScoreModeChange() {
    renderSessionScoreMode(); /* afișează/ascunde sub-selectorul de tip */
    if (typeof renderSessionPlayers === 'function') renderSessionPlayers(); /* etichete (Bonus) + scoruri păstrate via snapshot */
}

/* Direcția scorului MOȘTENITĂ de la jocul selectat (Faza 2): 'high' implicit. */
function sessionGameScoreDir() {
    try {
        const gn = (document.getElementById('sessionGame') || {}).value;
        const g = (gn && state.catalog) ? state.catalog[gn] : null;
        return (g && g.scoreDir === 'low') ? 'low' : 'high';
    } catch (e) { return 'high'; }
}

/* Direcția EFECTIVĂ a sesiunii curente: override-ul din foaie dacă e setat,
   altfel cea moștenită de la joc. Folosită la salvare (winner + puncte). */
function sessionEffectiveScoreDir() {
    const sel = document.getElementById('sessionScoreDir');
    if (sel && (sel.value === 'low' || sel.value === 'high')) return sel.value;
    return sessionGameScoreDir();
}

/* Selectorul de direcție pe foaia de sesiune. Apare pentru orice joc non-coop
   (direcția contează și pe raw, nu doar la uniformizare). Implicit = direcția
   jocului; poate fi suprascris pentru sesiunea curentă. RO+EN. */
function renderSessionScoreDir() {
    const wrap = document.getElementById('sessionScoreDirWrap');
    if (!wrap) return;
    const coop = (typeof currentSessionType !== 'undefined' && currentSessionType === 'coop');
    const gn = (document.getElementById('sessionGame') || {}).value;
    if (coop || !gn) { wrap.innerHTML = ''; return; }
    const gameDir = sessionGameScoreDir();
    const prev = (document.getElementById('sessionScoreDir') || {}).value;
    const cur = (prev === 'low' || prev === 'high') ? prev : gameDir;
    const overridden = cur !== gameDir;
    const gameDirLabel = gameDir === 'low' ? t('game.scoreDirLow') : t('game.scoreDirHigh');
    wrap.innerHTML = `
        <div class="form-group" style="border:1px solid var(--border,#333); padding:12px; border-radius:10px;">
            <label for="sessionScoreDir" style="margin-bottom:4px;"><i class="fas fa-arrow-down-1-9"></i> ${t('session.scoreDirLabel')}</label>
            <select id="sessionScoreDir" class="form-control" onchange="renderSessionScoreDir()">
                <option value="high" ${cur !== 'low' ? 'selected' : ''}>${t('game.scoreDirHigh')}</option>
                <option value="low" ${cur === 'low' ? 'selected' : ''}>${t('game.scoreDirLow')}</option>
            </select>
            <small style="color:var(--text-secondary); display:block; margin-top:6px;">
                ${overridden ? t('session.scoreDirOverride') : t('session.scoreDirInherited').replace('{dir}', gameDirLabel)}
            </small>
        </div>`;
}

function onSessionScoreKindChange() {
    renderSessionScoreMode(); /* nota de campanie */
    if (typeof renderSessionPlayers === 'function') renderSessionPlayers(); /* relabel Scor->Bonus, ascunde tie-break la campanie */
}

/* ===== Tie-breaker manual (departajare la egalitate) — Batch C2 =====
   Apare DOAR la sesiuni competitive uniformizate, când există scoruri brute egale.
   Cititorul alege manual câștigătorul departajării -> primește locul superior. */

/* Citește scorurile curente (live) ale jucătorilor înregistrați din inputuri. */
function readSessionScoresLive() {
    const out = {};
    (typeof sessionPlayers !== 'undefined' ? sessionPlayers : []).forEach(function (id) {
        const m = (typeof memberById === 'function') ? memberById(id) : (state.membersById && state.membersById[id]);
        if (!m) return;
        const pid = m.dbId || id;
        const safeId = String(pid).replace(/[^a-zA-Z0-9]/g, '-');
        const el = document.getElementById('score-' + safeId);
        if (el) out[pid] = parseFloat(el.value) || 0;
    });
    /* ★ INVITATII, care lipseau cu totul. Ei intra in `participants` si in `scores`
       la salvare, deci participa la clasare — dar bara de departajare nu-i vedea,
       asa ca o egalitate intre un invitat si un membru nu putea fi rezolvata.
       Cheia folosita aici e cea pe care salvarea o traduce in identificatorul final. */
    (typeof sessionGuests !== 'undefined' ? sessionGuests : []).forEach(function (g) {
        if (!g) return;
        const gkey = g.dbId || g.key;
        if (!gkey) return;
        const safeName = String(g.name || '').replace(/\s+/g, '-');
        const el = document.getElementById('score-guest-' + safeName);
        if (el) out[gkey] = parseFloat(el.value) || 0;
    });
    return out;
}

function onSessionScoreInput() {
    if (typeof renderTieBreakBar === 'function') renderTieBreakBar();
}

function renderTieBreakBar() {
    const bar = document.getElementById('sessionTieBreakBar');
    if (!bar) return;
    const sel = document.getElementById('sessionScoreMode');
    const uniform = !!(sel && sel.value === 'uniform');
    const friendly = !!(document.getElementById('sessionFriendly') && document.getElementById('sessionFriendly').checked);
    const coop = (typeof currentSessionType !== 'undefined' && currentSessionType === 'coop');
    const campaign = (typeof currentScoreKind === 'function') && currentScoreKind() === 'campaign';
    if (typeof sessionTieBreaks === 'undefined') { try { sessionTieBreaks = {}; } catch (e) { logError('renderTieBreakBar', e); } }
    if (!uniform || friendly || coop || campaign) { bar.innerHTML = ''; sessionTieBreaks = {}; return; }

    const scores = readSessionScoresLive();
    const ties = (typeof detectScoreTies === 'function') ? detectScoreTies(Object.keys(scores), scores) : [];
    /* Curăță departajările pentru jucători care nu mai sunt la egalitate. */
    const tiedSet = {}; ties.forEach(g => g.forEach(p => { tiedSet[p] = 1; }));
    Object.keys(sessionTieBreaks).forEach(k => { if (!tiedSet[k]) delete sessionTieBreaks[k]; });

    if (!ties.length) { bar.innerHTML = ''; return; }

    /* Invitatii nu exista in lista de membri, deci `displayNameById` nu-i gaseste
       si s-ar afisa cheia interna. Ii cautam intai printre invitati. */
    const nm = id => {
        const g = (typeof sessionGuests !== 'undefined' ? sessionGuests : [])
            .find(x => x && (x.dbId || x.key) === id);
        if (g && g.name) return g.name;
        return (typeof displayNameById === 'function' && displayNameById(id)) || id;
    };
    bar.innerHTML = `
        <div style="border:1px solid var(--accent-gold,#ffd700); background:rgba(255,215,0,0.06); border-radius:10px; padding:12px; margin-bottom:14px;">
            <div style="font-weight:700; display:flex; align-items:center; gap:8px;"><i class="fas fa-khanda" style="color:var(--accent-gold,#ffd700);"></i> ${t('session.tieBreakTitle')}</div>
            <small style="color:var(--text-secondary); display:block; margin:4px 0 10px;">${t('session.tieBreakHint')}</small>
            ${ties.map(group => {
                const sc = scores[group[0]];
                return `<div style="margin-top:8px;">
                    <div style="font-size:0.82em; color:var(--text-secondary); margin-bottom:6px;">${t('session.tieAt')} <strong>${sc}</strong> ${t('hist.points')}</div>
                    <div style="display:flex; flex-wrap:wrap; gap:8px;">
                        ${group.map(pid => {
                            const on = !!sessionTieBreaks[pid];
                            return `<button type="button" class="btn btn-sm ${on ? 'btn-primary' : 'btn-secondary'}" style="width:auto; flex:none;" onclick="toggleTieBreak('${window.attrJs(pid)}')">
                                <i class="fas fa-${on ? 'trophy' : 'khanda'}"></i> ${window.escHtml(nm(pid))}
                            </button>`;
                        }).join('')}
                    </div>
                </div>`;
            }).join('')}
        </div>`;
}

/* Marchează câștigătorul departajării în grupul lui (un singur câștigător/grup). */
function toggleTieBreak(pid) {
    if (typeof sessionTieBreaks === 'undefined') { try { sessionTieBreaks = {}; } catch (e) { logError('toggleTieBreak', e); } }
    const scores = readSessionScoresLive();
    const ties = (typeof detectScoreTies === 'function') ? detectScoreTies(Object.keys(scores), scores) : [];
    let group = [];
    for (const g of ties) { if (g.indexOf(pid) !== -1) { group = g; break; } }
    const wasOn = !!sessionTieBreaks[pid];
    group.forEach(p => { delete sessionTieBreaks[p]; });
    if (!wasOn) sessionTieBreaks[pid] = true;
    renderTieBreakBar();
}

function recalcGuestScoresheet(tid, safeName) {
    const gameName = (document.getElementById('sessionGame') || {}).value || '';
    const fields = scoresheetFor(gameName) || [];
    let sum = 0;
    fields.forEach((_, i) => { const el = document.getElementById('ssg-' + tid + '-' + i); sum += parseFloat(el && el.value) || 0; });
    const tot = document.getElementById('score-guest-' + safeName); if (tot) tot.value = sum;
    /* ★ Simetric cu `recalcScoresheet`: totalul s-a schimbat, deci departajarea
       trebuie recalculata. Lipsa acestui apel facea ca invitatii cu foaie de scor
       sa nu apara niciodata la egalitati. */
    if (typeof onSessionScoreInput === 'function') onSessionScoreInput();
}

function addGuest() {
    if (liveWriteBlocked()) return;
    const name = document.getElementById('guestName').value.trim();
    const email = document.getElementById('guestEmail').value.trim();

    if (!name) {
        showNotification(t('m1.enterGuestName'), 'error');
        return;
    }
    /* Z2-A: email obligatoriu la invitați. Cu email, dedup-ul pe email (server) previne
       proliferarea de profiluri-fantomă „acelaşi Ion” în sesiuni diferite. */
    if (!email) {
        showNotification(t('m1.guestEmailRequired'), 'error');
        return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showNotification(t('m1.guestEmailInvalid'), 'error');
        return;
    }
    const _emailLc = email.toLowerCase();
    /* Bariera anti-duplicat pe EMAIL (nu doar nume): același email nu poate fi adăugat
       de două ori în sesiune și nu poate coincide cu un membru existent al clubului
       (altfel dedup-ul server îi contopește -> confuzie „doi guests, un singur cont”). */
    if (sessionGuests.some(g => (g.email || '').toLowerCase() === _emailLc)) {
        showNotification(t('m1.guestEmailDupSession'), 'warning');
        return;
    }
    const _membersSrc = (state.membersById && Object.keys(state.membersById).length) ? state.membersById : (state.members || {});
    const _isMemberEmail = Object.keys(_membersSrc).some(k => ((_membersSrc[k] && _membersSrc[k].email) || '').toLowerCase() === _emailLc);
    if (_isMemberEmail) {
        showNotification(t('m1.guestEmailIsMember'), 'warning');
        return;
    }

    // Check if already added
    if (sessionGuests.some(g => g.name === name)) {
        showNotification(t('m1.guestAlready'), 'warning');
        return;
    }

    // Add to session guests (key = cheie cronometru stabilă)
    const guest = { name, email: email, key: 'g_' + Math.random().toString(36).slice(2, 10) };
    sessionGuests.push(guest);
    _gemSave();   /* 9.1: emailul rămâne pe dispozitiv, ca să nu se piardă la refresh */

    // Re-randează lista (include cronometrul și pentru invitați)
    renderSessionPlayers();
    /* Oaspeții fac parte din foaie (au cheie de ceas). `renderSessionPlayers` nu mai
       trimite foaia (ar fi ciclu de feedback), deci o trimitem explicit aici. */
    try { if (typeof pushLiveSheet === 'function') pushLiveSheet(); } catch (e) { logError('guests', e); }

    // Clear inputs
    document.getElementById('guestName').value = '';
    document.getElementById('guestEmail').value = '';
    
    showNotification(t('m1.guestAdded').replace('{name}', name), 'success');
}

/* ============================================================
   9.1 — Emailurile invitaților supraviețuiesc unui refresh.
   RO: foaia live NU conține emailul invitatului, și pe bună dreptate: o citesc TOȚI
       membrii clubului, iar emailul dat de admin n-are ce căuta la ei (§48). Efectul
       secundar era însă că, după refresh, emailul dispărea, serverul refuza salvarea
       („Emailul invitatului este obligatoriu") și nu mai aveai de unde să-l reintroduci.
       Îl ținem DOAR pe dispozitivul celui care l-a tastat, legat de sesiune. Pe alt
       dispozitiv sau după golirea datelor, îl cerem la salvare (`ensureGuestEmails`).
   EN: the live sheet must not carry guest emails (all club members can read it), so we
       keep them on the host's own device and ask again at save time when missing.
   ============================================================ */
/* ============================================================
   9.2 — Revenirea în sesiune după un refresh.
   RO: legătura dintre formular și sesiunea live trăia doar în memoria paginii, așa că
       un refresh (sau închiderea aplicației) te lăsa cu „Sesiune nouă", chiar dacă masa
       era vie pe server. Reținem pe dispozitiv DOAR identificatorul mesei și momentul.
       Nicio dată personală. La pornire o redeschidem, dacă mai e deschisă și dacă avem
       drept de scriere. Fereastra de 12 ore acoperă o seară întreagă cu pauze, dar
       împiedică aplicația să te arunce în tab-ul Sesiune peste trei zile.
   EN: remember only the live session id + timestamp on this device, and reopen it on
       start when it is still open and we may write. 12h window.
   ============================================================ */
const _LIVE_LAST_KEY = 'to_live_last';
const _LIVE_LAST_MAX_MS = 12 * 60 * 60 * 1000;

function _liveLastRemember(id) {
    try {
        if (!id) return;
        localStorage.setItem(_LIVE_LAST_KEY, JSON.stringify({ id: String(id), at: Date.now() }));
    } catch (e) { logError('_liveLastRemember', e); }
}
function _liveLastForget() {
    try { localStorage.removeItem(_LIVE_LAST_KEY); } catch (e) { logError('_liveLastForget', e); }
}
window._liveLastForget = _liveLastForget;

/* Chemată la pornire, DUPĂ ce lista de sesiuni live a fost încărcată. */
function restoreLiveBinding() {
    try {
        if (window._liveSessionId) return false;            /* deja legați: nimic de făcut */
        if (typeof isDemoMode === 'function' && isDemoMode()) return false;
        const raw = localStorage.getItem(_LIVE_LAST_KEY);
        if (!raw) return false;
        const rec = JSON.parse(raw) || {};
        if (!rec.id || !rec.at || (Date.now() - rec.at) > _LIVE_LAST_MAX_MS) { _liveLastForget(); return false; }
        const s = (state.liveSessions || []).find(function (x) { return String(x.id) === String(rec.id); });
        if (!s) { _liveLastForget(); return false; }        /* salvată, abandonată sau alt club */
        /* Doar cine poate scrie: altfel am deschide cuiva o masă în doar-vizualizare,
           fără s-o fi cerut. Regula e identică cu cea din `openLiveCard`. */
        const mine = (typeof lsIAmHost === 'function') && lsIAmHost(s);
        if (!mine && !(typeof can === 'function' && can('live.manage'))) return false;
        if (typeof openLiveCard !== 'function') return false;
        openLiveCard(s.id);
        return true;
    } catch (e) { logError('restoreLiveBinding', e); return false; }
}
window.restoreLiveBinding = restoreLiveBinding;

const _GEM_PREFIX = 'to_guest_emails_';

/* Ștergem intrările sesiunilor care nu mai sunt deschise: altfel emailurile ar rămâne
   pe dispozitiv la nesfârșit, iar §48 cere să nu păstrăm date personale fără motiv. */
function _gemPrune() {
    try {
        const alive = {};
        (state.liveSessions || []).forEach(function (s) { if (s && s.id) alive[_GEM_PREFIX + s.id] = 1; });
        const drop = [];
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (k && k.indexOf(_GEM_PREFIX) === 0 && !alive[k]) drop.push(k);
        }
        drop.forEach(function (k) { localStorage.removeItem(k); });
    } catch (e) { logError('_gemPrune', e); }
}

function _gemSave() {
    const id = window._liveSessionId;
    try {
        _gemPrune();
        if (!id) return;
        const map = {};
        (typeof sessionGuests !== 'undefined' ? sessionGuests : []).forEach(function (g) {
            if (g && g.key && g.email) map[g.key] = g.email;
        });
        if (Object.keys(map).length) localStorage.setItem(_GEM_PREFIX + id, JSON.stringify(map));
        else localStorage.removeItem(_GEM_PREFIX + id);
    } catch (e) { logError('_gemSave', e); }
}
window._gemSave = _gemSave;

/* Completează `sessionGuests[].email` din magazia locală. Nu suprascrie niciodată un
   email deja prezent în memorie (acela e mai proaspăt). */
function _gemRestore(sessionId) {
    try {
        const raw = localStorage.getItem(_GEM_PREFIX + sessionId);
        if (!raw) return;
        const map = JSON.parse(raw) || {};
        (typeof sessionGuests !== 'undefined' ? sessionGuests : []).forEach(function (g) {
            if (g && g.key && !g.email && map[g.key]) g.email = map[g.key];
        });
    } catch (e) { logError('_gemRestore', e); }
}
window._gemRestore = _gemRestore;

/* Validare identică cu cea din `addGuest` — aceleași reguli, același text de eroare.
   Întoarce '' dacă e în regulă, altfel cheia i18n a motivului. */
function _guestEmailProblem(email, forGuest) {
    const lc = String(email || '').trim().toLowerCase();
    if (!lc) return 'm1.guestEmailRequired';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(lc)) return 'm1.guestEmailInvalid';
    const dup = (typeof sessionGuests !== 'undefined' ? sessionGuests : [])
        .some(function (g) { return g !== forGuest && (g.email || '').toLowerCase() === lc; });
    if (dup) return 'm1.guestEmailDupSession';
    const src = (state.membersById && Object.keys(state.membersById).length) ? state.membersById : (state.members || {});
    const isMember = Object.keys(src).some(function (k) { return ((src[k] && src[k].email) || '').toLowerCase() === lc; });
    if (isMember) return 'm1.guestEmailIsMember';
    return '';
}

/* Cheamă-o ÎNAINTE de a salva. Cere emailurile lipsă, unul câte unul.
   Întoarce `false` dacă utilizatorul a renunțat -> salvarea se oprește, fără eroare
   de server și fără date pierdute. Invitații deja existenți în baza de date (`dbId`)
   au acolo emailul, deci îi sărim. */
async function ensureGuestEmails() {
    const list = (typeof sessionGuests !== 'undefined' && Array.isArray(sessionGuests)) ? sessionGuests : [];
    if (!list.length) return true;
    if (window._liveSessionId) _gemRestore(window._liveSessionId);
    for (const g of list) {
        if (!g || g.dbId) continue;
        if ((g.email || '').trim() && !_guestEmailProblem(g.email, g)) continue;
        let val = (g.email || '').trim();
        /* Buclă: insistăm până primim un email valid sau până se renunță explicit. */
        for (;;) {
            const ans = await promptModal(
                t('m1.guestEmailAskMsg').replace('{name}', g.name || ''),
                val,
                { title: t('m1.guestEmailAskTitle'), placeholder: 'nume@exemplu.com' }
            );
            if (ans === null) return false;                 /* Anulează / Escape */
            val = String(ans).trim();
            const problem = _guestEmailProblem(val, g);
            if (!problem) break;
            showNotification(t(problem), 'error');
        }
        g.email = val;
    }
    _gemSave();
    return true;
}
window.ensureGuestEmails = ensureGuestEmails;

function removeGuest(guestName) {
    if (liveWriteBlocked()) return;
    const index = sessionGuests.findIndex(g => g.name === guestName);
    if (index > -1) {
        sessionGuests.splice(index, 1);
    }
    if (typeof liveTimer !== 'undefined' && liveTimer.activePlayer === guestName) {
        bankActivePlayer(); liveTimer.activePlayer = null; maybeStopInterval();
    }
    if (typeof liveTimer !== 'undefined' && liveTimer.playerAccumMs) delete liveTimer.playerAccumMs[guestName];
    _gemSave();   /* 9.1: nu păstrăm emailul unui invitat scos de la masă (§48) */
    renderSessionPlayers();
    /* Oaspeții fac parte din foaie (au cheie de ceas). `renderSessionPlayers` nu mai
       trimite foaia (ar fi ciclu de feedback), deci o trimitem explicit aici. */
    try { if (typeof pushLiveSheet === 'function') pushLiveSheet(); } catch (e) { logError('guests', e); }
    showNotification(t('m1.guestRemoved').replace('{name}', guestName), 'success');
}

function clearSessionForm() {
    /* ⚠⚠ ORDINEA E CRITICĂ — aici era coruperea sesiunilor live paralele.
       Golirea câmpurilor NU e tăcută: `clearSessionGame()` (linia ~556) și
       `renderSessionPlayers()` cheamă `pushLiveSheet()`, care trimite foaia
       la sesiunea live de care e legat formularul. Iar dezlegarea
       (`_liveSessionId = null`) se făcea abia la SFÂRȘITUL funcției.
       Rezultat: golirea formularului trimitea o foaie GOALĂ în sesiunea live
       ÎNCĂ legată — adică îi ștergea jocul și jucătorii. Se vedea cel mai clar
       când porneai a doua sesiune live din dashboard: `openLiveSessionFromSheet(true)`
       cheamă `clearSessionForm()` cât timp formularul e legat de PRIMA sesiune.
       Corecția: ne dezlegăm ÎNTÂI, apoi golim. „Detach, then clear", nu invers.
       EN: clearing the form emits `pushLiveSheet()`; unbinding happened only at
       the end, so clearing wiped the still-bound live session. Unbind first. */
    window._liveSessionId = null;
    window._liveReadOnly = false;
    window._liveRosterPending = false;      /* formular nou -> nimic de protejat */
    /* 9.1: formular nou = datele partidei deja salvate nu mai sunt pe ecran, deci garda
       anti-dublare nu mai are ce apăra. EN: fresh form -> clear the duplicate guard. */
    window._liveSavedElsewhereId = null;
    window._liveSavedElsewhereMatch = null;
    _liveLastForget();   /* 9.2: formular nou -> nu ne mai întoarce nimeni la masa veche */

    document.getElementById('sessionDate').value = new Date().toISOString().split('T')[0];
    document.getElementById('sessionStartTime').value = new Date().toTimeString().slice(0, 5);
    document.getElementById('sessionDuration').value = '';
    if (typeof clearSessionGame === 'function') clearSessionGame(); else document.getElementById('sessionGame').value = '';
    document.getElementById('sessionLocation').value = '';
    document.getElementById('sessionNotes').value = '';
    if (document.getElementById('tournamentName')) document.getElementById('tournamentName').value = '';
    if (document.getElementById('tournamentPrize')) document.getElementById('tournamentPrize').value = '';
    if (document.getElementById('tournamentFee')) document.getElementById('tournamentFee').value = '';

    /* Reset COMPLET al stării de sesiune. Notă: renderSessionPlayers păstrează acum
       scorurile (snapshot/restore), deci trebuie să golim explicit jucătorii/invitații/
       departajările ÎNAINTE de re-randare — altfel scorurile vechi ar reapărea. */
    sessionPlayers = [];
    sessionGuests = [];
    try { sessionTieBreaks = {}; } catch (e) { logError('clearSessionForm', e); }
    sessionPhotoFiles = [];
    sessionPhotoPaths = [];   /* 9.3: și pozele deja urcate ale mesei anterioare */
    try { const pv = document.getElementById('sessionPhotoPreview'); if (pv) pv.innerHTML = ''; const fi = document.getElementById('sessionPhotos'); if (fi) fi.value = ''; } catch (e) { logError('clearSessionForm', e); }
    var _fr = document.getElementById('sessionFriendly'); if (_fr) _fr.checked = false;
    /* Golește comutatorul de scorare ca să revină la modul implicit al clubului. */
    try { const _smw = document.getElementById('sessionScoreModeWrap'); if (_smw) _smw.innerHTML = ''; } catch (e) { logError('clearSessionForm', e); }

    renderSessionPlayers();
    if (typeof renderSessionScoreMode === 'function') renderSessionScoreMode();
    if (typeof renderSessionScoreDir === 'function') renderSessionScoreDir();
    if (typeof resetLiveTimer === 'function') resetLiveTimer();
    if (typeof clearTimerState === 'function') clearTimerState();
    /* Dezlegarea de sesiunea live s-a MUTAT la începutul funcției — vezi nota de acolo.
       O lăsăm și aici, idempotent, ca plasă de siguranță. */
    window._liveSessionId = null;
    if (typeof syncGoLiveBtn === 'function') syncGoLiveBtn();

    // Reset session type
    setSessionType('standard');
}

/* ================= PLAYER MANAGEMENT ================= */
function renderPlayers() {
    /* ★ Etapa 3: cine are cont si cine nu se afla DOAR de la server (browserul nu
       are acces la zona de autentificare). Cerere unica per club, in fundal;
       cand raspunsul soseste, lista se re-randeaza singura. */
    try { if (typeof paRefreshActivationStatus === 'function') paRefreshActivationStatus(false); }
    catch (e) { if (typeof logError === 'function') logError('renderPlayers activation', e); }
    renderPlayersGrid();
    updatePlayerStats();
    
    // Show/hide admin buttons
    const bulkDeleteBtn = document.getElementById('bulkDeleteBtn');
    if (bulkDeleteBtn) {
        bulkDeleteBtn.style.display = isAdmin ? 'inline-flex' : 'none';
    }
}

var playersExpanded = false;
function renderPlayersGrid() {
    const grid = document.getElementById('playersGrid');
    const searchTerm = document.getElementById('playerSearch')?.value.toLowerCase() || '';
    
    // Filter players based on search
    const filteredPlayers = getSortedPlayers().filter(player => 
        player.name.toLowerCase().includes(searchTerm) ||
        (player.email && player.email.toLowerCase().includes(searchTerm))
    );
    
    if (filteredPlayers.length === 0) {
        grid.innerHTML = `
            <div class="card" style="grid-column: 1 / -1; text-align: center; padding: 40px;">
                <h3><i class="fas fa-users-slash"></i> ${t('players.noneFound')}</h3>
                <p style="color: var(--text-secondary); margin-top: 10px;">
                    ${searchTerm ? t('common.tryOtherSearch') : t('players.addFirst')}
                </p>
            </div>
        `;
        return;
    }
    
    const eloMap = (state.eloEnabled && typeof computeElo === 'function') ? computeElo() : {};
    const bannedSection = (isAdmin && state.bannedList && state.bannedList.length) ? `
        <div class="card" style="grid-column: 1 / -1; border-left:4px solid #b23b3b;">
            <h3 style="margin:0 0 8px;"><i class="fas fa-ban"></i> ${t('players.banned')} (${state.bannedList.length})</h3>
            ${state.bannedList.map(b => `<div style="display:flex; justify-content:space-between; align-items:center; gap:10px; padding:6px 0; border-bottom:1px solid var(--border,#333);">
                <span>${clubEsc(b.name)}</span>
                <button class="btn btn-sm btn-secondary" style="width:auto; min-width:auto; padding:8px 12px;" data-pl-act="unban" data-id="${window.escHtml(b.id)}" data-name="${window.escHtml(b.name||'')}"><i class="fas fa-rotate-left"></i> ${t('players.unban')}</button>
            </div>`).join('')}
        </div>` : '';
    const PLAYERS_LIMIT = 6;
    const plIsMobile = !!(window.matchMedia && window.matchMedia('(max-width: 720px)').matches);
    const plCollapse = plIsMobile && !searchTerm && !playersExpanded && filteredPlayers.length > PLAYERS_LIMIT;
    const shownPlayers = plCollapse ? filteredPlayers.slice(0, PLAYERS_LIMIT) : filteredPlayers;
    grid.innerHTML = bannedSection + shownPlayers.map(player => {
        const gamesPlayed = player.gamesPlayed || 0;
        const avgScore = gamesPlayed > 0 ? (player.score / gamesPlayed).toFixed(2) : '0.00';
        const wins = countWins(player.dbId);
        const winRate = gamesPlayed > 0 ? ((wins / gamesPlayed) * 100).toFixed(0) : '0';
        const lastMonthGames = getPlayerRecentGames(player.dbId, 30);
        const activityLevel = lastMonthGames >= 5 ? 'high' : lastMonthGames >= 2 ? 'medium' : 'low';
        const roleSlug = (state.memberRoleByName && state.memberRoleByName[player.name]) || (player.dbId && state.memberRoleById && state.memberRoleById[player.dbId]) || 'member';
        const roleClass = ({ principal_admin: 'principal', secondary_admin: 'secondary', moderator: 'moderator', member: 'member' })[roleSlug] || 'member';
        const roleLabel = (typeof clubRoleLabel === 'function') ? clubRoleLabel(roleSlug) : roleSlug;

        /* ★ Etapa 3: starea de activare. `null` = nu o stim (nu suntem admin sau
           inca nu a sosit raspunsul), caz in care nu afisam absolut nimic. */
        const paSt = (typeof paStatusOf === 'function' && player.dbId) ? paStatusOf(player.dbId) : null;
        const paNeactivat = !!(paSt && paSt.activated === false);
        const paLinkActiv = !!(paNeactivat && paSt.link_state === 'active');
        const paExpira = (paLinkActiv && paSt.link_expires)
            ? new Date(paSt.link_expires).toLocaleDateString(undefined, { day: 'numeric', month: 'short' })
            : '';

        return `
            <div class="player-card player-card-compact">
                <div class="player-header">
                    <span class="pl-avatar">${(typeof avatarHtml === 'function') ? avatarHtml(player.avatar, 30) : ''}<span class="presence-dot${(typeof isUserOnline === 'function' && (isUserOnline(player.dbId) || isUserOnline(player.name))) ? ' on' : ''}" data-presence-id="${window.attrJs(player.dbId || '')}" data-presence-name="${window.attrJs(player.name || '')}"></span></span>
                    <span class="pl-name" title="${t('common.viewProfile')}" data-pl-act="profile" data-id="${window.escHtml(player.dbId || player.name)}">${window.escHtml(player.name)}</span>
                    ${(player.dbId && state.memberMuted && state.memberMuted[player.dbId]) ? '<span class="badge pl-mini-pill" style="background:#9a6b00; color:#fff;">🔇</span>' : ''}
                    <span class="role-pill role-${roleClass} pl-mini-pill" data-i18n="role.${roleClass}">${roleLabel}</span>
                    <span class="badge badge-${activityLevel === 'high' ? 'success' : activityLevel === 'medium' ? 'warning' : 'danger'} pl-mini-pill">${activityLevel === 'high' ? t('players.actActive') : activityLevel === 'medium' ? t('players.actModerate') : t('players.actInactive')}</span>
                    ${paLinkActiv
                        ? `<span class="badge pl-mini-pill" style="background:#2b6cb0; color:#fff;" title="${window.attrJs(t('pact.admin.expiresOn') + ' ' + paExpira)}"><i class="fas fa-paper-plane"></i> ${t('pact.admin.linkSent')}</span>`
                        : (paNeactivat
                            ? `<span class="badge pl-mini-pill" style="background:#6b7280; color:#fff;" title="${window.attrJs(t('pact.admin.noAccountTip'))}"><i class="fas fa-user-slash"></i> ${t('pact.admin.noAccount')}</span>`
                            : '')}
                </div>

                <div class="player-mini">
                    ${state.eloEnabled ? `<span class="pm-item"><b>${eloMap[player.dbId] != null ? eloMap[player.dbId] : 1000}</b> ELO</span>` : ''}
                    <span class="pm-item"><b>${gamesPlayed}</b> ${t('players.statGames')}</span>
                    <span class="pm-item"><b>${winRate}%</b> ${t('players.statWin')}</span>
                    <span class="pm-item"><b>${avgScore}</b> ${t('players.statAvg')}</span>
                    <span class="pm-item"><b>${player.score.toFixed(1)}</b> ${t('players.statPts')}</span>
                </div>

                ${isAdmin ? `
                    <div class="player-actions">
                        ${isAdmin ? `<button class="btn btn-sm btn-secondary" title="${t('common.edit')}" aria-label="${t('common.edit')}" data-pl-act="edit" data-id="${window.escHtml(player.dbId || player.name)}"><i class="fas fa-edit"></i></button>` : ''}
                        ${(player.dbId && player.dbId !== (state.currentUser && state.currentUser.id)
                            && typeof can === 'function' && can('member.mute')) ? (
                            (state.memberMuted && state.memberMuted[player.dbId])
                            ? `<button class="btn btn-sm btn-secondary" title="${t('common.unmute')}" aria-label="${t('common.unmute')}" data-pl-act="unmute" data-id="${window.escHtml(player.dbId)}" data-name="${window.escHtml(player.name)}"><i class="fas fa-volume-high"></i></button>`
                            : `<button class="btn btn-sm btn-secondary" title="${t('common.mute')}" aria-label="${t('common.mute')}" data-pl-act="mute" data-id="${window.escHtml(player.dbId)}" data-name="${window.escHtml(player.name)}"><i class="fas fa-volume-xmark"></i></button>`
                        ) : ''}
                        ${(isAdmin && player.dbId && player.dbId !== (state.currentUser && state.currentUser.id)) ? `<button class="btn btn-sm btn-danger" title="${t('common.ban')}" aria-label="${t('common.ban')}" data-pl-act="ban" data-id="${window.escHtml(player.dbId)}" data-name="${window.escHtml(player.name)}"><i class="fas fa-ban"></i></button>` : ''}
                        ${paNeactivat ? `<button class="btn btn-sm btn-secondary" title="${window.attrJs(paLinkActiv ? t('pact.admin.newLink') : t('pact.admin.sendLink'))}" aria-label="${window.attrJs(paLinkActiv ? t('pact.admin.newLink') : t('pact.admin.sendLink'))}" data-pl-act="pa-issue" data-id="${window.escHtml(player.dbId)}" data-name="${window.escHtml(player.name || '')}"><i class="fas fa-user-check"></i></button>` : ''}
                        ${paLinkActiv ? `<button class="btn btn-sm btn-secondary" title="${window.attrJs(t('pact.admin.revoke'))}" aria-label="${window.attrJs(t('pact.admin.revoke'))}" data-pl-act="pa-revoke" data-id="${window.escHtml(player.dbId)}" data-name="${window.escHtml(player.name || '')}"><i class="fas fa-link-slash"></i></button>` : ''}
                        ${isAdmin ? `<button class="btn btn-sm btn-danger" title="${t('common.delete')}" aria-label="${t('common.delete')}" data-pl-act="delete" data-id="${window.escHtml(player.dbId || player.name)}"><i class="fas fa-trash"></i></button>` : ''}
                    </div>
                ` : ''}
            </div>
        `;
    }).join('');
    try { if (typeof refreshPresenceDots === 'function') refreshPresenceDots(); } catch (e) { if (typeof logError === 'function') logError('renderPlayersGrid presence', e); }

    // Buton „Vezi mai mult / mai puțin" (mobil, cluburi mari)
    var moreBox = document.getElementById('playersShowMore');
    if (moreBox) {
        var canCollapse = plIsMobile && !searchTerm && filteredPlayers.length > PLAYERS_LIMIT;
        if (!canCollapse) {
            moreBox.innerHTML = '';
        } else if (playersExpanded) {
            moreBox.innerHTML = '<button type="button" class="btn btn-sm btn-secondary players-more-btn" data-pl-act="more"><i class="fas fa-chevron-up"></i> ' + t('players.showLess') + '</button>';
        } else {
            var hidden = filteredPlayers.length - PLAYERS_LIMIT;
            moreBox.innerHTML = '<button type="button" class="btn btn-sm btn-secondary players-more-btn" data-pl-act="more"><i class="fas fa-chevron-down"></i> ' + t('players.showMore') + ' (' + hidden + ')</button>';
        }
    }
}

function togglePlayersExpanded() {
    playersExpanded = !playersExpanded;
    if (typeof renderPlayersGrid === 'function') renderPlayersGrid();
}

/* v9 zona 3 — Jucători și clasament (3 nov. 2026): fără handlere inline (erau 45): tabul Jucători (butonul „online",
   Adaugă / Caută / Unelte, adăugarea, căutarea, export / import / ștergere în masă), grila jucătorilor (profil, editează,
   mute, ban, linkul de activare, șterge, „Vezi mai mult"), clasamentul de pe Acasă (Puncte / Scoruri, profilul, „Vezi mai
   mult"), panoul „online" și ferestrele zonei: importul, ștergerea în masă, editarea scorului, linkul de activare, profilul
   (ultimele trei în supabase-integration.js). O singură delegare pe `document`, pe CAPTURĂ, legată o dată; fiecare acțiune
   cheamă ACEEAȘI funcție cu aceleași argumente ca vechiul `onclick`; id-urile și numele sunt DATE (`data-id` /
   `data-name`, escHtml), nu cod. Ferestrele zonei sunt marcate `data-back` („înapoi" de pe telefon le închide).
   EN: players & leaderboard zone without inline handlers; one capture-phase delegation; same calls; ids and names as data. */
(function () {
    if (document.__toPlayersActs) return;
    document.__toPlayersActs = true;
    document.addEventListener('click', function (e) {
        const el = e.target && e.target.closest ? e.target.closest('[data-pl-act]') : null;
        if (!el) return;
        const id = el.getAttribute('data-id'), nm = el.getAttribute('data-name');
        switch (el.getAttribute('data-pl-act')) {
            case 'online': togglePlayersOnlinePanel(); break;
            case 'tile': toggleTilePanel(el.getAttribute('data-panel'), el); break;
            case 'add': addPlayer(); break;
            case 'export-csv': exportPlayersCSV(); break;
            case 'import': importPlayersModal(); break;
            case 'bulk-delete': bulkDeleteModal(); break;
            case 'unban': unbanMember(id, nm); break;
            case 'profile': openPlayerProfile(id); break;
            case 'edit': editPlayer(id); break;
            case 'mute': muteMember(id, nm); break;
            case 'unmute': unmuteMember(id, nm); break;
            case 'ban': banMember(id, nm); break;
            case 'pa-issue': paIssueLinkFor(id, nm); break;
            case 'pa-revoke': paRevokeLinkFor(id, nm); break;
            case 'delete': deletePlayer(id); break;
            case 'more': togglePlayersExpanded(); break;
            case 'lb-view': setLbPtsView(el.getAttribute('data-mode')); break;
            case 'lb-profile': openLeaderboardProfile(id); break;
            case 'lb-more': toggleLeaderboard(); break;
            case 'online-profile': { const p = document.getElementById('playersOnlinePanel'); if (p) p.classList.add('hidden'); openLeaderboardProfile(id); break; }
            case 'close': { const m = el.closest('.modal'); if (m) m.remove(); break; }
            case 'import-run': processPlayerImport(); break;
            case 'bulk-run': processBulkDeletePlayers(); break;
            case 'es-adj': esAdjust(Number(el.getAttribute('data-d'))); break;
            case 'es-save': saveEditScore(id); break;
            case 'select': el.select(); break;
            case 'copy-link': copyInviteLink(); break;
        }
    }, true);
    document.addEventListener('input', function (e) {
        const el = e.target;
        if (el && el.getAttribute && el.getAttribute('data-pl-field') === 'search') searchPlayers();
    }, true);
    document.addEventListener('change', function (e) {
        const el = e.target, f = el && el.getAttribute ? el.getAttribute('data-pl-field') : null;
        if (f === 'bulk-all') document.querySelectorAll('.bulk-player-cb').forEach(c => { c.checked = el.checked; });
        else if (f === 'import-file') {
            /* ca vechiul onchange: fișierul ales se citește ca text în câmpul de lipire */
            const file = el.files && el.files[0]; if (!file) return;
            const r = new FileReader();
            r.onload = function (ev) { const ta = document.getElementById('importPlayersText'); if (ta) ta.value = ev.target.result; };
            r.readAsText(file);
        }
    }, true);
})();

function getPlayerRecentGames(playerId, days = 30) {
    const cutoff = new Date(Date.now() - days * 24 * 60 * 60 * 1000);
    return state.games.filter(game => 
        game.timestamp && 
        new Date(game.timestamp) > cutoff &&
        game.participants?.includes(playerId)
    ).length;
}

function _membersSrc() {
    return (state.membersById && Object.keys(state.membersById).length) ? state.membersById : (state.members || {});
}

function updatePlayerStats() {
    const activePlayers = Object.values(_membersSrc()).filter(m => !m.hidden).length;
    const newThisMonth = getNewPlayersThisMonth();
    const avgFrequency = getAverageFrequency();
    const participationRate = getParticipationRate();
    
    document.getElementById('stat-total-active').textContent = activePlayers;
    document.getElementById('stat-new-this-month').textContent = newThisMonth;
    document.getElementById('stat-avg-frequency').textContent = avgFrequency.toFixed(1);
    document.getElementById('stat-participation-rate').textContent = `${participationRate}%`;
}

function getNewPlayersThisMonth() {
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    
    return Object.values(_membersSrc()).filter(member => {
        if (!member.joinDate) return false;
        const joinDate = new Date(member.joinDate);
        return joinDate >= startOfMonth && !member.hidden;
    }).length;
}

function getAverageFrequency() {
    const activePlayers = getSortedPlayers();
    if (activePlayers.length === 0) return 0;
    
    // FIX: Calculate average games per month per player
    const totalGames = activePlayers.reduce((sum, player) => sum + (player.gamesPlayed || 0), 0);
    const monthsSinceOldest = getMonthsSinceOldestGame();
    
    return monthsSinceOldest > 0 ? (totalGames / activePlayers.length / monthsSinceOldest) : 0;
}

function getParticipationRate() {
    const totalPlayers = Object.keys(state.members).length;
    if (totalPlayers === 0) return 0;
    
    // FIX: Calculate participation rate based on last month's activity
    /* `setMonth` fără limitare sărea peste o lună întreagă în zilele de 29–31. */
    const lastMonth = addMonths(new Date(), -1);
    
    const activeLastMonth = Object.keys(state.members).filter(playerName => {
        const m = state.members[playerName];
        const lastMonthGames = getPlayerRecentGames(m && m.dbId, 30);
        return lastMonthGames > 0;
    }).length;
    
    return Math.round((activeLastMonth / totalPlayers) * 100);
}

function getMonthsSinceOldestGame() {
    if (state.games.length === 0) return 0;
    const oldestGame = new Date(Math.min(...state.games.map(g => new Date(g.timestamp).getTime())));
    const today = new Date();
    const months = (today.getFullYear() - oldestGame.getFullYear()) * 12 + 
                   (today.getMonth() - oldestGame.getMonth());
    return Math.max(1, months); // At least 1 month
}

function searchPlayers() {
    renderPlayersGrid();
}

function addPlayer() {
    const name = document.getElementById('newPlayerName').value.trim();
    const email = document.getElementById('newPlayerEmail').value.trim();
    
    if (!name) {
        showNotification(t('m1.enterPlayerName'), 'error');
        return;
    }
    
    if (state.members[name]) {
        showNotification(t('m1.playerExists'), 'error');
        return;
    }
    
    // Add player
    state.members[name] = {
        score: 0,
        gamesPlayed: 0,
        hidden: false,
        email: email || null,
        joinDate: new Date().toISOString().split('T')[0],
        preferredGames: [],
        skillLevel: 3
    };
    
    // Clear inputs
    document.getElementById('newPlayerName').value = '';
    document.getElementById('newPlayerEmail').value = '';
    
    // Add audit log
    addAuditLog('audit.playerAdded', state.currentUser.name, `${name}${email ? `, email: ${email}` : ''}`);
    
    // Save and render
    saveState();
    renderPlayers();
    
    showNotification(t('m1.playerAdded').replace('{name}', name), 'success');
}

async function editPlayer(playerName) {
    if (!isAdmin) {
        showNotification(t('m1.onlyAdminEditPlayers'), 'error');
        return;
    }
    
    const player = state.members[playerName];
    if (!player) return;
    
    const newScore = await promptModal(t('m1.newScorePrompt').replace('{name}', playerName), player.score);
    if (newScore === null) return;
    
    const score = parseFloat(newScore);
    if (isNaN(score)) {
        showNotification(t('m1.invalidScore'), 'error');
        return;
    }
    
    const oldScore = player.score;
    player.score = score;
    
    // Ask for additional edits
    const editMore = await confirmModal(t('m1.editMore'));
    if (editMore) {
        const newEmail = await promptModal(t('players.emailPromptPre') + ' ' + playerName + ' ' + t('players.emailPromptPost'), player.email || '');
        if (newEmail !== null) {
            player.email = newEmail || null;
        }
    }
    
    // Add audit log
    addAuditLog('audit.playerEdited', state.currentUser.name, 
        `${playerName}: scor ${oldScore.toFixed(1)} → ${score.toFixed(1)}, email: ${player.email || 'niciun'}`);
    
    // Save and render
    saveState();
    renderPlayers();
    renderDashboard();
    
    showNotification(t('m1.playerEdited').replace('{name}', playerName), 'success');
}

async function deletePlayer(playerName) {
    if (!await confirmModal(t('m1.confirmDeletePlayer').replace('{name}', playerName), { danger: true })) {
        return;
    }
    
    // Store player data for audit
    const playerData = state.members[playerName];
    const pid = playerData && playerData.dbId;
    
    // Remove player
    delete state.members[playerName];
    if (pid && state.membersById) delete state.membersById[pid];
    
    // Remove from games (identitate = id)
    state.games.forEach(game => {
        if (pid && game.scores && game.scores[pid] !== undefined) {
            delete game.scores[pid];
        }
        if (pid && Array.isArray(game.participants)) {
            game.participants = game.participants.filter(p => p !== pid);
        }
    });
    
    // Add audit log
    addAuditLog('audit.playerDeleted', state.currentUser.name, 
        `${playerName} (${playerData.gamesPlayed || 0} jocuri, ${playerData.score.toFixed(1)} puncte)`);
    
    // Save and render
    saveState();
    renderPlayers();
    renderDashboard();
    
    showNotification(t('m1.playerDeleted').replace('{name}', playerName), 'success');
}

/* Export CSV robust, reutilizabil (RFC-4180): fiecare celulă e quotată cu
   ghilimelele interne dublate (virgulele, ghilimelele și newline-urile din
   nume/notițe nu mai sparg coloanele), BOM UTF-8 pentru diacritice corecte în
   Excel și linia-hint „sep=," ca Excel să despartă coloanele indiferent de
   setările regionale (pe RO separatorul de listă implicit e „;"). */
function csvDownload(filename, headers, rows) {
    const esc = v => '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"';
    const lines = [headers.map(esc).join(','), ...rows.map(r => r.map(esc).join(','))];
    const csv = '\uFEFF' + 'sep=,\r\n' + lines.join('\r\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
}
window.csvDownload = csvDownload;

function exportPlayersCSV() {
    const players = getSortedPlayers();
    if (players.length === 0) {
        showNotification(t('m1.noPlayersExport'), 'error');
        return;
    }
    
    // Create CSV content
    const headers = [t('csv.name'), t('csv.email'), t('csv.points'), t('csv.plays'), t('csv.avg'), t('csv.winRate'), t('csv.joinDate')];
    const rows = players.map(player => {
        const gamesPlayed = player.gamesPlayed || 0;
        const avgScore = gamesPlayed > 0 ? (player.score / gamesPlayed).toFixed(2) : '0.00';
        const wins = countWins(player.dbId);
        const winRate = gamesPlayed > 0 ? ((wins / gamesPlayed) * 100).toFixed(0) : '0';
        /* Respectă hideEmail: un membru care și-a ascuns emailul apare cu celulă
           goală (self-ul rămâne vizibil — e adminul care exportă). state.email e
           deja null pentru cei ascunși, dar verificăm explicit pentru siguranță. */
        const isSelf = state.currentUser && (player.dbId === state.currentUser.id);
        const email = (player.hideEmail && !isSelf) ? '' : (player.email || '');

        return [
            player.name,
            email,
            player.score.toFixed(2),
            gamesPlayed,
            avgScore,
            winRate + '%',
            player.joinDate || ''
        ];
    });
    
    csvDownload(`turnorder-jucatori-${new Date().toISOString().split('T')[0]}.csv`, headers, rows);
    
    addAuditLog('audit.exportPlayersCsv', state.currentUser.name);
    showNotification(t('m1.playersExported'), 'success');
}

function importPlayersModal() {
    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.dataset.back = '1';   /* „înapoi" de pe telefon o închide (chat-core.js, v9 zona 2) */
    modal.innerHTML = `
        <div class="modal-content" style="max-width:600px;">
            <div class="modal-header">
                <h2><i class="fas fa-file-import"></i> ${t('import.playersTitle')}</h2>
                <button class="modal-close" data-pl-act="close" aria-label="${t('common.close')}">×</button>
            </div>
            <div class="form-group">
                <label for="importPlayersText"><i class="fas fa-list"></i> ${t('import.pasteLabel')}</label>
                <textarea id="importPlayersText" class="form-control" rows="8"
                    placeholder="${t('import.pastePh')}"></textarea>
                <small style="color:var(--text-secondary); display:block; margin-top:8px;">
                    ${t('import.formatHint')}
                </small>
            </div>
            <div class="form-group">
                <label for="importPlayersFile"><i class="fas fa-file-csv"></i> ${t('import.orCsv')}</label>
                <input type="file" id="importPlayersFile" accept=".csv,.txt" class="form-control"
                    data-pl-field="import-file">
            </div>
            <div class="btn-group">
                <button class="btn btn-success" data-pl-act="import-run">
                    <i class="fas fa-check"></i> ${t('common.import')}
                </button>
                <button class="btn btn-secondary" data-pl-act="close">
                    <i class="fas fa-times"></i> ${t('common.cancel')}
                </button>
            </div>
        </div>`;
    document.body.appendChild(modal);
}

async function processPlayerImport() {
    const text = document.getElementById('importPlayersText').value.trim();
    if (!text) {
        showNotification(t('m1.noPlayersEntered'), 'error');
        return;
    }

    const lines = text.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
    let added = 0, skipped = 0;

    const demo = (typeof isDemoMode === 'function') && isDemoMode();

    for (const line of lines) {
        const parts = line.split(/[,;\t]/).map(p => p.trim());
        const name = parts[0];
        if (!name || /^(nume|name)$/i.test(name)) continue;
        const email = parts[1] && parts[1].includes('@') ? parts[1] : null;

        if (demo) {
            // Demo: doar local (fără DB)
            if (state.members[name]) { skipped++; continue; }
            const id = 'guest-' + Math.random().toString(36).slice(2, 10);
            const mo = {
                dbId: id, name, displayName: name, role: 'member', userTag: '',
                score: 0, gamesPlayed: 0, hidden: false, email,
                joinDate: new Date().toISOString().split('T')[0], preferredGames: [], skillLevel: 3, isGuest: true
            };
            state.members[name] = mo;
            if (state.membersById) state.membersById[id] = mo;
            added++;
            continue;
        }

        // Real: profil garantat în DB prin RPC (dedup pe email)
        const res = await sb.rpc('admin_add_guest', { p_club_id: currentClubId, p_name: name, p_email: email });
        if (res.error || !res.data) { console.warn('import player:', res.error && res.error.message); skipped++; continue; }
        added++;
    }

    if (demo) {
        saveState();
        renderPlayers();
    } else {
        await hydrateFromSupabase();
        render();
    }
    if (typeof updatePlayerStats === 'function') updatePlayerStats();
    if (typeof updateTabBadges === 'function') updateTabBadges();
    if (state.currentUser) addAuditLog('audit.importPlayers', state.currentUser.name, `+${added} jucători`);
    document.querySelector('.modal.active')?.remove();
    showNotification(t('m1.importDone').replace('{added}', added).replace('{skipped}', skipped), 'success');
}

function bulkDeleteModal() {
    if (!isAdmin) {
        showNotification(t('m1.onlyAdminBulkDelete'), 'error');
        return;
    }

    const _msrc = (state.membersById && Object.keys(state.membersById).length) ? state.membersById : (state.members || {});
    const members = Object.values(_msrc).filter(m => m && m.dbId);
    if (members.length === 0) {
        showNotification(t('m1.noPlayersDelete'), 'warning');
        return;
    }

    const esc = s => String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');
    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.dataset.back = '1';   /* „înapoi" de pe telefon o închide (chat-core.js, v9 zona 2) */
    modal.innerHTML = `
        <div class="modal-content" style="max-width:560px;">
            <div class="modal-header">
                <h2><i class="fas fa-trash"></i> ${t('bulk.playersTitle')}</h2>
                <button class="modal-close" data-pl-act="close" aria-label="${t('common.close')}">×</button>
            </div>
            <p style="color:var(--danger); margin-bottom:12px;">
                <i class="fas fa-exclamation-triangle"></i> ${t('bulk.warningPlayers')}
            </p>
            <label style="display:block; margin-bottom:10px;">
                <input type="checkbox" data-pl-field="bulk-all"> <b>${t('common.selectAll')}</b>
            </label>
            <div style="max-height:50vh; overflow-y:auto; display:flex; flex-direction:column; gap:6px; margin-bottom:16px;">
                ${members.map(m => `
                    <label style="display:flex; align-items:center; gap:10px; padding:8px; background:var(--bg-secondary); border-radius:6px;">
                        <input type="checkbox" class="bulk-player-cb" value="${esc(m.dbId)}">
                        <span>${esc(m.name || m.displayName || '')}${m.userTag ? ' <small style="color:var(--accent-primary);">@' + esc(m.userTag) + '</small>' : ''}</span>
                        <small style="margin-left:auto; color:var(--text-secondary);">${(m.score||0).toFixed(1)} ${t('common.ptsShort')}</small>
                    </label>`).join('')}
            </div>
            <div class="btn-group">
                <button class="btn btn-danger" data-pl-act="bulk-run">
                    <i class="fas fa-trash"></i> ${t('common.deleteSelected')}
                </button>
                <button class="btn btn-secondary" data-pl-act="close">
                    <i class="fas fa-times"></i> ${t('common.cancel')}
                </button>
            </div>
        </div>`;
    document.body.appendChild(modal);
}

async function processBulkDeletePlayers() {
    if (typeof requireWritableClub === 'function' && !requireWritableClub()) return;
    const selected = Array.from(document.querySelectorAll('.bulk-player-cb:checked')).map(c => c.value);
    if (selected.length === 0) {
        showNotification(t('m1.noPlayerSelected'), 'warning');
        return;
    }
    if (!await confirmModal(t('m1.confirmBulkRemovePlayers').replace('{n}', selected.length), { danger: true })) return;

    for (const id of selected) {
        const m = (state.membersById && state.membersById[id]) || null;
        if (state.membersById) delete state.membersById[id];
        if (m && m.name && state.members[m.name] === m) delete state.members[m.name];
        if (!isDemoMode() && id) {
            const del = await sb.from('club_members').delete().eq('club_id', currentClubId).eq('profile_id', id);
            if (del.error) console.warn('bulk delete', id, del.error.message);
        }
    }

    if (!isDemoMode()) { await hydrateFromSupabase(); } else { saveState(); }
    renderPlayers();
    if (typeof updatePlayerStats === 'function') updatePlayerStats();
    if (typeof renderHistory === 'function') renderHistory();
    if (typeof renderDashboard === 'function') renderDashboard();
    if (typeof updateTabBadges === 'function') updateTabBadges();
    if (state.currentUser) addAuditLog('audit.bulkRemovePlayers', state.currentUser.name, `${selected.length} jucători`);
    document.querySelector('.modal.active')?.remove();
    showNotification(t('m1.bulkPlayersRemoved').replace('{n}', selected.length), 'success');
}

/* ================= CATALOG MANAGEMENT ================= */
/* ============================================================
   9.2 — Moduri de vizualizare pentru catalog (Compact / Extins / Grilă)
   RO: în modul de până acum se vedeau 1–2 jocuri pe ecran, deci un catalog mare
       nu putea fi parcurs. Cele trei moduri schimbă DOAR randarea; filtrarea,
       sortarea și acțiunile rămân aceleași.
   ⚠ Preferința stă pe CONT (`profiles.profile_extra.catalogView`), nu pe dispozitiv:
       cerința explicită a fost „să nu aleg modul la fiecare login". Citirea costă
       ZERO cereri — `profile_extra` vine deja cu profilul la login.
   EN: three catalog view modes; the preference lives on the account, not the device.
   ============================================================ */
var CATALOG_VIEWS = ['expanded', 'compact', 'grid'];
/* Câte jocuri arătăm la prima încărcare și cât adăugăm la fiecare apăsare pe
   „Vezi mai mult". ⚠ Un card mare ocupă mult, deci pasul e mic; în Compact și
   Grilă încap mult mai multe, deci pasul e mai mare. */
var CATALOG_STEP = { expanded: 10, compact: 24, grid: 24 };
var catalogView = 'expanded';
/* Câte jocuri sunt afișate ACUM. `null` = încă neinițializat (se pune pasul modului). */
var catalogShown = null;
var catalogExpanded = false;   /* păstrat: alte funcții îl resetează (vezi searchGames) */

/* Modul curent: memoria paginii, apoi profilul. Niciodată o cerere la rețea.
   ⚠ 9.2 — DE CE NU SE PĂSTRA PREFERINȚA: citeam doar `state.currentUser.profileExtra`,
   care NU e completat niciodată la autentificare — obiectul construit acolo preia din
   `profile_extra` doar `ownedGames`, nimic altceva. Deci după repornire cădeam mereu pe
   „Extins". Acum citim din aceleași locuri din care citesc și jocurile deținute
   (`state.users[email]` / membrul din club), iar autentificarea completează în plus
   `state.currentUser.profileExtra`, ca să nu depindem de ordinea încărcărilor.
   ⚠ Testul meu nu putea prinde asta: punea el însuși `profileExtra` pe `currentUser`,
   adică exact lucrul care în realitate nu se întâmplă.
   EN: we only read state.currentUser.profileExtra, which login never fills in; now we
   read the same sources as owned games, and login also populates it. */
function _catalogExtra() {
    try {
        if (state.currentUser && state.currentUser.profileExtra
            && typeof state.currentUser.profileExtra === 'object') return state.currentUser.profileExtra;
        const me = state.currentUser && state.currentUser.id;
        if (me && typeof _ogExtraOf === 'function') {
            const ex = _ogExtraOf(me);
            if (ex && typeof ex === 'object') return ex;
        }
    } catch (e) { logError('_catalogExtra', e); }
    return null;
}

function catalogViewNow() {
    try {
        const ex = _catalogExtra();
        const fromProfile = ex && ex.catalogView;
        if (fromProfile && CATALOG_VIEWS.indexOf(fromProfile) > -1) return fromProfile;
    } catch (e) { logError('catalogViewNow', e); }
    return (CATALOG_VIEWS.indexOf(catalogView) > -1) ? catalogView : 'expanded';
}

/* Ciclează Extins -> Compact -> Grilă și salvează pe cont. */
async function cycleCatalogView() {
    const cur = catalogViewNow();
    const next = CATALOG_VIEWS[(CATALOG_VIEWS.indexOf(cur) + 1) % CATALOG_VIEWS.length];
    catalogView = next;
    catalogShown = null;                 /* mod nou -> pornim de la primul lot */
    /* ⚠ Pornim de la `profile_extra` REAL (poate conține jocuri deținute, favorite etc.),
       nu de la un obiect gol — altfel memoria locală ar „uita" restul cheilor până la
       următoarea încărcare. Scrierea în baza de date recitește oricum din DB. */
    try {
        if (state.currentUser) {
            const _ex = Object.assign({}, _catalogExtra() || {}, { catalogView: next });
            state.currentUser.profileExtra = _ex;
            const _u = (state.currentUser.email && state.users && state.users[state.currentUser.email]) || null;
            if (_u) _u.profileExtra = _ex;
            const _m = (typeof memberById === 'function') ? memberById(state.currentUser.id) : null;
            if (_m) _m.profileExtra = _ex;
        }
    } catch (e) { logError('cycleCatalogView', e); }
    if (typeof renderCatalogGrid === 'function') renderCatalogGrid();
    syncCatalogViewBtn();
    /* Salvarea e „pe fundal": dacă eșuează, modul rămâne oricum aplicat în sesiunea
       curentă. Nu blocăm interfața pentru o preferință. */
    try { if (typeof persistCatalogView === 'function') await persistCatalogView(next); }
    catch (e) { logError('cycleCatalogView.persist', e); }
}
window.cycleCatalogView = cycleCatalogView;

/* Iconița + titlul butonului arată modul CURENT. */
function syncCatalogViewBtn() {
    const btn = document.getElementById('catTile-view');
    if (!btn) return;
    const v = catalogViewNow();
    const ic = { expanded: 'fa-list', compact: 'fa-bars', grid: 'fa-th' }[v] || 'fa-list';
    const lbl = t('catalog.view') + ': ' + t('catalog.view' + v.charAt(0).toUpperCase() + v.slice(1));
    btn.innerHTML = '<i class="fas ' + ic + '"></i>';
    btn.setAttribute('title', lbl);
    btn.setAttribute('aria-label', lbl);
}
window.syncCatalogViewBtn = syncCatalogViewBtn;

// Colectează voturile numerice (key 'r'=rating 1-10, 'w'=weight 1-5). Sursă: ratingVotes (persistent), fallback ratingsHistory.
function _gameVoteList(game, key) {
    var out = [];
    if (game && game.ratingVotes && typeof game.ratingVotes === 'object') {
        Object.keys(game.ratingVotes).forEach(function (k) {
            var v = game.ratingVotes[k];
            if (v && typeof v[key] === 'number') out.push(v[key]);
        });
    } else if (game && Array.isArray(game.ratingsHistory)) {
        var latest = {};
        game.ratingsHistory.forEach(function (r) {
            var val = key === 'r' ? r.rating : r.difficulty;
            if (typeof val === 'number') latest[r.ratedBy || '?'] = val;
        });
        Object.keys(latest).forEach(function (k) { out.push(latest[k]); });
    }
    return out;
}
// Media rating = scorul la adăugare (baseRating) + voturile jucătorilor. Scală 1-10.
function gameRatingAvg(game) {
    if (!game) return null;
    var vals = _gameVoteList(game, 'r');
    if (typeof game.baseRating === 'number' && game.baseRating > 0) vals = [game.baseRating].concat(vals);
    if (vals.length) return vals.reduce(function (a, b) { return a + b; }, 0) / vals.length;
    return (typeof game.rating === 'number' && game.rating > 0) ? game.rating : null;
}
// Media weight (dificultate BGG) = scorul la adăugare (baseDifficulty/complexity) + voturile jucătorilor. Scală 1-5.
function gameWeightAvg(game) {
    if (!game) return null;
    var vals = _gameVoteList(game, 'w');
    if (typeof game.baseDifficulty === 'number' && game.baseDifficulty > 0) vals = [game.baseDifficulty].concat(vals);
    if (vals.length) return vals.reduce(function (a, b) { return a + b; }, 0) / vals.length;
    return (typeof game.difficulty === 'number' && game.difficulty > 0) ? game.difficulty : null;
}
function gameRealMin(game) {
    if (game && Array.isArray(game.actualDurations) && game.actualDurations.length) {
        return Math.round(game.actualDurations.reduce(function (a, b) { return a + b; }, 0) / game.actualDurations.length);
    }
    return null;
}
// Curăță un URL pentru a fi folosit în background-image:url('...') fără a sparge atributul/CSS-ul.
/* v9 8.5-D2: `fel` (opțional: list / thumb / tile / banner / wide) ⇒ coperta BGG în mărimea
   locului (covers.js), nu originalul de până la 4,7 MB; fără `fel` ⇒ adresa dată, ca înainte.
   Escaparea e cea de dinainte, neschimbată. EN: optional size slot for BGG covers. */
function gameImgCss(u, fel) {
    let s = '' + (u || '');
    if (fel && s && window.TO_COVER) { try { s = window.TO_COVER.pick(s, fel); } catch (e) { logError('gameImgCss', e); } }
    return s.replace(/["'()\\<>\s]/g, function (m) { return encodeURIComponent(m); });
}

/* ─── ÎNCĂRCARE LENEȘĂ PENTRU FUNDALURI DE IMAGINE (Batch 0a-1, perf) ──────────
   RO: Imaginile de catalog (BGG) se randează ca `background-image` pe `div`, deci
       `loading="lazy"` NU se aplică. Măsurat 08.08.2026: banda de miniaturi de pe
       Home descărca 12 imagini la rezoluție completă (7,36 MB din 9,73 MB totali)
       pentru pătrățele de 104×66 px aflate SUB ecran.
       Soluția: adresa pleacă în `data-bg`, iar imaginea se pune abia când elementul
       intră efectiv în viewport. Degradare grațioasă: fără IntersectionObserver
       (sau la orice eroare) se aplică imediat = exact comportamentul de dinainte.
       NU schimbă aspectul: `.perf-thumb` are deja dimensiuni fixe și `background-color`
       în style.css, deci nu apar sărituri de layout (CLS).
   EN: catalogue images render as CSS `background-image`, so `loading="lazy"` does not
       apply. The URL is parked in `data-bg` and applied on viewport entry, with an
       immediate-apply fallback when IntersectionObserver is unavailable. ── */
let _toBgObs = null;

/* Pune efectiv fundalul pe element și îl scoate din evidență. */
/* ⚠ Catalogul NU mai folosește acest mecanism (a trecut la `<img loading="lazy">`).
   Rămâne pentru ceilalți apelanți, exact cum era înainte de 9.2 — nu-l mai atingem,
   ca să nu schimbăm comportamentul unor zone care funcționau. */
function _toBgApply(el) {
    if (!el || !el.getAttribute) return;
    const u = el.getAttribute('data-bg');
    el.removeAttribute('data-bg');
    if (u) el.style.backgroundImage = "url('" + u + "')";
}

/* Atributul de pus în HTML în locul lui `style="background-image:..."`.
   `gameImgCss` elimină deja ghilimelele și `<`/`>`, deci e sigur în atribut. */
function toLazyBgAttr(url, fel) {
    return url ? ' data-bg="' + gameImgCss(url, fel) + '"' : '';
}

/* Pornește urmărirea pentru toate elementele cu `data-bg` din `root`.
   Se apelează DUPĂ ce HTML-ul a fost pus în DOM (după `innerHTML = ...`). */
function toObserveLazyBg(root) {
    let els;
    try {
        els = (root || document).querySelectorAll('[data-bg]');
        if (!els || !els.length) return;
        if (typeof IntersectionObserver !== 'function') {
            Array.prototype.forEach.call(els, _toBgApply);
            return;
        }
        if (!_toBgObs) {
            _toBgObs = new IntersectionObserver(function (entries, obs) {
                entries.forEach(function (en) {
                    if (!en.isIntersecting) return;
                    obs.unobserve(en.target);
                    _toBgApply(en.target);
                });
            }, { rootMargin: '200px' });   /* pornește puțin înainte să fie vizibil */
        }
        Array.prototype.forEach.call(els, function (el) { _toBgObs.observe(el); });
    } catch (e) {
        /* Orice eșec => încărcăm tot imediat: mai bine lent decât fără imagini. */
        try { Array.prototype.forEach.call(els || [], _toBgApply); } catch (_) { }
        if (typeof logError === 'function') logError('toObserveLazyBg', e);
    }
}
// Timestamp pentru sortarea „după data adăugării" (createdAt din DB, apoi addedAt; altfel 0).
function _gameAddedTs(g) {
    var d = g && (g.createdAt || g.addedAt);
    var ts = d ? Date.parse(d) : NaN;
    return isNaN(ts) ? 0 : ts;
}

function renderCatalog() {
    renderCatalogGrid();
    try { syncCatalogViewBtn(); } catch (e) { logError('renderCatalog', e); }
    updateCatalogStats();
    
    // Show/hide admin buttons
    const bulkDeleteGamesBtn = document.getElementById('bulkDeleteGamesBtn');
    if (bulkDeleteGamesBtn) {
        /* `catalog.delete` (rang 3) în loc de `isAdmin`: același public ca înainte,
           dar dintr-o sursă neambiguă — rolul din clubul ACTIV. `isAdmin` avea trei
           scriitori cu două înțelesuri (rol global vs. rol de club) și era ridicat ca
           zăvor de `renderAdmin`. */
        const _mayBulk = (typeof can === 'function') ? can('catalog.delete') : !!isAdmin;
        bulkDeleteGamesBtn.style.display = _mayBulk ? 'inline-flex' : 'none';
    }
    /* Importul în masă cere `catalog.import` (rang 3), identic cu pragul din RPC-ul
       `import_games_bulk`. Moderatorii (rang 2) păstrează `catalog.manage` și pot
       adăuga jocuri unul câte unul, inclusiv din căutarea BGG — doar importul
       colecției întregi le e ascuns. Fallback pe `isAdmin` doar dacă stratul de
       capabilități n-a apucat să se încarce. */
    const importBggBtn = document.getElementById('importBggBtn');
    if (importBggBtn) {
        const _mayImport = (typeof can === 'function') ? can('catalog.import') : !!isAdmin;
        importBggBtn.style.display = _mayImport ? 'inline-flex' : 'none';
    }
}

/* Lista filtrată și sortată, exact ca în randare. Extrasă ca s-o poată folosi și
   adăugarea unui lot nou, fără să refacă toată grila. */
function _catalogFiltered() {
    try {
        const searchTerm = document.getElementById('gameSearch')?.value.toLowerCase() || '';
        const filter = document.getElementById('gameFilter')?.value || '';
        let list = Object.entries(state.catalog || {});
        if (searchTerm) {
            list = list.filter(([name, game]) =>
                name.toLowerCase().includes(searchTerm) ||
                game.description?.toLowerCase().includes(searchTerm) ||
                game.categories?.some(cat => cat.toLowerCase().includes(searchTerm)));
        }
        if (filter) list = list.filter(([_, game]) => game.categories?.some(cat => cat.toLowerCase().includes(filter)));
        const sortBy = (document.getElementById('gameSort') && document.getElementById('gameSort').value) || 'az';
        list.sort(function (a, b) {
            const na = a[0], ga = a[1], nb = b[0], gb = b[1];
            const tie = na.localeCompare(nb);
            switch (sortBy) {
                case 'rating': return ((gameRatingAvg(gb) || 0) - (gameRatingAvg(ga) || 0)) || tie;
                case 'weight': return ((gameWeightAvg(gb) || 0) - (gameWeightAvg(ga) || 0)) || tie;
                case 'plays':  return ((gb.timesPlayed || 0) - (ga.timesPlayed || 0)) || tie;
                case 'recent': return ((gb.lastPlayed ? Date.parse(gb.lastPlayed) : 0) - (ga.lastPlayed ? Date.parse(ga.lastPlayed) : 0)) || tie;
                case 'added':  return (_gameAddedTs(gb) - _gameAddedTs(ga)) || tie;
                default:       return tie;
            }
        });
        return list;
    } catch (e) { logError('_catalogFiltered', e); return null; }
}

/* ============================================================
   9.5 — Eticheta „Uniformizat" explică ce înseamnă.
   RO: eticheta avea doar `title=`, adică un tooltip care pe telefon NU se vede niciodată
       — acolo era problema reală, și a fost întrebare frecventă în beta. O facem
       apăsabilă: deschide un text scurt, plus scorurile PRESTABILITE ale clubului activ,
       ca omul să înțeleagă cum se punctează la el în club.
   ⚠ Textul e SCRIS PENTRU JUCĂTOR, nu pentru administrator. Prima variantă refolosea
       `scoreTpl.intro` din panoul de admin, dar acela îi explică adminului ce are de
       CONFIGURAT („când e activată, la fiecare sesiune nouă poți alege…") — irelevant
       pentru cineva care vrea doar să înțeleagă de ce scrie „Uniformizat" pe o partidă.
       Aici explicăm DE CE există conversia, cu un exemplu concret.
       Valorile rămân citite din configurația REALĂ a clubului (`getScoringTemplates`),
       nu dintr-un exemplu generic — asta era partea bună a variantei precedente.
   ⚠ Etichetele șabloanelor sunt și ele altele: „Șablonul A — Competitiv" e limbaj de
       panou de administrare. Jucătorul vede „Jocuri competitive (după loc)".
   ⚠ Eticheta era un `<span>`. Devenind interactivă, primește rol de buton, poate fi
       focalizată de la tastatură și folosește `data-action`, nu `onclick` (§5.1).
   EN: the badge only had a `title` tooltip, invisible on phones; it is now a real button
       that opens the admin explanation plus the club's actual scoring templates.
   ============================================================ */
function uniformBadgeHtml(extraStyle) {
    const lbl = t('hist.uniform');
    const hint = t('hist.uniformWhat');
    return '<span class="badge uniform-badge" role="button" tabindex="0"'
        + ' data-action="uniform-info" title="' + window.escHtml(hint) + '"'
        + ' aria-label="' + window.escHtml(lbl + ' — ' + hint) + '"'
        + ' style="margin-left:10px; background:#0e8a7b; color:#fff; cursor:pointer;'
        + (extraStyle || '') + '">'
        + '<i class="fas fa-scale-balanced"></i> ' + window.escHtml(lbl)
        + ' <i class="fas fa-circle-info" style="opacity:.75; margin-left:2px;"></i></span>';
}
window.uniformBadgeHtml = uniformBadgeHtml;

function openUniformInfo() {
    try {
        const tpl = (typeof getScoringTemplates === 'function') ? getScoringTemplates() : null;
        /* ⚠ COMPACT, intenționat. Prima variantă punea fiecare loc pe câte un rând, deci
           pe telefon fereastra cerea derulare — pentru o lămurire de câteva secunde, e
           prea mult. Valorile stau acum pe un singur rând per categorie, despărțite prin
           puncte. EN: one line per category; the earlier vertical list forced scrolling. */
        const P = ' ' + t('scoreTpl.pts');
        let body = t('hist.uniformExplain');
        if (tpl) {
            const parti = [];
            /* Competitiv: ultima valoare se aplică tuturor locurilor inferioare. */
            const pr = (tpl.competitive && Array.isArray(tpl.competitive.perRank)) ? tpl.competitive.perRank : [];
            if (pr.length) {
                const locuri = pr.map(function (v, i) {
                    const ultim = (i === pr.length - 1);
                    /* ⚠ Doar „3+", nu „3+ (și mai jos)": eticheta categoriei spune deja
                       „după loc", iar paranteza dubla lungimea rândului degeaba. */
                    return (i + 1) + (ultim ? '+' : '') + ': ' + v + P;
                }).join(' · ');
                parti.push(t('hist.uniformComp') + ' — ' + locuri);
            }
            if (tpl.coop) {
                parti.push(t('hist.uniformCoop') + ' — ' + t('scoreTpl.win').toLowerCase() + ': ' + tpl.coop.win + P
                         + ' · ' + t('scoreTpl.loss').toLowerCase() + ': ' + tpl.coop.loss + P);
            }
            if (tpl.campaign) {
                parti.push(t('hist.uniformCamp') + ' — ' + t('hist.uniformPart') + ': ' + tpl.campaign.participation + P);
            }
            if (parti.length) body += '\n\n' + t('hist.uniformHow') + '\n' + parti.join('\n');
        }
        if (typeof confirmModal === 'function') {
            confirmModal(body, { title: t('hist.uniform'), confirmText: t('common.close'), hideCancel: true, hideIcon: true });
        } else {
            showNotification(body, 'info');
        }
    } catch (e) { logError('openUniformInfo', e); }
}
window.openUniformInfo = openUniformInfo;

/* Delegare globală: eticheta apare în mai multe liste, randate din fișiere diferite. */
document.addEventListener('click', function (ev) {
    const el = ev.target && ev.target.closest ? ev.target.closest('[data-action="uniform-info"]') : null;
    if (!el) return;
    ev.stopPropagation();    /* eticheta stă pe un card care se deschide la clic */
    openUniformInfo();
});
document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' && ev.key !== ' ') return;
    const el = ev.target && ev.target.closest ? ev.target.closest('[data-action="uniform-info"]') : null;
    if (!el) return;
    ev.preventDefault();
    ev.stopPropagation();
    openUniformInfo();
});

function renderCatalogGrid() {
    /* RO: Editarea și ștergerea au praguri DIFERITE, aliniate cu RLS-ul de pe `games`:
           update = rang>=2 (`catalog.manage`), delete = rang>=3 (`catalog.delete`,
           politica `games_delete_min_admin`). Înainte ambele erau ascunse în spatele
           lui `isAdmin`, deci un moderator nu vedea butonul de editare deși baza de
           date îi permitea — și `saveGameEdits` îl accepta deja prin `catalog.manage`.
       EN: edit and delete have different thresholds; both used to hide behind `isAdmin`. */
    const _mayEditGames = (typeof can === 'function') ? can('catalog.manage') : !!isAdmin;
    const _mayDeleteGames = (typeof can === 'function') ? can('catalog.delete') : !!isAdmin;
    const grid = document.getElementById('catalogGrid');
    const searchTerm = document.getElementById('gameSearch')?.value.toLowerCase() || '';
    const filter = document.getElementById('gameFilter')?.value || '';
    
    // Filter games
    let filteredGames = Object.entries(state.catalog);
    
    if (searchTerm) {
        filteredGames = filteredGames.filter(([name, game]) => 
            name.toLowerCase().includes(searchTerm) ||
            game.description?.toLowerCase().includes(searchTerm) ||
            game.categories?.some(cat => cat.toLowerCase().includes(searchTerm))
        );
    }
    
    if (filter) {
        filteredGames = filteredGames.filter(([_, game]) => 
            game.categories?.some(cat => cat.toLowerCase().includes(filter))
        );
    }

    // Sortare stabilă (implicit alfabetic) — astfel ordinea nu se schimbă la evaluare
    const sortBy = (document.getElementById('gameSort') && document.getElementById('gameSort').value) || 'az';
    filteredGames.sort(function (a, b) {
        const na = a[0], ga = a[1], nb = b[0], gb = b[1];
        const tie = na.localeCompare(nb);
        switch (sortBy) {
            case 'rating': return ((gameRatingAvg(gb) || 0) - (gameRatingAvg(ga) || 0)) || tie;
            case 'weight': return ((gameWeightAvg(gb) || 0) - (gameWeightAvg(ga) || 0)) || tie;
            case 'plays':  return ((gb.timesPlayed || 0) - (ga.timesPlayed || 0)) || tie;
            case 'recent': return ((gb.lastPlayed ? Date.parse(gb.lastPlayed) : 0) - (ga.lastPlayed ? Date.parse(ga.lastPlayed) : 0)) || tie;
            case 'added':  return (_gameAddedTs(gb) - _gameAddedTs(ga)) || tie;
            default:       return tie;
        }
    });

    if (filteredGames.length === 0) {
        const mb0 = document.getElementById('catalogShowMore'); if (mb0) mb0.innerHTML = '';
        grid.innerHTML = `
            <div class="card" style="grid-column: 1 / -1; text-align: center; padding: 40px;">
                <h3><i class="fas fa-gamepad"></i> ${t('catalog.noneFound')}</h3>
                <p style="color: var(--text-secondary); margin-top: 10px;">
                    ${searchTerm || filter ? t('common.tryOtherSearch') : t('catalog.addFirst')}
                </p>
            </div>
        `;
        return;
    }
    
    const _view = catalogViewNow();
    const CAT_STEP = CATALOG_STEP[_view] || 10;
    const catIsMobile = !!(window.matchMedia && window.matchMedia('(max-width: 720px)').matches);
    /* ⚠ 9.2: „Vezi mai mult" arăta TOT catalogul de la prima apăsare, deci pagina
       devenea imensă dintr-un clic. Acum crește cu câte un lot. `catalogShown` ține
       numărul curent; căutarea, filtrarea și sortarea îl resetează.
       EN: the button used to reveal the entire catalog at once; now it adds one batch. */
    if (catalogShown == null) catalogShown = CAT_STEP;
    const catCollapse = catIsMobile && !searchTerm && !filter && filteredGames.length > catalogShown;
    const shownGames = catCollapse ? filteredGames.slice(0, catalogShown) : filteredGames;

    grid.className = 'catalog-grid mt-20' + (_view === 'compact' ? ' catalog-view-compact' : (_view === 'grid' ? ' catalog-view-grid' : ''));

    if (_view === 'compact' || _view === 'grid') {
        grid.innerHTML = shownGames.map(([name, game]) => _catalogItemSlim(name, game, _view, _mayEditGames, _mayDeleteGames)).join('');
        _catalogBindDelegation();
        /* Încărcarea amânată o face browserul singur, prin `loading="lazy"` de pe `<img>`. */
        _catalogRenderShowMore(filteredGames.length, catIsMobile, searchTerm, filter, CAT_STEP);
        return;
    }

    grid.innerHTML = shownGames.map(([name, game]) => {
        const typeEmoji = {
            'Eurogame': '🏛️',
            'Ameritrash': '🎲',
            'Party': '🎉',
            'Cooperativ': '🤝',
            'Strategie': '🧠',
            'Filler': '⚡',
            'Legacy': '📖',
            'Deck Building': '🎴',
            'RPG': '🐉',
            'Worker Placement': '👷',
            'Engine Building': '⚙️'
        };
        
        const timesPlayed = game.timesPlayed || 0;
        const ratingAvg = gameRatingAvg(game);
        const ratingTxt = (ratingAvg != null) ? ratingAvg.toFixed(1) : 'N/A';
        const weightAvg = gameWeightAvg(game);
        const weightTxt = (weightAvg != null) ? weightAvg.toFixed(2) : 'N/A';
        const realMin = gameRealMin(game);
        const lastPlayed = game.lastPlayed ? new Date(game.lastPlayed).toLocaleDateString('en-GB') : t('common.never');
        
        return `
            <div class="catalog-item${game.imageUrl ? ' has-banner' : ''}" data-cat-open="${window.escHtml(name)}">
                ${game.imageUrl ? `
                <div class="catalog-banner"><img class="catalog-img" src="${window.escHtml(window.TO_COVER ? window.TO_COVER.pick(game.imageUrl, 'banner') : game.imageUrl)}" loading="lazy" decoding="async" alt="">
                    <div class="catalog-banner-overlay">
                        <div class="catalog-banner-title">${window.escHtml(name)}</div>
                        <div class="catalog-banner-rating"><i class="fas fa-star"></i> ${ratingTxt}/10</div>
                    </div>
                </div>
                ` : `
                <div class="catalog-header">
                    <div class="catalog-name">${window.escHtml(name)}</div>
                    <div class="catalog-rating">
                        <i class="fas fa-star" style="color: var(--accent-gold);"></i>
                        ${ratingTxt}/10
                    </div>
                </div>
                `}
                
                <div class="catalog-tags">
                    ${game.categories?.slice(0, 3).map(cat => `
                        <span class="catalog-tag">
                            ${typeEmoji[cat] || '🎲'} ${window.escHtml(cat)}
                        </span>
                    `).join('')}
                </div>
                
                <div class="catalog-summary">
                    <span><i class="fas fa-users"></i> ${game.players || 'N/A'}</span>
                    <span><i class="fas fa-clock"></i> ${game.duration || 'N/A'} min</span>
                    <span><i class="fas fa-chart-line"></i> ${weightTxt}/5</span>
                    <span><i class="fas fa-gamepad"></i> ${timesPlayed} ${t('catalog.playsShort')}</span>
                </div>
                
                ${game.description ? `
                    <p style="margin-top: 15px; color: var(--text-secondary); font-size: 0.9em; line-height: 1.5;">
                        ${window.escHtml(game.description.length > 120 ? game.description.substring(0, 120) + '...' : game.description)}
                    </p>
                ` : ''}
                
                <div class="catalog-actions">
                    <button class="btn btn-sm btn-secondary" title="${t('catalog.rate')}" aria-label="${t('catalog.rate')}" data-cat-act="rate" data-cat-game="${window.escHtml(name)}">
                        <i class="fas fa-star"></i>
                    </button>
                    ${_mayEditGames ? `
                        <button class="btn btn-sm btn-secondary" title="${t('catalog.edit')}" aria-label="${t('catalog.edit')}" data-cat-act="edit" data-cat-game="${window.escHtml(name)}">
                            <i class="fas fa-pen"></i>
                        </button>
                    ` : ''}
                    ${_mayDeleteGames ? `
                        <button class="btn btn-sm btn-danger" title="${t('common.delete')}" aria-label="${t('common.delete')}" data-cat-act="delete" data-cat-game="${window.escHtml(name)}">
                            <i class="fas fa-trash"></i>
                        </button>
                    ` : ''}
                </div>
            </div>
        `;
    }).join('');
    _catalogBindDelegation();   /* v9 zona 2: și cardurile mari, fără onclick (aceeași delegare ca listă / grilă) */

    _catalogRenderShowMore(filteredGames.length, catIsMobile, searchTerm, filter, CAT_STEP);
}

/* Un rând (Compact) sau o dală (Grilă). Aceleași praguri de editare/ștergere ca la
   cardul mare — în Grilă butoanele n-ar încăpea, dar fereastra jocului are rating și
   editare, deci un moderator nu pierde nimic, doar face un tap în plus. */
function _catalogItemSlim(name, game, view, mayEdit, mayDelete) {
    const ratingAvg = gameRatingAvg(game);
    const ratingTxt = (ratingAvg != null) ? ratingAvg.toFixed(1) : 'N/A';
    const nameEsc = window.escHtml(name);
    /* ⚠ 9.2 — a TREIA încercare la „blip", de data asta pe altă cale. Fundalurile CSS
       puse din JavaScript clipeau indiferent ce animație scoteam: schimbarea proprietății
       `background-image` pe un element deja pictat produce o repictare vizibilă.
       Trecem la `<img>`, exact ca pozele de sesiune și de chat: browserul le încarcă
       singur (`loading="lazy"`), le decodează în afara firului principal
       (`decoding="async"`) și le afișează fără să repicteze altceva.
       Beneficiu în plus: nu mai avem nevoie de observator propriu pentru catalog.
       EN: switched from JS-set CSS backgrounds to real <img> with native lazy loading,
       like session/chat photos — no repaint flash. */
    const img = game.imageUrl
        ? '<img class="catalog-img" src="' + window.escHtml(window.TO_COVER ? window.TO_COVER.pick(game.imageUrl, view === 'grid' ? 'tile' : 'list') : game.imageUrl) + '" loading="lazy" decoding="async" alt="">'
        : '';
    const nameJs = window.attrJs(name);

    /* ⚠ DELEGARE, nu `onclick=`. Numele jocului călătorește într-un atribut `data-`,
       escapat ca TEXT HTML — deci nu mai trece printr-un context JavaScript. Ascultătorul
       e UNUL singur, pus o dată pe grilă, nu câte unul per element (§5.1). Codul nou nu
       trebuie să mai adauge datorie tehnică.
       EN: event delegation instead of inline onclick; the name travels as an HTML-escaped
       data- attribute and never enters a JS context. */
    if (view === 'grid') {
        return '<div class="catalog-tile" data-cat-open="' + nameEsc + '">'
            +   '<div class="catalog-tile-img">' + img + '</div>'
            +   '<div class="catalog-tile-overlay">'
            +     '<div class="catalog-tile-title">' + nameEsc + '</div>'
            +     '<div class="catalog-tile-rating"><i class="fas fa-star"></i> ' + ratingTxt + '</div>'
            +   '</div>'
            + '</div>';
    }

    /* ⚠ Butoanele de acțiune se randează MEREU, dar sunt ascunse din CSS sub 720px.
       Pe telefon cele trei butoane lăsau titlului o coloană de câțiva centimetri, iar
       detaliile se rupeau câte unul pe rând. Pe desktop e loc berechet, deci rămân.
       ⚠ De ce ascundere din CSS și nu din JavaScript: o decizie luată la randare ar
       rămâne greșită după rotirea telefonului sau redimensionarea ferestrei, fără o
       re-randare. CSS-ul răspunde singur.
       Pe telefon acțiunile rămân în fereastra jocului, cu aceleași praguri.
       EN: actions are always rendered but hidden below 720px via CSS, so rotating the
       phone or resizing the window can never leave a stale decision behind. */
    const plays = game.timesPlayed || 0;
    const act = function (cls, action, icon, label) {
        return '<button type="button" class="btn btn-sm ' + cls + '" title="' + label + '" aria-label="' + label + '"'
             + ' data-cat-act="' + action + '" data-cat-game="' + nameEsc + '"><i class="fas ' + icon + '"></i></button>';
    };
    const bits = [];
    if (ratingAvg != null) bits.push('<i class="fas fa-star"></i> ' + ratingTxt);
    if (game.players) bits.push('<i class="fas fa-users"></i> ' + window.escHtml(String(game.players)));
    if (game.duration) bits.push('<i class="fas fa-clock"></i> ' + window.escHtml(String(game.duration)) + ' min');
    return '<div class="catalog-row" data-cat-open="' + nameEsc + '">'
        +   '<div class="catalog-row-img">' + img + '</div>'
        +   '<div class="catalog-row-main">'
        +     '<div class="catalog-row-title">' + nameEsc + '</div>'
        +     '<div class="catalog-row-meta">' + bits.join('<span class="catalog-row-dot">·</span>') + '</div>'
        +   '</div>'
        +   '<div class="catalog-row-plays">' + plays + ' ' + t('catalog.playsShort') + '</div>'
        +   '<div class="catalog-row-actions">'
        +     act('btn-secondary', 'rate', 'fa-star', t('catalog.rate'))
        +     (mayEdit ? act('btn-secondary', 'edit', 'fa-pen', t('catalog.edit')) : '')
        +     (mayDelete ? act('btn-danger', 'delete', 'fa-trash', t('common.delete')) : '')
        +   '</div>'
        + '</div>';
}

/* v9 zona 2 — Catalog (3 nov. 2026): tabul Catalog și ferestrele lui fără handlere inline (erau 31: butoanele
   tabului, căutarea / filtrul / sortarea, unelte, „Vezi mai mult", „Adaugă / editează joc" cu căutarea BGG,
   „Evaluează", „Ștergere în masă", anularea importului BGG; cardurile mari folosesc delegarea grilei de mai
   jos). O singură delegare pe `document`, pe faza de CAPTURĂ (ferestrele se recreează), legată o dată;
   fiecare acțiune cheamă ACEEAȘI funcție, cu aceleași argumente, ca vechiul `onclick`. Numele jocului e DATĂ
   (`data-game`, escHtml), nu cod. Câmpurile: căutarea pe `input`, listele și „Selectează tot" pe `change`,
   căutarea BGG pe `input` + Enter — exact evenimentele de dinainte.
   Zona 2b (3 nov. 2026): și rezultatele / edițiile BGG, previzualizarea și maparea importului
   (supabase-integration.js) și butoanele de import din Admin (index.html). Id-ul BGG trece doar dacă e număr
   (înainte intra direct în cod); fișierul ales ajunge la `handleImportFile` ca înainte (elementul + tipul).
   EN: catalog zone without inline handlers; one capture-phase delegation; same calls; names as data. */
(function () {
    if (document.__toCatalogActs) return;
    document.__toCatalogActs = true;
    document.addEventListener('click', function (e) {
        const el = e.target && e.target.closest ? e.target.closest('[data-catalog-act]') : null;
        if (!el) return;
        switch (el.getAttribute('data-catalog-act')) {
            case 'add-game': openAddGameModal(); break;
            case 'view': cycleCatalogView(); break;
            case 'tile': toggleTilePanel(el.getAttribute('data-panel'), el); break;
            case 'import-bgg': importBGGCollection(); break;
            case 'export-json': exportCatalogJSON(); break;
            case 'bulk-delete': bulkDeleteGamesModal(); break;
            case 'show-more': catalogShowMore(); break;
            case 'show-less': catalogShowLess(); break;
            case 'close': { const m = el.closest('.modal'); if (m) m.remove(); break; }
            case 'bgg-search': bggSearch(); break;
            case 'more': { const p = document.getElementById('addGameMore'); if (p) el.classList.toggle('is-open', p.classList.toggle('hidden') === false); break; }
            case 'save-edit': saveGameEdits(el.getAttribute('data-game')); break;
            case 'add-new': addNewGame(); break;
            case 'bgg-imp-cancel': bggImportCancel(); break;
            case 'rate-weight': setRateWeight(Number(el.getAttribute('data-w'))); break;
            case 'rate-submit': submitRating(); break;
            case 'bulk-run': processBulkDeleteGames(); break;
            case 'bgg-pick': { const id = el.getAttribute('data-bgg-id') || ''; if (/^\d+$/.test(id)) bggPick(Number(id)); break; }
            case 'bgg-ver': bggPickVersion(el.getAttribute('data-i')); break;
            case 'import-file': { const f = document.getElementById(el.getAttribute('data-input')); if (f) f.click(); break; }
            case 'import-run': runImport(); break;
            case 'impmap-apply': applyImportMapping(); break;
        }
    }, true);
    document.addEventListener('input', function (e) {
        const el = e.target, f = el && el.getAttribute ? el.getAttribute('data-catalog-field') : null;
        if (f === 'search') searchGames();
        else if (f === 'bgg') bggSearchLive();
        else if (f === 'rate-range') { const d = document.getElementById('rateValDisplay'); if (d) d.textContent = el.value; }
        else if (f === 'bgg-ver') filterBggVersions();
    }, true);
    document.addEventListener('change', function (e) {
        const el = e.target, f = el && el.getAttribute ? el.getAttribute('data-catalog-field') : null;
        if (f === 'filter') filterGames();
        else if (f === 'sort') sortGames();
        else if (f === 'bulk-all') document.querySelectorAll('.bulk-game-cb').forEach(c => { c.checked = el.checked; });
        else if (f === 'impmap') onImportMapChange(Number(el.getAttribute('data-i')));
        else if (f === 'import-file') handleImportFile(el, el.getAttribute('data-kind'));
    }, true);
    document.addEventListener('keydown', function (e) {
        const el = e.target;
        if (e.key === 'Enter' && el && el.getAttribute && el.getAttribute('data-catalog-field') === 'bgg') { e.preventDefault(); bggSearch(); }
    }, true);
})();

/* UN singur ascultător pe grilă, pus o singură dată. Butoanele se verifică ÎNAINTEA
   rândului: altfel un clic pe „șterge" ar deschide și fereastra jocului. */
function _catalogBindDelegation() {
    const grid = document.getElementById('catalogGrid');
    if (!grid || grid._catDelegated) return;
    grid._catDelegated = true;
    grid.addEventListener('click', function (ev) {
        const btn = ev.target.closest ? ev.target.closest('[data-cat-act]') : null;
        if (btn && grid.contains(btn)) {
            ev.stopPropagation();
            const g = btn.getAttribute('data-cat-game');
            const a = btn.getAttribute('data-cat-act');
            if (a === 'rate' && typeof rateGame === 'function') rateGame(g);
            else if (a === 'edit' && typeof openAddGameModal === 'function') openAddGameModal(g);
            else if (a === 'delete' && typeof deleteGameFromCatalog === 'function') deleteGameFromCatalog(g);
            return;
        }
        const item = ev.target.closest ? ev.target.closest('[data-cat-open]') : null;
        if (item && grid.contains(item) && typeof showGameDetails === 'function') {
            showGameDetails(item.getAttribute('data-cat-open'));
        }
    });
}

/* Butonul de lot. Arată câte mai urmează, dar adaugă doar UN lot pe apăsare. */
function _catalogRenderShowMore(total, isMobile, searchTerm, filter, step) {
    const box = document.getElementById('catalogShowMore');
    if (!box) return;
    if (!isMobile || searchTerm || filter) { box.innerHTML = ''; return; }
    const shown = catalogShown || step;
    let html = '';
    if (total > shown) {
        const rest = total - shown;
        const next = Math.min(step, rest);
        html += '<button type="button" class="btn btn-sm btn-secondary players-more-btn" data-catalog-act="show-more">'
             +  '<i class="fas fa-chevron-down"></i> ' + t('players.showMore') + ' (+' + next + ' ' + t('catalog.ofTotal').replace('{n}', rest) + ')</button>';
    }
    if (shown > step) {
        html += '<button type="button" class="btn btn-sm btn-secondary players-more-btn" data-catalog-act="show-less">'
             +  '<i class="fas fa-chevron-up"></i> ' + t('players.showLess') + '</button>';
    }
    box.innerHTML = html;
}

/* ⚠ 9.2 — VITEZA la „Vezi mai mult". Înainte refăceam TOATĂ grila, deci fiecare `<img>`
   deja afișat era distrus și recreat: browserul le lua din memoria proprie, dar trebuia
   să le decodeze și să le picteze din nou — se vedea ca o clipire a întregii liste.
   Acum lotul nou se ADAUGĂ la sfârșit; elementele existente nu sunt atinse deloc.
   ⚠ Doar pentru Compact și Grilă, care construiesc rândurile printr-o funcție proprie.
   Modul Extins folosește în continuare randarea completă — acolo lotul e mic (10) și
   HTML-ul cardului e generat inline, deci nu merită duplicat.
   EN: append the next batch instead of re-rendering everything, so existing <img>
   elements are never destroyed and re-decoded. */
function catalogShowMore() {
    const view = catalogViewNow();
    const step = CATALOG_STEP[view] || 10;
    const before = catalogShown || step;
    catalogShown = before + step;

    const grid = document.getElementById('catalogGrid');
    if ((view === 'compact' || view === 'grid') && grid && typeof _catalogFiltered === 'function') {
        const list = _catalogFiltered();
        if (list) {
            const mayEdit = (typeof can === 'function') ? can('catalog.manage') : !!isAdmin;
            const mayDelete = (typeof can === 'function') ? can('catalog.delete') : !!isAdmin;
            const next = list.slice(before, catalogShown);
            if (next.length) {
                grid.insertAdjacentHTML('beforeend',
                    next.map(function (e) { return _catalogItemSlim(e[0], e[1], view, mayEdit, mayDelete); }).join(''));
            }
            _catalogRenderShowMore(list.length, !!(window.matchMedia && window.matchMedia('(max-width: 720px)').matches),
                document.getElementById('gameSearch') ? document.getElementById('gameSearch').value : '',
                document.getElementById('gameFilter') ? document.getElementById('gameFilter').value : '', step);
            return;
        }
    }
    if (typeof renderCatalogGrid === 'function') renderCatalogGrid();
}
function catalogShowLess() {
    catalogShown = null;   /* înapoi la primul lot */
    if (typeof renderCatalogGrid === 'function') renderCatalogGrid();
}
window.catalogShowMore = catalogShowMore;
window.catalogShowLess = catalogShowLess;

/* Păstrată: alte căi din aplicație o pot chema. */
function toggleCatalogExpanded() {
    if (catalogShown && catalogShown > (CATALOG_STEP[catalogViewNow()] || 10)) catalogShowLess();
    else catalogShowMore();
}

function updateCatalogStats() {
    const totalGames = Object.keys(state.catalog).length;
    const mostPlayed = getMostPlayedGame();
    const totalPlays = getTotalPlays();
    const playMinutes = Object.values(state.catalog).reduce((s, g) => s + (g.timesPlayed || 0) * (g.avgDuration || g.duration || 0), 0);
    const playHours = Math.round(playMinutes / 60);

    document.getElementById('stat-total-games-catalog').textContent = totalGames;
    document.getElementById('stat-most-played').textContent = mostPlayed;
    const pt = document.getElementById('stat-play-time'); if (pt) pt.textContent = playHours + 'h';
    document.getElementById('stat-total-plays').textContent = totalPlays;
}

function getMostPlayedGame() {
    if (Object.keys(state.catalog).length === 0) return '-';
    
    const mostPlayed = Object.entries(state.catalog).reduce((max, [name, game]) => {
        const plays = game.timesPlayed || 0;
        return plays > max.plays ? { name, plays } : max;
    }, { name: '', plays: 0 });
    
    return mostPlayed.name || '-';
}

function getAverageRating() {
    const gamesWithRating = Object.values(state.catalog).filter(g => g.rating);
    if (gamesWithRating.length === 0) return 0;
    
    const totalRating = gamesWithRating.reduce((sum, g) => sum + g.rating, 0);
    return totalRating / gamesWithRating.length;
}

function getTotalPlays() {
    return Object.values(state.catalog).reduce((sum, g) => sum + (g.timesPlayed || 0), 0);
}

function searchGames() {
    catalogExpanded = false;
    catalogShown = null;   /* 9.2: căutare/filtru/sortare nouă -> primul lot */
    renderCatalogGrid();
}

function filterGames() {
    catalogExpanded = false;
    catalogShown = null;   /* 9.2: căutare/filtru/sortare nouă -> primul lot */
    renderCatalogGrid();
}

function sortGames() {
    catalogExpanded = false;
    catalogShown = null;   /* 9.2: căutare/filtru/sortare nouă -> primul lot */
    renderCatalogGrid();
}

function openAddGameFromSession() {
    openAddGameModal();
    window._addGameReturnToSession = true;
}
window.openAddGameFromSession = openAddGameFromSession;

function openAddGameModal(editName) {
    window._addGameReturnToSession = false; /* reset; setat doar de openAddGameFromSession */
    const g = editName ? state.catalog[editName] : null;
    const isEdit = !!g;
    const aesc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const gCats = (g && Array.isArray(g.categories)) ? g.categories : [];
    const customCats = gCats.filter(c => !state.categories.includes(c));
    const dsel = isEdit ? Math.min(5, Math.max(1, Math.round(g.baseDifficulty || g.difficulty || 3))) : 3;
    const rval = isEdit ? (g.baseRating != null ? g.baseRating : (g.rating || 7)) : '7.0';
    const moreCls = isEdit ? '' : 'hidden';

    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.dataset.back = '1';   /* „înapoi" de pe telefon o închide (chat-core.js, v9 zona 2) */
    
    modal.innerHTML = `
        <div class="modal-content">
            <div class="modal-header">
                <h2><i class="fas fa-${isEdit ? 'pen' : 'plus'}"></i> ${isEdit ? t('game.editTitle') : t('game.addTitleNew')}</h2>
                <button class="modal-close" data-catalog-act="close" aria-label="${t('common.close')}">×</button>
            </div>

            <div class="form-group" style="background:rgba(255,107,53,0.06); padding:10px; border-radius:8px;">
                <label for="bggSearchInput"><i class="fas fa-magnifying-glass"></i> ${t('game.bggSearch')}</label>
                <div style="display:flex; gap:8px; align-items:stretch;">
                    <input type="text" id="bggSearchInput" class="form-control" placeholder="Ex: Catan" autocomplete="off" style="flex:1 1 auto; min-width:0;" data-catalog-field="bgg">
                    <button class="btn btn-sm" type="button" data-catalog-act="bgg-search" aria-label="${t('game.bggSearch')}" style="flex:0 0 auto; width:auto; min-width:0; padding:0 18px;"><i class="fas fa-search"></i></button>
                </div>
                <div id="bggResults" style="max-height:200px; overflow:auto; margin-top:6px;"></div>
                <a href="https://boardgamegeek.com" target="_blank" rel="noopener" style="font-size:.72em; color:var(--accent-primary,#ff6b35); opacity:0.95; text-decoration:none;">Powered by BoardGameGeek</a>
            </div>
            
            <div class="form-group">
                <label for="newGameName"><i class="fas fa-heading"></i> ${t('game.nameLabel')}</label>
                <input type="text" id="newGameName" class="form-control" placeholder="${t('game.namePh')}" value="${isEdit ? aesc(editName) : ''}" ${isEdit ? 'readonly style="opacity:.7; cursor:not-allowed;"' : ''}>
                ${isEdit ? `<small style="opacity:.65; font-size:.78em; display:block; margin-top:4px;">${t('game.nameLockedNote')}</small>` : ''}
            </div>
            
            <div class="form-row">
                <div class="form-group">
                    <label for="newGamePlayers"><i class="fas fa-users"></i> ${t('game.players')}</label>
                    <input type="text" id="newGamePlayers" class="form-control" placeholder="${t('game.playersPh')}" value="${isEdit ? aesc(g.players) : ''}">
                </div>
                <div class="form-group">
                    <label for="newGameDuration"><i class="fas fa-clock"></i> ${t('game.durationLabel')}</label>
                    <input type="number" id="newGameDuration" class="form-control" placeholder="Ex: 60" value="${isEdit && g.duration ? aesc(g.duration) : ''}">
                </div>
            </div>
            
            <div class="form-row">
                <div class="form-group">
                    <label for="newGameDifficulty"><i class="fas fa-chart-line"></i> ${t('game.difficulty')}</label>
                    <select id="newGameDifficulty" class="form-control">
                        <option value="1" ${dsel === 1 ? 'selected' : ''}>${t('game.diff1')}</option>
                        <option value="2" ${dsel === 2 ? 'selected' : ''}>${t('game.diff2')}</option>
                        <option value="3" ${dsel === 3 ? 'selected' : ''}>${t('game.diff3')}</option>
                        <option value="4" ${dsel === 4 ? 'selected' : ''}>${t('game.diff4')}</option>
                        <option value="5" ${dsel === 5 ? 'selected' : ''}>${t('game.diff5')}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="newGameRating"><i class="fas fa-star"></i> ${t('game.rating')}</label>
                    <input type="number" id="newGameRating" class="form-control" min="1" max="10" step="0.1" value="${aesc(rval)}">
                </div>
            </div>
            
            <div class="form-group">
                <span class="form-section-label"><i class="fas fa-tags"></i> ${t('game.categories')}</span>
                <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px;">
                    ${state.categories.map(category => `
                        <label style="display: flex; align-items: center; gap: 5px;">
                            <input type="checkbox" value="${aesc(category)}" class="game-category" ${gCats.includes(category) ? 'checked' : ''}>
                            ${category}
                        </label>
                    `).join('')}
                </div>
                <input type="text" id="newGameCategories" class="form-control mt-10" placeholder="${t('game.categoriesPh')}" value="${aesc(customCats.join(', '))}">
            </div>
            
            <div class="form-group">
                <label for="newGameDescription"><i class="fas fa-align-left"></i> ${t('common.description')}</label>
                <textarea id="newGameDescription" class="form-control" rows="3" placeholder="${t('catalog.descPh')}">${isEdit ? aesc(g.description) : ''}</textarea>
            </div>

            <div class="form-group" style="margin-top:6px;">
                <button type="button" class="acc-toggle ${isEdit ? 'is-open' : ''}" data-catalog-act="more">
                    <span><i class="fas fa-sliders-h"></i> ${t('game.moreDetails')}</span>
                    <i class="fas fa-chevron-right acc-chev"></i>
                </button>
            </div>
            <div id="addGameMore" class="${moreCls}">
                <div class="form-group">
                    <label for="newGameImageUrl"><i class="fas fa-image"></i> ${t('game.imageUrl')}</label>
                    <input type="text" id="newGameImageUrl" class="form-control" placeholder="https://...jpg" value="${isEdit ? aesc(g.imageUrl) : ''}">
                </div>
                <div class="form-group">
                    <label for="newGameEdition"><i class="fas fa-layer-group"></i> ${t('game.edition')}</label>
                    <input type="text" id="newGameEdition" class="form-control" placeholder="${t('game.editionPh')}" value="${isEdit ? aesc(g.edition) : ''}">
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="newGameAge"><i class="fas fa-child"></i> ${t('game.age')}</label>
                        <input type="number" id="newGameAge" class="form-control" min="0" placeholder="Ex: 14" value="${isEdit && g.minAge ? aesc(g.minAge) : ''}">
                    </div>
                    <div class="form-group">
                        <label for="newGamePublisher"><i class="fas fa-building"></i> ${t('game.publisher')}</label>
                        <input type="text" id="newGamePublisher" class="form-control" placeholder="Ex: Stonemaier Games" value="${isEdit ? aesc(g.publisher) : ''}">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="newGameDesigner"><i class="fas fa-pen-nib"></i> ${t('game.designer')}</label>
                        <input type="text" id="newGameDesigner" class="form-control" placeholder="Ex: Jamey Stegmaier" value="${isEdit ? aesc(g.designer) : ''}">
                    </div>
                    <div class="form-group">
                        <label for="newGameArtist"><i class="fas fa-paint-brush"></i> ${t('game.artist')}</label>
                        <input type="text" id="newGameArtist" class="form-control" placeholder="Ex: Jakub Rozalski" value="${isEdit ? aesc(g.artist) : ''}">
                    </div>
                </div>
                <div class="form-group">
                    <label for="newGameScoreDir"><i class="fas fa-arrow-down-1-9"></i> ${t('game.scoreDir')}</label>
                    <select id="newGameScoreDir" class="form-control">
                        <option value="high" ${(!isEdit || (g.scoreDir || 'high') !== 'low') ? 'selected' : ''}>${t('game.scoreDirHigh')}</option>
                        <option value="low" ${(isEdit && g.scoreDir === 'low') ? 'selected' : ''}>${t('game.scoreDirLow')}</option>
                    </select>
                    <small style="opacity:.6; display:block; margin-top:4px;">${t('game.scoreDirHint')}</small>
                </div>
                <div class="form-group">
                    <label for="newGameBggId"><i class="fas fa-external-link-alt"></i> ${t('catalog.bggLinkLabel')}</label>
                    <input type="text" id="newGameBggId" class="form-control" placeholder="Ex: https://boardgamegeek.com/boardgame/13/catan" value="${isEdit ? aesc(g.bggId) : ''}">
                </div>
            </div>
            
            <div class="btn-group">
                ${isEdit
                    ? `<button class="btn btn-success" data-catalog-act="save-edit" data-game="${window.escHtml(editName)}"><i class="fas fa-save"></i> ${t('catalog.saveGame')}</button>`
                    : `<button class="btn btn-success" data-catalog-act="add-new"><i class="fas fa-plus"></i> ${t('catalog.addGameBtn')}</button>`}
                <button class="btn btn-secondary" data-catalog-act="close">
                    <i class="fas fa-times"></i> ${t('common.cancel')}
                </button>
            </div>
        </div>
    `;
    
    document.body.appendChild(modal);
}

function addNewGame() {
    const name = document.getElementById('newGameName').value.trim();
    const players = document.getElementById('newGamePlayers').value.trim();
    const duration = parseInt(document.getElementById('newGameDuration').value) || 60;
    const difficulty = parseInt(document.getElementById('newGameDifficulty').value) || 3;
    const rating = parseFloat(document.getElementById('newGameRating').value) || 7.0;
    const description = document.getElementById('newGameDescription').value.trim();
    const bggId = document.getElementById('newGameBggId').value.trim();
    const sdEl = document.getElementById('newGameScoreDir');
    const scoreDir = (sdEl && sdEl.value === 'low') ? 'low' : 'high';
    
    // Get categories
    const categoryCheckboxes = document.querySelectorAll('.game-category:checked');
    let categories = Array.from(categoryCheckboxes).map(cb => cb.value);
    
    // Add custom categories
    const customCategories = document.getElementById('newGameCategories').value
        .split(',')
        .map(cat => cat.trim())
        .filter(cat => cat.length > 0);
    
    categories = [...categories, ...customCategories];
    
    // Validate
    if (!name || !players) {
        showNotification(t('m1.fillNamePlayers'), 'error');
        return;
    }
    
    if (state.catalog[name]) {
        showNotification(t('m1.gameInCatalog'), 'error');
        return;
    }
    
    // Add game to catalog
    state.catalog[name] = {
        categories: categories.length > 0 ? categories : ['Altele'],
        players,
        duration,
        difficulty,
        rating,
        baseRating: rating,
        baseDifficulty: difficulty,
        ratingsHistory: [],
        description: description || '',
        bggId: bggId || null,
        scoreDir: scoreDir,
        timesPlayed: 0,
        actualDurations: [],
        avgDuration: null,
        lastPlayed: null,
        addedBy: state.currentUser.name,
        addedAt: new Date().toISOString()
    };
    
    // Save and render
    saveState();
    renderCatalog();
    
    // Close modal
    document.querySelector('.modal.active').remove();
    
    addAuditLog('audit.gameAddedCatalog', state.currentUser.name, name);
    showNotification(t('m1.gameAddedCatalog').replace('{name}', name), 'success');
}

/* ===== IMPORT COLECȚIE BOARDGAMEGEEK ========================================
   RO: Rescris integral. Versiunea veche apela `boardgamegeek.com` DIRECT din
       browser: BGG cere acum token (`BGG_TOKEN`, trimis de Edge Function ca
       Bearer) și nu trimite headere CORS => cererea era respinsă de fiecare dată
       cu 401 + blocaj CORS, iar codul cădea în `catch` și afișa „blocat de
       browser". Importul NU a funcționat niciodată. În plus, chiar dacă ar fi
       trecut, scria doar în `state.catalog` + `saveState()` — care persistă
       LOCAL doar {settings, audit, lastSaved} — deci jocurile ar fi dispărut la
       primul refresh și n-ar fi ajuns niciodată la ceilalți membri.

       Acum: totul prin `bgg-proxy` (aceeași cale ca la căutarea din „Adaugă joc",
       care funcționează), scriere REALĂ în DB prin `import_games_bulk`, apoi
       rehidratare din DB — o singură sursă de adevăr pentru catalog.

       Patru faze, cu progres live și anulare:
         1. colecția  -> titluri + id-uri BGG            (1 cerere)
         2. detaliile -> greutate reală, categorii, etc. (pachete de 20)
         3. salvarea  -> import_games_bulk               (pachete de 25)
         4. rehidratarea din DB
   EN: full rewrite — the old version hit boardgamegeek.com directly (401 + CORS)
       and only ever wrote to in-memory state. Now proxied, persisted and rehydrated.
   ============================================================================ */

/* Steag de anulare, citit între pachete. NU întrerupem un pachet în curs: un
   `import_games_bulk` pe jumătate trimis ar fi oricum aplicat de server. */
let _bggImportAbort = false;
let _bggImportRunning = false;

function bggImportCancel() {
    _bggImportAbort = true;
    const p = document.getElementById('bggImpPhase');
    if (p) p.textContent = t('bggimp.cancelling');
    const b = document.getElementById('bggImpCancelBtn');
    if (b) b.disabled = true;
}
window.bggImportCancel = bggImportCancel;

function _bggImpClose() {
    const m = document.getElementById('bggImportModal');
    if (m) m.remove();
}

/* Fereastra de progres. Intenționat FĂRĂ buton „×": singura ieșire e „Anulează",
   care oprește curat între pachete. Un × ar fi lăsat importul să curgă mai departe
   în fundal, invizibil, în timp ce utilizatorul crede că l-a oprit. */
function _bggImpOpen() {
    _bggImpClose();
    const m = document.createElement('div');
    m.className = 'modal active';
    m.id = 'bggImportModal';
    m.innerHTML =
        '<div class="modal-content" style="max-width:520px;">' +
            '<div class="modal-header"><h2><i class="fas fa-cloud-download-alt"></i> ' +
                window.escHtml(t('bggimp.title')) + '</h2></div>' +
            '<p id="bggImpPhase" style="color:var(--text-secondary); margin-bottom:12px;"></p>' +
            '<div class="ach-progress"><div id="bggImpBar" style="width:0%; transition:width .2s ease;"></div></div>' +
            '<p id="bggImpCount" style="font-size:.85em; opacity:.75; margin-top:8px; min-height:1.2em;"></p>' +
            '<div class="btn-group" style="margin-top:16px;">' +
                '<button id="bggImpCancelBtn" class="btn btn-secondary" type="button" data-catalog-act="bgg-imp-cancel">' +
                    '<i class="fas fa-times"></i> ' + window.escHtml(t('bggimp.cancel')) + '</button>' +
            '</div>' +
        '</div>';
    document.body.appendChild(m);
}

function _bggImpSet(phase, done, total) {
    const p = document.getElementById('bggImpPhase');
    if (p && !_bggImportAbort && phase) p.textContent = phase;
    const pct = (total > 0) ? Math.max(0, Math.min(100, Math.round((done / total) * 100))) : 0;
    const bar = document.getElementById('bggImpBar');
    if (bar) bar.style.width = pct + '%';
    const c = document.getElementById('bggImpCount');
    if (c) c.textContent = (total > 0)
        ? t('bggimp.counter').replace('{done}', String(done)).replace('{total}', String(total))
        : '';
}

/* Edge Function-ul răspunde cu 4xx/5xx pentru cazuri utile (ex. username inexistent).
   supabase-js împachetează asta într-o eroare al cărei corp JSON e în `context`;
   fără despachetare am fi arătat „FunctionsHttpError" în loc de cauza reală. */
async function _bggErrText(err) {
    try {
        if (err && err.context && typeof err.context.json === 'function') {
            const j = await err.context.json();
            if (j && j.error) return String(j.error);
        }
    } catch (e) { /* corpul nu era JSON — cădem pe mesajul generic */ }
    return (err && err.message) ? String(err.message) : '';
}

/* 0 și valorile negative venite de la BGG înseamnă „necunoscut", nu „zero minute". */
function _bggPos(v) { return (typeof v === 'number' && isFinite(v) && v > 0) ? v : null; }

async function importBGGCollection() {
    if (_bggImportRunning) return;

    /* Gardă de demo ÎNAINTE de orice trafic — nici măcar spre BGG. */
    if (typeof isDemoMode === 'function' && isDemoMode()) {
        showNotification(t('sb.demoNoSaveChanges'), 'info');
        return;
    }
    if (typeof requireWritableClub === 'function' && !requireWritableClub()) return;
    /* Autorizarea REALĂ e în RPC (rang >= 3) + RLS. Verificarea de aici doar
       înlocuiește o eroare brută de bază de date cu un mesaj lizibil. */
    if (typeof can === 'function' && !can('catalog.import')) {
        showNotification(t('rbac.noPermission'), 'error');
        return;
    }
    if (typeof sb === 'undefined' || !sb || typeof currentClubId === 'undefined' || !currentClubId) {
        showNotification(t('bggimp.noClub'), 'error');
        return;
    }

    const username = await promptModal(t('catalog.bggUserPrompt'));
    if (!username || !username.trim()) return;
    const user = username.trim();

    _bggImportAbort = false;
    _bggImportRunning = true;
    _bggImpOpen();

    let inserted = 0, updated = 0, noWeight = 0, noDetails = 0;

    try {
        /* ---- FAZA 1: colecția ---------------------------------------------- */
        _bggImpSet(t('bggimp.phaseCollection'), 0, 0);
        const cr = await sb.functions.invoke('bgg-proxy', { body: { type: 'collection', username: user } });
        if (cr.error) {
            const msg = await _bggErrText(cr.error);
            if (/invalid username/i.test(msg)) { showNotification(t('bggimp.invalidUser'), 'error'); return; }
            throw new Error(msg || 'collection');
        }
        const items = ((cr.data && cr.data.items) || []).filter(it => it && it.id && it.name);
        if (!items.length) { showNotification(t('m1.collectionEmpty'), 'warning'); return; }

        /* ---- FAZA 2: detaliile, în pachete de 20 --------------------------- */
        /* 20, nu 1 per joc: proxy-ul limitează la 60 de cereri/minut per utilizator,
           iar o colecție de 78 de jocuri ar fi lovit pragul la jumătatea importului. */
        const detail = {};
        const ids = items.map(it => it.id);
        for (let i = 0; i < ids.length; i += 20) {
            if (_bggImportAbort) break;
            const chunk = ids.slice(i, i + 20);
            const dr = await sb.functions.invoke('bgg-proxy', { body: { type: 'things', ids: chunk } });
            if (dr.error) noDetails += chunk.length;
            else ((dr.data && dr.data.items) || []).forEach(d => { if (d && d.id) detail[d.id] = d; });
            _bggImpSet(t('bggimp.phaseDetails'), Math.min(i + chunk.length, ids.length), ids.length);
            if (i + 20 < ids.length) await new Promise(r => setTimeout(r, 350));
        }

        /* ---- FAZA 3: salvarea în DB --------------------------------------- */
        /* `complexity` vine din `weight` = `averageweight` de pe BGG. Dacă lipsește,
           trimitem null și NU inventăm 3 (vechiul comportament): RPC-ul păstrează
           atunci valoarea existentă, iar raportul final spune câte au rămas fără. */
        const rows = items.map(it => {
            const d = detail[it.id] || {};
            const cats = (d.categories && d.categories.length) ? d.categories.slice(0, 5).join(', ') : null;
            const w = _bggPos(d.weight);
            if (w == null) noWeight++;
            return {
                title: d.name || it.name,
                min_players: _bggPos(d.minPlayers) || _bggPos(it.minPlayers),
                max_players: _bggPos(d.maxPlayers) || _bggPos(it.maxPlayers),
                duration: _bggPos(d.playingTime) || _bggPos(it.playingTime),
                complexity: (w != null) ? Math.round(w * 100) / 100 : null,
                category: cats,
                description: d.description || null,
                image_url: d.image || d.thumbnail || null,
                bgg_id: String(it.id),
                base_rating: (_bggPos(d.rating) != null) ? Math.round(d.rating * 10) / 10 : null,
                min_age: _bggPos(d.minAge),
                designer: (d.designers && d.designers.length) ? d.designers.slice(0, 3).join(', ') : null,
                artist: (d.artists && d.artists.length) ? d.artists.slice(0, 3).join(', ') : null,
                publisher: (d.publishers && d.publishers.length) ? d.publishers.slice(0, 3).join(', ') : null
            };
        });

        _bggImpSet(t('bggimp.phaseSaving'), 0, rows.length);
        for (let i = 0; i < rows.length; i += 25) {
            if (_bggImportAbort) break;
            const batch = rows.slice(i, i + 25);
            const rg = await sb.rpc('import_games_bulk', { p_club_id: currentClubId, p_games: batch });
            if (rg.error) throw rg.error;
            inserted += (rg.data && rg.data.inserted) || 0;
            updated += (rg.data && rg.data.updated) || 0;
            _bggImpSet(null, Math.min(i + batch.length, rows.length), rows.length);
        }

        /* ---- FAZA 4: rehidratare din DB ----------------------------------- */
        /* Sursa de adevăr pentru catalog e baza de date, nu ce am construit local.
           `skipHeavy` sare peste meciuri/mesaje (istoricul din memorie e reconstituit
           în hidratare), deci `timesPlayed` și `avgDuration` rămân corecte. */
        if (inserted || updated) {
            _bggImpSet(t('bggimp.phaseRefresh'), 1, 1);
            if (typeof hydrateFromSupabase === 'function') await hydrateFromSupabase({ skipHeavy: true });
            if (typeof renderCatalog === 'function') renderCatalog();
        }

        /* Auditul se scrie DOAR dacă s-a schimbat ceva în baza de date. Vechea
           versiune îl scria mereu, inclusiv la importurile care eșuau complet. */
        if ((inserted || updated) && state.currentUser) {
            addAuditLog('audit.importBggCollection', state.currentUser.name,
                { key: 'auditd.gamesAddedByUser', params: { user: user, n: inserted + updated } });
        }

        let msg = (_bggImportAbort ? t('bggimp.doneCancelled') : t('bggimp.done'))
            .replace('{ins}', String(inserted)).replace('{upd}', String(updated));
        if (noWeight) msg += ' ' + t('bggimp.noWeight').replace('{n}', String(noWeight));
        if (noDetails) msg += ' ' + t('bggimp.failedDetails').replace('{n}', String(noDetails));
        showNotification(msg, (inserted || updated) ? 'success' : 'info');
    } catch (err) {
        console.error('BGG import:', err);
        showNotification(t('bggimp.error').replace('{msg}', (err && err.message) || ''), 'error');
    } finally {
        _bggImportRunning = false;
        _bggImpClose();
    }
}

function exportCatalogJSON() {
    const data = {
        catalog: state.catalog,
        exportedAt: new Date().toISOString(),
        totalGames: Object.keys(state.catalog).length
    };
    
    const dataStr = JSON.stringify(data, null, 2);
    const blob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `turnorder-catalog-${new Date().toISOString().split('T')[0]}.json`;
    link.click();
    URL.revokeObjectURL(url);
    
    addAuditLog('audit.exportCatalogJson', state.currentUser.name);
    showNotification(t('m1.catalogExported'), 'success');
}

function gameScoreNoteText(game, kind) {
    if (!game) return '';
    var base = kind === 'r' ? game.baseRating : game.baseDifficulty;
    var hasBase = (typeof base === 'number' && base > 0);
    var votes = (typeof _gameVoteList === 'function') ? _gameVoteList(game, kind) : [];
    var n = votes ? votes.length : 0;
    var bggVal = hasBase ? (kind === 'r' ? base.toFixed(1) : base.toFixed(2)) : '';
    var s = '';
    if (hasBase && n > 0) s = t('catalog.scoreBlendBoth');
    else if (hasBase) s = t('catalog.scoreBggOnly');
    else if (n > 0) s = t('catalog.scoreClubOnly');
    else return '';
    return s.replace('{bgg}', bggVal).replace('{n}', String(n));
}
function gameScoreNote(game, kind, gameName) {
    var txt = gameScoreNoteText(game, kind);
    if (!txt) return '';
    var titleSafe = String(txt).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    /* v9 8.16-4e: fără onclick — folosită doar în fișa jocului (showGameDetails), unde delegarea `data-gd-act`
       cheamă showGameScoreInfo; titlul jocului e dată (escHtml), nu cod. EN: delegated, no inline handler. */
    return ' <i class="fas fa-circle-info gscore-info" title="' + titleSafe + '" data-gd-act="score" data-game="' + window.escHtml(gameName || '') + '" data-kind="' + (kind === 'r' ? 'r' : 'w') + '"></i>';
}
function showGameScoreInfo(gameName, kind) {
    var g = state.catalog[gameName]; if (!g) return;
    var txt = gameScoreNoteText(g, kind); if (!txt) return;
    var label = kind === 'r' ? t('catalog.rating') : t('catalog.weight');
    showNotification(label + ': ' + txt, 'info');
}
function toggleGameDesc(btn) {
    var wrap = btn.closest('.gdesc-wrap'); if (!wrap) return;
    var p = wrap.querySelector('.gdesc-body'); if (!p) return;
    var clamped = p.classList.toggle('gdesc-clamp');
    btn.textContent = clamped ? t('common.readMore') : t('common.readLess');
}
window.gameScoreNoteText = gameScoreNoteText;
window.gameScoreNote = gameScoreNote;
window.showGameScoreInfo = showGameScoreInfo;
window.toggleGameDesc = toggleGameDesc;

function showGameDetails(gameName) {
    const game = state.catalog[gameName];
    if (!game) return;
    const _gdRating = gameRatingAvg(game) != null ? gameRatingAvg(game).toFixed(1) : 'N/A';
    /* Curăță orice modal de joc rămas în DOM (unele căi de închidere doar ascund cu CSS,
       nu elimină nodul -> id-uri duplicate). */
    document.querySelectorAll('.game-details-modal').forEach(function (m) { m.remove(); });

    /* ⚠ Delegare și aici: adresa copertei stă într-un atribut `data-`, nu într-un
       `onclick`. Ascultătorul e legat de fereastră, deci dispare odată cu ea.
       ★ v9 8.16-4e (1 nov. 2026): și butoanele ferestrei (✕, „Citește tot", Evaluează, Editează,
       Închide, ⓘ de la scoruri, „Cine îl are": numele și „Îl am") trec prin el (`data-gd-act`), fără `onclick`: titlul jocului călătorea în cod
       (`attrJs`), acum e dată (`data-game`, escHtml). Fereastra se deschide acum și din chat
       (cardul „Ce jucăm"). Acțiunea se tratează ÎNAINTEA copertei ⇒ ✕ de pe copertă nu mai
       deschide imaginea mare (rolul vechiului `event.stopPropagation()`). EN: no inline handlers. */
    const _bindFullImage = function (root) {
        root.addEventListener('click', function (ev) {
            const act = ev.target.closest ? ev.target.closest('[data-gd-act]') : null;
            if (act && root.contains(act)) {
                const a = act.getAttribute('data-gd-act'), g = act.getAttribute('data-game') || '';
                if (a === 'close') root.remove();
                else if (a === 'desc' && typeof toggleGameDesc === 'function') toggleGameDesc(act);
                else if (a === 'rate' && typeof rateGame === 'function') rateGame(g);
                else if (a === 'edit') { root.remove(); if (typeof openAddGameModal === 'function') openAddGameModal(g); }
                else if (a === 'score' && typeof showGameScoreInfo === 'function') showGameScoreInfo(g, act.getAttribute('data-kind') === 'r' ? 'r' : 'w');
                else if (a === 'owner' && typeof openLeaderboardProfile === 'function') openLeaderboardProfile(act.getAttribute('data-uid') || '');
                else if (a === 'own' && typeof toggleGameOwn === 'function') toggleGameOwn(act);
                return;
            }
            const el = ev.target.closest ? ev.target.closest('[data-gd-full]') : null;
            if (!el || !root.contains(el)) return;
            const src = el.getAttribute('data-gd-full');
            if (!src || typeof openLightbox !== 'function') return;
            /* v9 8.5-D2 (ideea lui Alex): imaginea mare apare IMEDIAT în varianta de 1000 px
               (deja descărcată pentru banner), iar originalul o înlocuiește când a venit, ca
               la galeria pozelor (8.5-B2); mărirea începută rămâne (lightbox-zoom.js). Dacă
               originalul nu vine, rămâne varianta de 1000 px. Fără variantă ⇒ ca înainte. */
            const ph = window.TO_COVER ? window.TO_COVER.pick(src, 'wide') : src;
            if (ph === src) { openLightbox(src, null, null); return; }
            openLightbox(ph, null, null);
            const im = document.getElementById('lightboxImg');
            if (!im) return;
            const big = new Image();
            im._toBig = big;   /* ținută de element, ca descărcarea să nu fie abandonată */
            big.onload = function () { if (im.isConnected && im.src !== src) im.src = src; };
            big.src = src;
        });
    };

    const modal = document.createElement('div');
    modal.className = 'modal active game-details-modal';
    modal.dataset.back = '1';   /* „înapoi" de pe telefon o închide (chat-core.js, v9 zona 2) */
    modal.innerHTML = `
        <div class="modal-content" style="max-width: 700px;">
            ${game.imageUrl ? `
            <div class="gdetail-banner" style="background-image:url('${gameImgCss(game.imageUrl, 'wide')}'); cursor:zoom-in;" data-gd-full="${window.escHtml(game.imageUrl)}" title="${t('catalog.viewFullImage')}">
                <button class="modal-close gdetail-close" data-gd-act="close" aria-label="${t('common.close')}">×</button>
                <div class="gdetail-banner-overlay">
                    <div class="gdetail-banner-title">${window.escHtml(gameName)}</div>
                    <div class="gdetail-banner-rating"><i class="fas fa-star"></i> ${_gdRating}/10</div>
                </div>
            </div>
            ` : `
            <div class="modal-header">
                <h2>${window.escHtml(gameName)}</h2>
                <button class="modal-close" data-gd-act="close" aria-label="${t('common.close')}">×</button>
            </div>
            `}
            
            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(min(100%, 240px), 1fr)); gap: 20px; margin: 20px 0;">
                <div>
                    <h3><i class="fas fa-info-circle"></i> ${t('catalog.info')}</h3>
                    <div class="catalog-details">
                        <div class="catalog-detail">
                            <i class="fas fa-users"></i> <strong>${t('catalog.playersColon')}:</strong> ${game.players || 'N/A'}
                        </div>
                        <div class="catalog-detail">
                            <i class="fas fa-clock"></i> <strong>${t('catalog.durationLabel')}:</strong> ${game.duration || 'N/A'} min
                            ${gameRealMin(game) != null ? `(${t('catalog.realAvg')}: ${gameRealMin(game)} min)` : ''}
                        </div>
                        <div class="catalog-detail">
                            <i class="fas fa-chart-line"></i> <strong>${t('catalog.weight')}:</strong> ${gameWeightAvg(game) != null ? gameWeightAvg(game).toFixed(2) : 'N/A'} / 5${gameScoreNote(game, 'w', gameName)}
                        </div>
                        <div class="catalog-detail">
                            <i class="fas fa-star"></i> <strong>${t('catalog.rating')}:</strong> ${gameRatingAvg(game) != null ? gameRatingAvg(game).toFixed(1) : 'N/A'}/10${gameScoreNote(game, 'r', gameName)}
                        </div>
                        <div class="catalog-detail">
                            <i class="fas fa-gamepad"></i> <strong>${t('catalog.playsLabel')}:</strong> ${game.timesPlayed || 0}
                        </div>
                        <div class="catalog-detail">
                            <i class="fas fa-calendar"></i> <strong>${t('catalog.lastPlayedLabel')}:</strong> 
                            ${game.lastPlayed ? new Date(game.lastPlayed).toLocaleDateString('en-GB') : t('common.never')}
                        </div>
                    </div>
                </div>
                
                <div>
                    <h3><i class="fas fa-tags"></i> ${t('catalog.categories')}</h3>
                    <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px;">
                        ${game.categories?.map(cat => `
                            <span class="badge badge-primary">${window.escHtml(cat)}</span>
                        `).join('') || '<em>' + t('catalog.noCategories') + '</em>'}
                    </div>
                    
                    <h3 style="margin-top: 30px;"><i class="fas fa-history"></i> ${t('catalog.statistics')}</h3>
                    <div class="catalog-details" style="margin-top: 10px;">
                        <div class="catalog-detail">
                            <i class="fas fa-chart-bar"></i> <strong>${t('catalog.avgDurationLabel')}:</strong> ${game.avgDuration || game.duration || 'N/A'} min
                        </div>
                        <div class="catalog-detail">
                            <i class="fas fa-trophy"></i> <strong>${t('catalog.favoriteFor')}:</strong> 
                            ${getPlayersWhoLoveGame(gameName).length > 0 ? 
                                getPlayersWhoLoveGame(gameName).map(window.escHtml).join(', ') : t('catalog.nobody')}
                        </div>
                    </div>
                </div>
            </div>
            
            ${(game.minAge || game.designer || game.artist || game.publisher || game.edition) ? `
            <div class="gcredits">
                ${game.edition ? `<div class="gcredit"><i class="fas fa-layer-group"></i> <strong>${t('catalog.edition')}:</strong> <span>${window.escHtml(game.edition)}</span></div>` : ''}
                ${game.minAge ? `<div class="gcredit"><i class="fas fa-child"></i> <strong>${t('catalog.age')}:</strong> <span>${window.escHtml(String(game.minAge))}+</span></div>` : ''}
                ${game.designer ? `<div class="gcredit"><i class="fas fa-pen-nib"></i> <strong>${t('catalog.designer')}:</strong> <span>${window.escHtml(game.designer)}</span></div>` : ''}
                ${game.artist ? `<div class="gcredit"><i class="fas fa-paint-brush"></i> <strong>${t('catalog.artist')}:</strong> <span>${window.escHtml(game.artist)}</span></div>` : ''}
                ${game.publisher ? `<div class="gcredit"><i class="fas fa-building"></i> <strong>${t('catalog.publisher')}:</strong> <span>${window.escHtml(game.publisher)}</span></div>` : ''}
            </div>` : ''}

            ${game.description ? `
                <h3><i class="fas fa-align-left"></i> ${t('common.description')}</h3>
                <div class="gdesc-wrap">
                    <p class="gdesc-body${game.description.length > 320 ? ' gdesc-clamp' : ''}">${window.escHtml(game.description)}</p>
                    ${game.description.length > 320 ? `<button type="button" class="gdesc-toggle" data-gd-act="desc">${t('common.readMore')}</button>` : ''}
                </div>
            ` : ''}
            
            ${game.bggId ? `
                <div style="margin-top: 20px; padding: 15px; background: var(--bg-secondary); border-radius: 10px;">
                    <i class="fas fa-external-link-alt"></i> 
                    <strong>BoardGameGeek ID:</strong> ${window.escHtml(game.bggId)}
                    <a href="https://boardgamegeek.com/boardgame/${encodeURIComponent(game.bggId)}" 
                       target="_blank" 
                       style="color: var(--accent-primary); margin-left: 10px;">
                        ${t('catalog.viewBgg')}
                    </a>
                </div>
            ` : ''}
            
            <div id="gameOwnersSection" class="game-owners-section" data-gameid="${window.escHtml(String(game.dbId || ''))}" data-gamename="${window.escHtml(gameName)}" data-addedby="${window.escHtml(game.owner || game.addedBy || '')}"></div>

            <div class="btn-group" style="margin-top: 30px;">
                <button class="btn btn-secondary" data-gd-act="rate" data-game="${window.escHtml(gameName)}">
                    <i class="fas fa-star"></i> ${t('catalog.rate')}
                </button>
                ${((typeof can === 'function') ? can('catalog.manage') : !!isAdmin) ? `
                <button class="btn btn-secondary" data-gd-act="edit" data-game="${window.escHtml(gameName)}">
                    <i class="fas fa-pen"></i> ${t('catalog.edit')}
                </button>
                ` : ''}
                <button class="btn btn-secondary" data-gd-act="close">
                    <i class="fas fa-times"></i> ${t('common.close')}
                </button>
            </div>
        </div>
    `;
    
    _bindFullImage(modal);
    document.body.appendChild(modal);
    try { if (typeof renderGameOwners === 'function') renderGameOwners(modal.querySelector('#gameOwnersSection')); } catch (e) { logError('showGameDetails', e); }
}

function getPlayersWhoLoveGame(gameName) {
    return Object.entries(state.members)
        .filter(([_, member]) => member.preferredGames?.includes(gameName))
        .map(([name]) => name);
}

let _rateGameName = null;
let _rateWeight = 3;

function rateGame(gameName) {
    const game = state.catalog[gameName];
    if (!game) return;
    /* Ratingul e deschis ORICĂRUI membru (game.rate = rang 1). Scrierea se face
       prin RPC-ul `game_rate`, care persistă DOAR votul propriu. */
    if (typeof requireWritableClub === 'function' && !requireWritableClub()) return;
    if (typeof can === 'function' && !can('game.rate')) { showNotification(t('rbac.noPermission'), 'error'); return; }
    _rateGameName = gameName;
    const voterKey = (state.currentUser && (state.currentUser.id || state.currentUser.name)) || 'anon';
    const myVote = (game.ratingVotes && game.ratingVotes[voterKey]) || null;
    let curR = myVote ? myVote.r : (Math.round((gameRatingAvg(game) || game.baseRating || 7) * 2) / 2);
    if (curR < 1) curR = 1; if (curR > 10) curR = 10;
    _rateWeight = myVote ? myVote.w : Math.round(gameWeightAvg(game) || game.baseDifficulty || 3);
    if (_rateWeight < 1) _rateWeight = 1; if (_rateWeight > 5) _rateWeight = 5;

    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.dataset.back = '1';   /* „înapoi" de pe telefon o închide (chat-core.js, v9 zona 2) */
    modal.id = 'rateModal';
    modal.innerHTML = `
        <div class="modal-content" style="max-width:460px;">
            <div class="modal-header">
                <h2><i class="fas fa-star" style="color:var(--accent-gold);"></i> ${t('catalog.rate')} — ${window.escHtml(gameName)}</h2>
                <button class="modal-close" data-catalog-act="close" aria-label="${t('common.close')}">×</button>
            </div>
            ${myVote ? `<p style="color:var(--text-secondary); font-size:.85em; margin-bottom:14px;">${t('rate.yourPrev')} ⭐ ${myVote.r}/10 · ${t('catalog.weight')} ${myVote.w}/5</p>` : ''}

            <div class="rate-section">
                <label for="rateRatingInput" class="rate-label">${t('rate.ratingLabel')}</label>
                <div class="rate-value"><i class="fas fa-star"></i> <span id="rateValDisplay">${curR}</span><span style="opacity:.5; font-size:.6em;">/10</span></div>
                <input type="range" id="rateRatingInput" class="rate-slider" min="1" max="10" step="0.5" value="${curR}" data-catalog-field="rate-range">
                <div class="rate-scale"><span>1</span><span>5</span><span>10</span></div>
            </div>

            <div class="rate-section">
                <span class="rate-label">${t('rate.weightLabel')}</span>
                <div class="rate-weights" id="rateWeights">
                    ${[1, 2, 3, 4, 5].map(w => `<button type="button" class="rate-weight-chip${w === _rateWeight ? ' active' : ''}" data-catalog-act="rate-weight" data-w="${w}">${w}</button>`).join('')}
                </div>
                <div class="rate-scale"><span>${t('game.diff1')}</span><span>${t('game.diff5')}</span></div>
            </div>

            <div class="btn-group" style="margin-top:18px;">
                <button class="btn btn-success" data-catalog-act="rate-submit"><i class="fas fa-check"></i> ${t('rate.save')}</button>
                <button class="btn btn-secondary" data-catalog-act="close">${t('common.cancel')}</button>
            </div>
        </div>`;
    document.body.appendChild(modal);
}
window.rateGame = rateGame;

function setRateWeight(w) {
    _rateWeight = w;
    const box = document.getElementById('rateWeights');
    if (box) Array.from(box.children).forEach((b, i) => b.classList.toggle('active', (i + 1) === w));
}
window.setRateWeight = setRateWeight;

function submitRating() {
    const gameName = _rateGameName;
    const game = state.catalog[gameName];
    if (!game) return;
    const input = document.getElementById('rateRatingInput');
    const ratingNum = parseFloat(input ? input.value : NaN);
    const difficultyNum = _rateWeight;
    if (isNaN(ratingNum) || ratingNum < 1 || ratingNum > 10) { showNotification(t('m1.invalidRating'), 'error'); return; }
    if (isNaN(difficultyNum) || difficultyNum < 1 || difficultyNum > 5) { showNotification(t('m1.invalidWeight'), 'error'); return; }

    // Adoptă scorul existent ca bază dacă lipsește (retrocompatibilitate)
    if (typeof game.baseRating !== 'number' && typeof game.rating === 'number' && game.rating > 0) game.baseRating = game.rating;
    if (typeof game.baseDifficulty !== 'number' && typeof game.difficulty === 'number' && game.difficulty > 0) game.baseDifficulty = game.difficulty;

    // Un singur vot per jucător (se suprascrie la re-evaluare)
    if (!game.ratingVotes || typeof game.ratingVotes !== 'object') game.ratingVotes = {};
    var voterKey = (state.currentUser && (state.currentUser.id || state.currentUser.name)) || 'anon';
    game.ratingVotes[voterKey] = { r: ratingNum, w: difficultyNum };

    // Recalculează mediile
    const ra = gameRatingAvg(game); if (ra != null) game.rating = Math.round(ra * 10) / 10;
    const wa = gameWeightAvg(game); if (wa != null) game.difficulty = Math.round(wa * 100) / 100;

    if (typeof window.persistGameRating === 'function') window.persistGameRating(gameName);
    saveState();
    renderCatalog();
    const m = document.getElementById('rateModal'); if (m) m.remove();
    showNotification(t('rate.saved'), 'success');
}
window.submitRating = submitRating;

async function deleteGameFromCatalog(gameName) {
    if (!isAdmin) {
        showNotification(t('m1.onlyAdminDeleteGames'), 'error');
        return;
    }
    
    if (!await confirmModal(t('m1.confirmDeleteGame').replace('{game}', gameName), { danger: true })) {
        return;
    }
    
    const game = state.catalog[gameName];
    
    // Remove from catalog
    delete state.catalog[gameName];
    
    // Remove from player preferences
    Object.values(state.members).forEach(member => {
        if (member.preferredGames) {
            member.preferredGames = member.preferredGames.filter(g => g !== gameName);
        }
    });
    
    // Add audit log
    addAuditLog('audit.gameDeletedCatalog', state.currentUser.name, 
        `${gameName} (${game.timesPlayed || 0} jocuri, rating ${game.rating || 'N/A'})`);
    
    // Save and render
    saveState();
    renderCatalog();
    
    showNotification(t('m1.gameDeleted').replace('{name}', gameName), 'success');
}

function bulkDeleteGamesModal() {
    /* Ascunderea butonului nu e securitate — funcția rămâne apelabilă din consolă.
       Garda reală de scriere e RLS-ul de pe `games`; asta doar oprește devreme. */
    if (typeof can === 'function' ? !can('catalog.delete') : !isAdmin) {
        showNotification(t('m1.onlyAdminBulkDelete'), 'error');
        return;
    }

    const names = Object.keys(state.catalog);
    if (names.length === 0) {
        showNotification(t('m1.catalogEmpty'), 'warning');
        return;
    }

    const esc = s => String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');
    const modal = document.createElement('div');
    modal.className = 'modal active';
    modal.dataset.back = '1';   /* „înapoi" de pe telefon o închide (chat-core.js, v9 zona 2) */
    modal.id = 'bulkGamesModal';
    modal.innerHTML = `
        <div class="modal-content" style="max-width:560px;">
            <div class="modal-header">
                <h2><i class="fas fa-trash"></i> ${t('bulk.gamesTitle')}</h2>
                <button class="modal-close" data-catalog-act="close" aria-label="${t('common.close')}">×</button>
            </div>
            <p style="color:var(--danger); margin-bottom:12px;">
                <i class="fas fa-exclamation-triangle"></i> ${t('bulk.warningGames')}
            </p>
            <p style="color:var(--text-secondary); font-size:.86em; margin-bottom:12px;">
                <i class="fas fa-circle-info"></i> ${t('bulk.gamesLinksNote')}
            </p>
            <label style="display:block; margin-bottom:10px;">
                <input type="checkbox" data-catalog-field="bulk-all"> <b>${t('common.selectAll')}</b>
            </label>
            <div style="max-height:50vh; overflow-y:auto; display:flex; flex-direction:column; gap:6px; margin-bottom:16px;">
                ${names.map(n => `
                    <label style="display:flex; align-items:center; gap:10px; padding:8px; background:var(--bg-secondary); border-radius:6px;">
                        <input type="checkbox" class="bulk-game-cb" value="${esc(n)}">
                        <span>${esc(n)}</span>
                        <small style="margin-left:auto; color:var(--text-secondary);">${state.catalog[n].timesPlayed||0} ${t('common.playsShort')}</small>
                    </label>`).join('')}
            </div>
            <div class="btn-group">
                <button class="btn btn-danger" id="bulkGamesRunBtn" data-catalog-act="bulk-run">
                    <i class="fas fa-trash"></i> ${t('common.deleteSelected')}
                </button>
                <button class="btn btn-secondary" data-catalog-act="close">
                    <i class="fas fa-times"></i> ${t('common.cancel')}
                </button>
            </div>
        </div>`;
    document.body.appendChild(modal);
}

async function processBulkDeleteGames() {
    const selected = Array.from(document.querySelectorAll('.bulk-game-cb:checked')).map(c => c.value);
    if (selected.length === 0) {
        showNotification(t('m1.noGameSelected'), 'warning');
        return;
    }

    /* RO: Gărzile se re-verifică AICI, nu doar la deschiderea modalului: între
           deschidere și apăsare se poate schimba clubul activ sau rolul. */
    if (typeof isDemoMode === 'function' && isDemoMode()) {
        showNotification(t('sb.demoNoSaveChanges'), 'info');
        return;
    }
    if (typeof requireWritableClub === 'function' && !requireWritableClub()) return;
    if (typeof can === 'function' ? !can('catalog.delete') : !isAdmin) {
        showNotification(t('m1.onlyAdminBulkDelete'), 'error');
        return;
    }

    if (!await confirmModal(t('m1.confirmBulkDeleteGames').replace('{n}', selected.length), { danger: true })) return;

    const runBtn = document.getElementById('bulkGamesRunBtn');
    if (runBtn) {
        runBtn.disabled = true;
        runBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> ' + window.escHtml(t('bulk.gamesDeleting'));
    }

    /* RO: Separăm după REPREZENTARE, nu după nume: jocurile cu `dbId` trăiesc în
           baza de date (sursa de adevăr) și trebuie șterse acolo; cele fără `dbId`
           există doar în memorie (rânduri locale) și se curăță direct.
       EN: split by representation — rows with a `dbId` must be deleted server-side. */
    const withId = [];
    const localOnly = [];
    selected.forEach(n => {
        const g = state.catalog[n];
        if (!g) return;
        if (g.dbId) withId.push({ name: n, id: g.dbId });
        else localOnly.push(n);
    });

    const deletedNames = [];
    let failed = 0;
    let lastErr = '';

    try {
        /* RO: Ștergere pe ID, în pachete de 50. `.select('id')` întoarce EXACT
               rândurile șterse: dacă RLS respinge tăcut o parte (rang insuficient,
               alt club), aflăm din răspuns în loc să presupunem că s-a șters tot ce
               am cerut. Curățăm local DOAR ce a confirmat serverul — altfel jocul
               dispărea din interfață și reapărea la următoarea hidratare.
               Exact acesta era defectul: versiunea veche făcea `delete state.catalog[n]`
               și `saveState()`, care NU persistă catalogul. Nimic nu ajungea în DB.
           EN: id-based batched delete; local cleanup only for server-confirmed rows. */
        for (let i = 0; i < withId.length; i += 50) {
            const chunk = withId.slice(i, i + 50);
            const res = await sb.from('games').delete().in('id', chunk.map(x => x.id)).select('id');
            if (res.error) {
                failed += chunk.length;
                lastErr = res.error.message || '';
                logError('processBulkDeleteGames', res.error);
                continue;
            }
            const okIds = new Set((res.data || []).map(r => String(r.id)));
            chunk.forEach(x => {
                if (okIds.has(String(x.id))) deletedNames.push(x.name);
                else failed++;
            });
        }
    } finally {
        if (runBtn) {
            runBtn.disabled = false;
            runBtn.innerHTML = '<i class="fas fa-trash"></i> ' + window.escHtml(t('common.deleteSelected'));
        }
    }

    const removed = new Set(deletedNames.concat(localOnly));

    removed.forEach(name => { delete state.catalog[name]; });
    /* Aceeași curățare ca la ștergerea unui singur joc (`deleteGameFromCatalog`):
       altfel rămân preferințe care indică spre jocuri inexistente. */
    Object.values(state.members || {}).forEach(m => {
        if (Array.isArray(m.preferredGames)) m.preferredGames = m.preferredGames.filter(g => !removed.has(g));
    });

    saveState();

    const modal = document.getElementById('bulkGamesModal');
    if (modal) modal.remove();

    /* Rehidratare din DB: catalogul are o singură sursă de adevăr. Confirmă și că
       ce credem că am șters chiar nu mai există. `skipHeavy` sare peste meciuri și
       mesaje — istoricul din memorie e reconstituit în hidratare. */
    if (removed.size && typeof hydrateFromSupabase === 'function') {
        await hydrateFromSupabase({ skipHeavy: true });
    }
    renderCatalog();
    if (typeof updateTabBadges === 'function') updateTabBadges();

    /* Auditul se scrie DOAR pentru ce s-a șters efectiv, cu numărul real. */
    if (removed.size && state.currentUser) {
        addAuditLog('audit.bulkDeleteGames', state.currentUser.name, { key: 'auditd.gamesCount', params: { n: removed.size } });
    }

    if (failed) {
        showNotification(
            t('bulk.gamesDeletePartial').replace('{ok}', String(removed.size)).replace('{fail}', String(failed)) +
            (lastErr ? ' ' + lastErr : ''), 'warning');
    } else {
        showNotification(t('m1.bulkGamesDeleted').replace('{n}', String(removed.size)), 'success');
    }
}

/* ═══════════════════════════════════════════════════════════════════════════
   CALCULATOR DE SCOR (inspirat din BG Stats: „calculate on the fly with + −").
   Se deschide din orice câmp de scor, permițând compunerea scorului din
   sub-scoruri (ex. 12+7+3+5) direct în aplicație, fără calculator extern.
   Arhitectură: scripturi clasice, global scope, ZERO import/export (§3).
   - Câmpurile de scor sunt marcate automat (data-calc + inputmode="none" ca să
     NU apară tastatura nativă pe mobil) prin `upgradeScoreFields`, apelat de un
     MutationObserver global => prinde orice foaie/modal viitor fără cod în plus.
   - Evaluare SIGURĂ (fără eval): tokenizer + shunting-yard + RPN. Acceptă doar
     numere zecimale/negative și + − × ÷ cu paranteze.
   RO+EN: singurele texte vizibile sunt titlul și hint-ul (tastele = simboluri).
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
    'use strict';
    var SEL = '.session-player-score, [class*="ss-cat-"], input[id^="edit-score-"], #coopScore, #editCoopScore';
    /* Dispozitiv touch (telefon/tabletă): acolo tastatura nativă e problema.
       Pe touch facem câmpurile readonly ca tastatura să NU apară NICIODATĂ (cel mai
       fiabil pe toate browserele mobile); pe desktop rămân editabile (tastatura fizică). */
    var IS_TOUCH = false;
    try { IS_TOUCH = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0); } catch (e) {}
    /* TELEFON REAL (nu doar „are touch"): pointer principal = deget (coarse) ȘI ecran
       îngust. Un laptop cu touchscreen are touchpad/mouse ca pointer principal (fine) +
       ecran lat -> NU e telefon -> primește modul desktop (popup flotant + tastare fizică).
       Se evaluează la fiecare deschidere (fereastra se poate redimensiona/roti). */
    function _isPhone() {
        try {
            return window.matchMedia('(pointer: coarse)').matches &&
                   window.matchMedia('(max-width: 820px)').matches;
        } catch (e) { return IS_TOUCH && window.innerWidth <= 820; }
    }

    function _isScoreField(el) {
        if (!el || !el.matches) return false;
        /* câmpurile deja pregătite (data-calc) sunt recunoscute chiar dacă le-am făcut
           readonly pe touch — altfel readonly-ul propriu le-ar exclude. */
        if (el.getAttribute && el.getAttribute('data-calc') === '1') return !el.disabled;
        return el.matches(SEL) && !el.readOnly && !el.disabled;
    }

    /* Marchează câmpurile ca „calculabile” + suprimă tastatura nativă. Pe touch =>
       readonly (garanție anti-tastatură); pe desktop => editabile + inputmode none. */
    function upgradeScoreFields(root) {
        try {
            var scope = root && root.querySelectorAll ? root : document;
            var list = scope.querySelectorAll(SEL);
            for (var i = 0; i < list.length; i++) {
                var el = list[i];
                if (el.readOnly || el.disabled) continue;       /* readonly din alt motiv (ex. Total) -> nu-l atingem */
                if (el.getAttribute('data-calc') === '1') continue;
                el.setAttribute('data-calc', '1');
                el.setAttribute('inputmode', 'none');
                el.setAttribute('autocomplete', 'off');
                if (IS_TOUCH) el.readOnly = true;               /* mobil: fără tastatură nativă, deloc */
            }
        } catch (e) { if (typeof logError === 'function') logError('upgradeScoreFields', e); }
    }
    window.upgradeScoreFields = upgradeScoreFields;

    /* ---- Evaluator sigur de expresii aritmetice (fără eval) ---- */
    function _tokenize(s) {
        var toks = [], i = 0, n = s.length, prev = null;
        while (i < n) {
            var c = s[i];
            if (c === ' ') { i++; continue; }
            if ('+-*/()'.indexOf(c) !== -1) {
                /* minus unar: la început sau după operator/paranteză deschisă */
                if (c === '-' && (prev === null || prev === 'op' || prev === '(')) {
                    var j = i + 1, num = '-';
                    while (j < n && (/[0-9.]/).test(s[j])) { num += s[j]; j++; }
                    if (num === '-') { toks.push({ t: 'op', v: '-' }); prev = 'op'; i++; continue; }
                    toks.push({ t: 'num', v: parseFloat(num) }); prev = 'num'; i = j; continue;
                }
                if (c === '(') { toks.push({ t: '(', v: c }); prev = '('; }
                else if (c === ')') { toks.push({ t: ')', v: c }); prev = ')'; }
                else { toks.push({ t: 'op', v: c }); prev = 'op'; }
                i++; continue;
            }
            if ((/[0-9.]/).test(c)) {
                var k = i, num2 = '';
                while (k < n && (/[0-9.]/).test(s[k])) { num2 += s[k]; k++; }
                toks.push({ t: 'num', v: parseFloat(num2) }); prev = 'num'; i = k; continue;
            }
            return null; /* caracter invalid */
        }
        return toks;
    }
    function _evalExpr(str) {
        if (!str || !str.trim()) return null;
        var toks = _tokenize(str.replace(/×/g, '*').replace(/÷/g, '/').replace(/−/g, '-'));
        if (!toks) return null;
        var prec = { '+': 1, '-': 1, '*': 2, '/': 2 }, out = [], ops = [];
        for (var i = 0; i < toks.length; i++) {
            var tk = toks[i];
            if (tk.t === 'num') out.push(tk.v);
            else if (tk.t === 'op') {
                while (ops.length && ops[ops.length - 1].t === 'op' && prec[ops[ops.length - 1].v] >= prec[tk.v]) out.push(ops.pop());
                ops.push(tk);
            } else if (tk.t === '(') ops.push(tk);
            else if (tk.t === ')') {
                while (ops.length && ops[ops.length - 1].t !== '(') out.push(ops.pop());
                if (!ops.length) return null; ops.pop();
            }
        }
        while (ops.length) { var o = ops.pop(); if (o.t === '(') return null; out.push(o); }
        var st = [];
        for (var q = 0; q < out.length; q++) {
            var e = out[q];
            if (typeof e === 'number') st.push(e);
            else {
                var b = st.pop(), a = st.pop();
                if (a == null || b == null) return null;
                if (e.v === '+') st.push(a + b);
                else if (e.v === '-') st.push(a - b);
                else if (e.v === '*') st.push(a * b);
                else if (e.v === '/') st.push(b === 0 ? NaN : a / b);
            }
        }
        if (st.length !== 1) return null;
        var r = st[0];
        return (typeof r === 'number' && isFinite(r)) ? r : null;
    }
    window._scoreCalcEval = _evalExpr;

    var _calcTarget = null;

    function closeScoreCalc() {
        var el = document.getElementById('scoreCalcPop');
        if (el && el._calcCleanup) { try { el._calcCleanup(); } catch (e) {} }
        var bd = document.getElementById('scoreCalcBackdrop'); if (bd) bd.remove();
        if (el) el.remove();
        _calcTarget = null;
    }
    window.closeScoreCalc = closeScoreCalc;

    function _tt2(k, fb) { try { var s = window.t ? window.t(k) : k; return (s && s !== k) ? s : fb; } catch (e) { return fb; } }

    function openScoreCalc(inputEl) {
        if (!inputEl) return;
        closeScoreCalc();
        _calcTarget = inputEl;
        var start = (inputEl.value != null ? String(inputEl.value) : '').trim();
        if (start === '0') start = '';

        var bd = document.createElement('div');
        bd.id = 'scoreCalcBackdrop'; bd.className = 'score-calc-backdrop';
        /* Anti-glitch: click-ul care face parte din GESTUL de deschidere (pointerdown
           pe câmp -> click) ar cădea pe backdrop-ul tocmai apărut sub deget și l-ar
           închide instant. Îl facem inert ~300ms, apoi devine „închide la tap în afară”. */
        bd.style.pointerEvents = 'none';
        bd.onclick = function () { _commitAndClose(); };
        document.body.appendChild(bd);
        setTimeout(function () { if (bd && bd.parentNode) bd.style.pointerEvents = 'auto'; }, 300);

        var pop = document.createElement('div');
        pop.id = 'scoreCalcPop'; pop.className = 'score-calc';
        var keys = [
            ['C', 'danger', 'clear'], ['(', 'op', 'ins'], [')', 'op', 'ins'], ['÷', 'op', 'ins'],
            ['7', '', 'ins'], ['8', '', 'ins'], ['9', '', 'ins'], ['×', 'op', 'ins'],
            ['4', '', 'ins'], ['5', '', 'ins'], ['6', '', 'ins'], ['−', 'op', 'ins'],
            ['1', '', 'ins'], ['2', '', 'ins'], ['3', '', 'ins'], ['+', 'op', 'ins'],
            ['0', '', 'ins'], ['.', '', 'ins'], ['⌫', 'danger', 'back'], ['=', 'op', 'eq']
        ];
        var grid = '';
        keys.forEach(function (k) {
            grid += '<button type="button" class="score-calc-key ' + k[1] + '" data-act="' + k[2] + '" data-k="' + k[0] + '">' + k[0] + '</button>';
        });
        pop.innerHTML =
            '<div class="score-calc-head" id="scoreCalcHead">' +
                '<span class="score-calc-title"><i class="fas fa-calculator"></i> ' + _tt2('calc.title', 'Calculator') + '</span>' +
                '<button type="button" class="score-calc-done" data-act="ok">' + _tt2('calc.done', 'Gata') + '</button>' +
                '<button type="button" class="score-calc-x" data-act="cancel" aria-label="' + _tt2('common.cancel', 'Anulează') + '"><i class="fas fa-times"></i></button>' +
            '</div>' +
            '<div class="score-calc-display" id="scoreCalcDisp">' + (window.escHtml ? window.escHtml(start) : start) + '</div>' +
            '<div class="score-calc-sub" id="scoreCalcSub"></div>' +
            '<div class="score-calc-grid">' + grid +
            '<button type="button" class="score-calc-key ok wide" data-act="ok">OK</button>' +
            '<button type="button" class="score-calc-key wide" data-act="cancel">' + _tt2('common.cancel', 'Anulează') + '</button>' +
            '</div>';
        document.body.appendChild(pop);

        if (_isPhone()) {
            /* TELEFON: tastatură nativă ancorată jos. (Desktop cu touchscreen NU intră
               aici -> primește popup flotant + tastare fizică, ca orice desktop.) */
            pop.classList.add('score-calc--sheet');
            try { setTimeout(function () { inputEl.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 60); } catch (e) {}
        } else {
            /* DESKTOP: popup flotant lângă câmp, mutabil de bara de titlu (ca înainte). */
            _positionCalc(pop, inputEl);
            _makeCalcDraggable(pop, document.getElementById('scoreCalcHead'));
        }

        _updateCalcPreview();
        pop.addEventListener('click', _onCalcKey);
    }
    window.openScoreCalc = openScoreCalc;

    /* RO: Marginea de siguranță a calculatorului de scor. Pe iPhone cu crestătură,
           8px de la marginea de sus însemna sub Dynamic Island, iar 8px de jos peste
           indicatorul de acasă. Citim inseturile reale din CSS; dacă browserul nu le
           cunoaște (desktop), `env()` cade pe 0 și rămâne comportamentul de până acum.
       EN: safe-area-aware margins for the score calculator popup. */
    var _MARGIN = 8;
    function _safeInset(nume) {
        try {
            var p = document.createElement('div');
            p.style.cssText = 'position:fixed;visibility:hidden;padding-' + nume + ':env(safe-area-inset-' + nume + ',0px)';
            document.body.appendChild(p);
            var v = parseFloat(getComputedStyle(p)['padding' + nume.charAt(0).toUpperCase() + nume.slice(1)]) || 0;
            p.remove();
            return v;
        } catch (e) { return 0; }
    }
    function _clamp(v, lo, hi) { return Math.max(lo, Math.min(v, hi)); }

    function _positionCalc(pop, inputEl) {
        try {
            var pr = pop.getBoundingClientRect();
            var popW = pr.width || pop.offsetWidth || 264;
            var popH = pr.height || pop.offsetHeight || 360;
            var vw = window.innerWidth, vh = window.innerHeight;
            var left, top;
            var r = inputEl && inputEl.getBoundingClientRect ? inputEl.getBoundingClientRect() : null;
            if (r) {
                left = r.left;
                if (r.bottom + 6 + popH <= vh - _MARGIN) top = r.bottom + 6;        /* sub câmp */
                else if (r.top - 6 - popH >= _MARGIN) top = r.top - 6 - popH;        /* deasupra */
                else top = vh - popH - _MARGIN;                                       /* prins jos */
            } else { left = (vw - popW) / 2; top = (vh - popH) / 2; }
            var _sT = _MARGIN + _safeInset('top'), _sB = _MARGIN + _safeInset('bottom');
            var _sL = _MARGIN + _safeInset('left'), _sR = _MARGIN + _safeInset('right');
            pop.style.left = _clamp(left, _sL, Math.max(_sL, vw - popW - _sR)) + 'px';
            pop.style.top = _clamp(top, _sT, Math.max(_sT, vh - popH - _sB)) + 'px';
        } catch (e) { pop.style.left = '12px'; pop.style.top = '80px'; }
    }

    function _makeCalcDraggable(pop, handle) {
        if (!pop || !handle) return;
        var dragging = false, offX = 0, offY = 0;
        function onDown(ev) {
            /* nu porni dragul de pe butonul de închidere */
            if (ev.target.closest('[data-act]') && ev.target.closest('.score-calc-x')) return;
            dragging = true;
            var p = _pt(ev), r = pop.getBoundingClientRect();
            offX = p.x - r.left; offY = p.y - r.top;
            try { handle.setPointerCapture && ev.pointerId != null && handle.setPointerCapture(ev.pointerId); } catch (e) {}
            ev.preventDefault();
        }
        function onMove(ev) {
            if (!dragging) return;
            var p = _pt(ev);
            var popW = pop.offsetWidth, popH = pop.offsetHeight;
            var left = _clamp(p.x - offX, _MARGIN, Math.max(_MARGIN, window.innerWidth - popW - _MARGIN));
            var top = _clamp(p.y - offY, _MARGIN, Math.max(_MARGIN, window.innerHeight - popH - _MARGIN));
            pop.style.left = left + 'px'; pop.style.top = top + 'px';
            ev.preventDefault();
        }
        function onUp() { dragging = false; }
        function _pt(ev) {
            if (ev.touches && ev.touches[0]) return { x: ev.touches[0].clientX, y: ev.touches[0].clientY };
            return { x: ev.clientX, y: ev.clientY };
        }
        if (window.PointerEvent) {
            handle.addEventListener('pointerdown', onDown);
            document.addEventListener('pointermove', onMove);
            document.addEventListener('pointerup', onUp);
            /* curăță listenerii globali la închidere */
            pop._calcCleanup = function () {
                document.removeEventListener('pointermove', onMove);
                document.removeEventListener('pointerup', onUp);
            };
        } else {
            handle.addEventListener('mousedown', onDown);
            document.addEventListener('mousemove', onMove);
            document.addEventListener('mouseup', onUp);
            handle.addEventListener('touchstart', onDown, { passive: false });
            document.addEventListener('touchmove', onMove, { passive: false });
            document.addEventListener('touchend', onUp);
            pop._calcCleanup = function () {
                document.removeEventListener('mousemove', onMove);
                document.removeEventListener('mouseup', onUp);
                document.removeEventListener('touchmove', onMove);
                document.removeEventListener('touchend', onUp);
            };
        }
    }

    function _disp() { return document.getElementById('scoreCalcDisp'); }
    function _updateCalcPreview() {
        var d = _disp(), sub = document.getElementById('scoreCalcSub');
        if (!d || !sub) return;
        var expr = d.textContent || '';
        if (!expr.trim()) { sub.textContent = ''; return; }
        var v = _evalExpr(expr);
        sub.textContent = (v == null) ? '—' : ('= ' + (Math.round(v * 1000) / 1000));
    }

    function _onCalcKey(ev) {
        var btn = ev.target.closest('[data-act]'); if (!btn) return;
        ev.preventDefault(); ev.stopPropagation();
        var act = btn.getAttribute('data-act'), d = _disp();
        if (!d) return;
        if (act === 'cancel') { closeScoreCalc(); return; }
        if (act === 'ok') { _commitAndClose(); return; }
        if (act === 'clear') { d.textContent = ''; _updateCalcPreview(); return; }
        if (act === 'back') { d.textContent = (d.textContent || '').slice(0, -1); _updateCalcPreview(); return; }
        if (act === 'eq') { var v = _evalExpr(d.textContent || ''); if (v != null) { d.textContent = String(Math.round(v * 1000) / 1000); _updateCalcPreview(); } return; }
        if (act === 'ins') { d.textContent = (d.textContent || '') + btn.getAttribute('data-k'); _updateCalcPreview(); return; }
    }

    function _commitAndClose() {
        var d = _disp();
        if (d && _calcTarget) {
            var expr = (d.textContent || '').trim();
            var v = expr ? _evalExpr(expr) : 0;
            if (v != null) {
                var out = Math.round(v * 1000) / 1000;
                _calcTarget.value = String(out);
                /* declanșează logica existentă (recalc total, onSessionScoreInput etc.) */
                try { _calcTarget.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
                try { _calcTarget.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
            }
        }
        closeScoreCalc();
    }

    /* Deschide calculatorul la focus/tap pe un câmp de scor (delegare globală). */
    function _onFocusIn(ev) {
        var el = ev.target;
        if (!_isScoreField(el)) return;
        if (el.getAttribute('data-calc') !== '1') upgradeScoreFields(el.parentNode || document);
        /* evită dublarea dacă e deja deschis pentru același câmp */
        if (_calcTarget === el && document.getElementById('scoreCalcPop')) return;
        openScoreCalc(el);
    }

    function _initScoreCalc() {
        upgradeScoreFields(document);
        /* Pe TOUCH: interceptăm atingerea ÎNAINTE de focus (preventDefault) ca să nu
           apară nici tastatura, nici bara de accesorii (iOS), și deschidem calculatorul.
           Pe desktop lăsăm focus-ul normal (tastatura fizică rămâne utilă). */
        document.addEventListener('pointerdown', function (ev) {
            if (ev.pointerType !== 'touch' && ev.pointerType !== 'pen') return;
            var el = ev.target && ev.target.closest ? ev.target.closest('[data-calc="1"]') : null;
            if (!el || !_isScoreField(el)) return;
            ev.preventDefault();   /* blochează focus-ul nativ -> fără tastatură */
            if (!(document.getElementById('scoreCalcPop') && _calcTarget === el)) openScoreCalc(el);
        }, true);
        document.addEventListener('focusin', _onFocusIn, true);
        /* click explicit (desktop + fallback touch fără PointerEvent) */
        document.addEventListener('click', function (ev) {
            var el = ev.target && ev.target.closest ? ev.target.closest('[data-calc="1"]') : ev.target;
            if (el && _isScoreField(el) && !document.getElementById('scoreCalcPop')) openScoreCalc(el);
        }, true);
        /* Tastare fizică (mai ales desktop): cât timp calculatorul e deschis, tastele
           merg direct în el — cifre, operatori, Enter (=OK), Backspace, Escape (=anulează).
           Pe mobil nu strică: se declanșează doar dacă chiar există o tastatură fizică. */
        document.addEventListener('keydown', function (ev) {
            var pop = document.getElementById('scoreCalcPop'); if (!pop) return;
            var k = ev.key;
            if (k === 'Escape') { ev.preventDefault(); closeScoreCalc(); return; }
            var d = _disp(); if (!d) return;
            if (k === 'Enter') { ev.preventDefault(); _commitAndClose(); return; }
            if (k === 'Backspace') { ev.preventDefault(); d.textContent = (d.textContent || '').slice(0, -1); _updateCalcPreview(); return; }
            if (k === '=') { ev.preventDefault(); var v = _evalExpr(d.textContent || ''); if (v != null) { d.textContent = String(Math.round(v * 1000) / 1000); _updateCalcPreview(); } return; }
            /* cifre + operatori (inclusiv variantele tipografice × ÷ −, normalizate la evaluare) */
            if (/^[0-9.()+\-*/×÷−]$/.test(k)) {
                ev.preventDefault();
                d.textContent = (d.textContent || '') + k;
                _updateCalcPreview();
            }
        });
        /* la redimensionare/rotire: reclampează calculatorul în ecran (fără să-l re-ancoreze,
           ca să nu-l „mute” de unde l-a pus userul). */
        window.addEventListener('resize', function () {
            var pop = document.getElementById('scoreCalcPop'); if (!pop) return;
            if (pop.classList.contains('score-calc--sheet')) return;   /* sheet-ul mobil e ancorat prin CSS */
            var popW = pop.offsetWidth, popH = pop.offsetHeight;
            var left = parseFloat(pop.style.left) || 0, top = parseFloat(pop.style.top) || 0;
            pop.style.left = _clamp(left, _MARGIN, Math.max(_MARGIN, window.innerWidth - popW - _MARGIN)) + 'px';
            pop.style.top = _clamp(top, _MARGIN + _safeInset('top'), Math.max(_MARGIN, window.innerHeight - popH - _MARGIN - _safeInset('bottom'))) + 'px';
        });
        /* auto-upgrade pentru orice foaie/modal nou (scalabil, fără cod în fiecare loc) */
        try {
            var mo = new MutationObserver(function (muts) {
                for (var i = 0; i < muts.length; i++) {
                    var added = muts[i].addedNodes;
                    for (var j = 0; j < added.length; j++) {
                        var node = added[j];
                        if (node.nodeType === 1) {
                            if (_isScoreField(node)) upgradeScoreFields(node.parentNode || document);
                            else if (node.querySelector && node.querySelector(SEL)) upgradeScoreFields(node);
                        }
                    }
                }
            });
            mo.observe(document.body, { childList: true, subtree: true });
        } catch (e) { if (typeof logError === 'function') logError('scoreCalcObserver', e); }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', _initScoreCalc);
    else _initScoreCalc();
})();
